/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Representation of date and time in "Y-m-d H:i:s" format */
  DateTime: { input: any; output: any; }
  /** Representation of date and time in same string format as PHP DateTime class. */
  DateTimeAsString: { input: any; output: any; }
  /** String or Array */
  StringOrArray: { input: any; output: any; }
};

export type Address = {
  /** ID pobočky */
  branchId?: Maybe<Scalars['String']['output']>;
  /** Město */
  city?: Maybe<Scalars['String']['output']>;
  /** Společnost */
  company?: Maybe<Company>;
  /** Název firmy */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Země */
  country?: Maybe<Scalars['String']['output']>;
  /** Cokoli... */
  customData?: Maybe<Scalars['String']['output']>;
  /** Zákazník */
  customer?: Maybe<Customer>;
  /** DIČ */
  dic?: Maybe<Scalars['String']['output']>;
  /** E-mail */
  email?: Maybe<Scalars['String']['output']>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Jméno */
  firstName?: Maybe<Scalars['String']['output']>;
  /** IČ */
  ic?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Fakturační */
  isBilling?: Maybe<Scalars['Boolean']['output']>;
  /** Uloženo */
  isStored?: Maybe<Scalars['Boolean']['output']>;
  /** Příjmení */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Poznámka */
  note?: Maybe<Scalars['String']['output']>;
  /** Telefon */
  phone?: Maybe<Scalars['String']['output']>;
  /** Kraj */
  state?: Maybe<Scalars['String']['output']>;
  /** Ulice */
  street?: Maybe<Scalars['String']['output']>;
  /** ID adresy Zasilkovna */
  zasilkovnaAddressId?: Maybe<Scalars['String']['output']>;
  /** PSČ */
  zip?: Maybe<Scalars['String']['output']>;
};

export type ApiError = {
  /** Kategorie odvozená z kódu: request | auth | not_found | validation | business | conflict | retry | outcome_unknown | external | internal | unknown */
  category?: Maybe<Scalars['String']['output']>;
  /** Stabilní kód chyby; UNCLASSIFIED = zatím bez kódu */
  code?: Maybe<Scalars['String']['output']>;
  /** Cesta ke vstupní hodnotě (např. ean, items[0].product); null u chyby bez pole */
  field?: Maybe<Scalars['String']['output']>;
  /** Přesně text errors[i] */
  message?: Maybe<Scalars['String']['output']>;
  /** Podrobnosti chyby; hodnoty jsou vždy řetězce */
  params?: Maybe<Array<Maybe<ApiErrorParam>>>;
  /** Text chyby bez předpony pole a příčiny v závorce */
  text?: Maybe<Scalars['String']['output']>;
};

export type ApiErrorParam = {
  /** Název parametru (camelCase) */
  name?: Maybe<Scalars['String']['output']>;
  /** Hodnota, vždy jako řetězec */
  value?: Maybe<Scalars['String']['output']>;
};

export type Bestsellers = {
  /** Částka */
  amount?: Maybe<Scalars['Int']['output']>;
  /** Produkt */
  product?: Maybe<Product>;
  /** Prodeje */
  sales?: Maybe<Array<Maybe<Price>>>;
};

export type Carrier = {
  /** Barva */
  color?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Pozice */
  position?: Maybe<Scalars['Int']['output']>;
  /** Required doručovací adresa */
  requiredShippingAddress?: Maybe<Scalars['Boolean']['output']>;
  /** Tarify */
  tariffs?: Maybe<Array<Maybe<CarrierTariff>>>;
};

export type CarrierTariff = {
  /** Dobírka */
  cod?: Maybe<Scalars['Boolean']['output']>;
  /** Konstanta */
  const?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Pozice */
  position?: Maybe<Scalars['Int']['output']>;
};

export type CarrierUsage = {
  /** Částka */
  amount?: Maybe<Scalars['Int']['output']>;
  /** Dopravce */
  carrier?: Maybe<Carrier>;
};

export type Category = {
  /** Potomci */
  children?: Maybe<Array<Maybe<Category>>>;
  /** Společnost */
  company?: Maybe<Company>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Má potomky */
  hasChildren?: Maybe<Scalars['Boolean']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Nadřazený */
  parent?: Maybe<Category>;
  /** Pozice */
  position?: Maybe<Scalars['Int']['output']>;
  /** Tagy */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Text */
  text?: Maybe<Scalars['String']['output']>;
  /** Cesta ve stromu */
  treePath?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type Cert = {
  /** Společnost */
  company?: Maybe<Company>;
  /** Datum expirace */
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Veřejný klíč */
  publicKey?: Maybe<Scalars['String']['output']>;
};

export type Checkout = {
  /** Částka */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Automatická expedice */
  autoDispatched?: Maybe<Scalars['Boolean']['output']>;
  /** Automatické balení */
  autoPacking?: Maybe<Scalars['Boolean']['output']>;
  /** Automatické vychystání */
  autoPicking?: Maybe<Scalars['Boolean']['output']>;
  /** Velikost písma dokladu */
  billFontSize?: Maybe<Scalars['Int']['output']>;
  /** Tloušťka písma dokladu */
  billFontWeight?: Maybe<Scalars['String']['output']>;
  /** Patička dokladu */
  billFooter?: Maybe<Scalars['String']['output']>;
  /** Šířka dokladu */
  billWidth?: Maybe<Scalars['Int']['output']>;
  /** Společnost */
  company?: Maybe<Company>;
  /** Vytvoření */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** Aktuální uzávěrka */
  currentClosing?: Maybe<CheckoutClosing>;
  /** Lze smazat */
  deletable?: Maybe<Scalars['Boolean']['output']>;
  /** Sklady */
  depots?: Maybe<Array<Maybe<Depot>>>;
  /** EET povoleno */
  eetEnable?: Maybe<Scalars['Boolean']['output']>;
  /** EET ID */
  eetId?: Maybe<Scalars['Int']['output']>;
  /** EET testovací režim */
  eetPlayground?: Maybe<Scalars['Boolean']['output']>;
  /** EET ověřovací režim */
  eetVerificationMode?: Maybe<Scalars['Boolean']['output']>;
  /** Aktivní k použití */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Typy událostí */
  eventTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** URL události */
  eventUrl?: Maybe<Scalars['String']['output']>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Instituce */
  institution?: Maybe<Institution>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Záporné rezervace */
  negativeReservation?: Maybe<Scalars['Boolean']['output']>;
  /** Další doklad číslo */
  nextBillNumber?: Maybe<Scalars['Int']['output']>;
  /** Další rezervace číslo */
  nextReservationNumber?: Maybe<Scalars['Int']['output']>;
  /** Platby */
  payments?: Maybe<Array<Maybe<Payment>>>;
  /** Pozice */
  position?: Maybe<Scalars['Int']['output']>;
  /** Rezervace jen z jednoho skladu */
  reservationOnlyOneDepot?: Maybe<Scalars['Boolean']['output']>;
  /** Sklad vratky */
  returnsDepot?: Maybe<Depot>;
  /** Aktualizace */
  updated?: Maybe<Scalars['DateTime']['output']>;
  /** Uživatelé */
  users?: Maybe<Array<Maybe<User>>>;
};

export type CheckoutClosing = {
  /** Částka Closed */
  amountClosed?: Maybe<Scalars['Float']['output']>;
  /** Částka Open */
  amountOpen?: Maybe<Scalars['Float']['output']>;
  /** Částka Real Closed */
  amountRealClosed?: Maybe<Scalars['Float']['output']>;
  /** Částka Real Open */
  amountRealOpen?: Maybe<Scalars['Float']['output']>;
  /** URL účtenky */
  billUrl?: Maybe<Scalars['String']['output']>;
  /** Pokladna */
  checkout?: Maybe<Checkout>;
  /** Společnost */
  company?: Maybe<Company>;
  /** Datum uzavření */
  dateClosed?: Maybe<Scalars['DateTime']['output']>;
  /** Datum otevření */
  dateOpen?: Maybe<Scalars['DateTime']['output']>;
  /** Číselník */
  enumeration?: Maybe<Scalars['String']['output']>;
  /** Doplňkové operace */
  extraOperations?: Maybe<Array<Maybe<CheckoutExtraOperation>>>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Poznámka Closed */
  noteClosed?: Maybe<Scalars['String']['output']>;
  /** Poznámka Open */
  noteOpen?: Maybe<Scalars['String']['output']>;
  /** Objednávky */
  orders?: Maybe<Array<Maybe<Order>>>;
  paymentSum?: Maybe<Array<Maybe<paymentSum>>>;
  /** Zisk */
  profit?: Maybe<Scalars['Float']['output']>;
  /** Uživatel Closed */
  userClosed?: Maybe<User>;
  /** Uživatel Open */
  userOpen?: Maybe<User>;
  /** Rozpis DPH */
  vatAllocations?: Maybe<Array<Maybe<VatAllocation>>>;
};

export type CheckoutExtraOperation = {
  /** Částka */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Pokladna */
  checkout?: Maybe<Checkout>;
  /** Uzávěrka pokladny */
  checkoutClosing?: Maybe<CheckoutClosing>;
  /** Datum vytvoření */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Poznámka */
  note?: Maybe<Scalars['String']['output']>;
  /** Uživatel */
  user?: Maybe<User>;
};

export type ClearanceItem = {
  /** Částka */
  amount?: Maybe<Scalars['Int']['output']>;
  /** Šarže */
  batch?: Maybe<Scalars['String']['output']>;
  /** Sklad */
  depot?: Maybe<Depot>;
  /** Datum expirace */
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Uzamčeno */
  locked?: Maybe<Scalars['Boolean']['output']>;
  /** Pořadí podle řádků objednávky (1..N, bez děr a bez duplicit) POUZE v rámci seznamu, ze kterého položka pochází — u orderGroup napříč objednávkami podle groupPosition. Seznam samotný zůstává seřazený podle trasy; řádek rozpadlý na více pozic/šarží dostane po sobě jdoucí čísla v pořadí trasy. Není to globální identifikátor ani číslo řádku. U mutace updateClearanceItem s argumentem locations je null — načti seznam znovu. */
  orderIndex?: Maybe<Scalars['Int']['output']>;
  /** Položky objednávky */
  orderItems?: Maybe<Array<Maybe<OrderItem>>>;
  /** Zabaleno */
  packed?: Maybe<Scalars['Int']['output']>;
  /** Pořadí na trase vychystání (1..N) POUZE v rámci seznamu, ze kterého položka pochází. Táž položka má jinou hodnotu v order.clearanceItems, v orderItem.clearanceItems i v orderGroup/package — a v singulárním dotazu clearanceItem(id:) podle toho, který rodič byl předán. Není to globální identifikátor, neporovnávej hodnoty napříč seznamy. U mutace updateClearanceItem s argumentem locations je null (relokace mění trasu, odpověď se serializuje z předmutačního stavu) — načti seznam znovu. */
  pathIndex?: Maybe<Scalars['Int']['output']>;
  /** Vychystáno */
  picked?: Maybe<Scalars['Int']['output']>;
  /** Pozice */
  position?: Maybe<Scalars['String']['output']>;
  /** Pozice 1 */
  position1?: Maybe<Scalars['String']['output']>;
  /** Pozice 2 */
  position2?: Maybe<Scalars['String']['output']>;
  /** Pozice 3 */
  position3?: Maybe<Scalars['String']['output']>;
  /** Barva štítku pozice jako HEX (#rrggbb); null, pokud barva není zadaná nebo pozice na mapě skladu není. */
  positionColor?: Maybe<Scalars['String']['output']>;
  /** Typ pozice na mapě skladu (shelf = regálová, pallet = paletová/doplňovací); null, pokud pozice na mapě skladu není. */
  positionType?: Maybe<Scalars['String']['output']>;
  /** Zóna pozice na mapě skladu (A/B/C); null, pokud pozice na mapě skladu není. */
  positionZone?: Maybe<Scalars['String']['output']>;
  /** Produkt */
  product?: Maybe<Product>;
  /** Sklady produktu */
  productDepots?: Maybe<Array<Maybe<ProductDepot>>>;
  /** Přesuny produktu */
  productMoves?: Maybe<Array<Maybe<ProductMove>>>;
  /** Množství dostupné */
  quantityAvailable?: Maybe<Scalars['Int']['output']>;
  /** Množství rezervace */
  quantityReservation?: Maybe<Scalars['Int']['output']>;
  /** Množství skladem */
  quantityStock?: Maybe<Scalars['Int']['output']>;
};

export type Company = {
  /** Režim expirace šarží */
  batchExpirationMode?: Maybe<Scalars['String']['output']>;
  /** Logo dokladu */
  billLogo?: Maybe<Scalars['String']['output']>;
  /** Dopravce vazby */
  carrierRelations?: Maybe<Array<Maybe<CompanyCarrier>>>;
  /** Potomci */
  children?: Maybe<Array<Maybe<Company>>>;
  /** Město */
  city?: Maybe<Scalars['String']['output']>;
  /** Země */
  country?: Maybe<Scalars['String']['output']>;
  /** Měna */
  currency?: Maybe<Currency>;
  /** Vlastní volby */
  customOptions?: Maybe<Scalars['String']['output']>;
  /** Výchozí platnost poukazu */
  defaultVoucherValidity?: Maybe<Scalars['Int']['output']>;
  /** DIČ */
  dic?: Maybe<Scalars['String']['output']>;
  /** E-mail */
  email?: Maybe<Scalars['String']['output']>;
  /** Povolené zamykání */
  enabledLocking?: Maybe<Scalars['Boolean']['output']>;
  /** Povolené pozice */
  enabledPositions?: Maybe<Scalars['Boolean']['output']>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** IČ */
  ic?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Logo */
  logo?: Maybe<File>;
  /** Modul vazby */
  moduleRelations?: Maybe<Array<Maybe<CompanyModule>>>;
  /** Víceúčelové poukazy (prodej bez DPH, DPH až při uplatnění) */
  multiPurposeVouchers?: Maybe<Scalars['Boolean']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Další kód */
  nextCode?: Maybe<Scalars['Int']['output']>;
  /** Další EAN */
  nextEan?: Maybe<Scalars['Int']['output']>;
  /** Nadřazený */
  parent?: Maybe<Company>;
  /** Platby */
  payments?: Maybe<Array<Maybe<Payment>>>;
  /** Telefon */
  phone?: Maybe<Scalars['String']['output']>;
  /** Vychystání jen z jednoho skladu */
  pickingOnlyOneDepot?: Maybe<Scalars['Boolean']['output']>;
  /** Nákup cena s DPH */
  purchasePriceWithVat?: Maybe<Scalars['Boolean']['output']>;
  /** Registration poznámka */
  registrationNote?: Maybe<Scalars['String']['output']>;
  /** Ulice */
  street?: Maybe<Scalars['String']['output']>;
  /** Tarif */
  tariff?: Maybe<Tariff>;
  /** Datum expirace tarifu */
  tariffExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** PSČ */
  zip?: Maybe<Scalars['String']['output']>;
};

export type CompanyCarrier = {
  /** Dopravce */
  carrier?: Maybe<Carrier>;
  /** Pokladna */
  checkout?: Maybe<Checkout>;
  /** Povoleno */
  enable?: Maybe<Scalars['Boolean']['output']>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Možnosti */
  options?: Maybe<Scalars['String']['output']>;
};

export type CompanyCarrierTest = {
  /** Výsledek pro uživatele, u chyby důvod od dopravce */
  message?: Maybe<Scalars['String']['output']>;
  /** Nevyplněné povinné možnosti; company.* = údaj v nastavení firmy (telefon, ulice, město, PSČ) */
  missingOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Číslo testovací zásilky u dopravce */
  shipmentNumber?: Maybe<Scalars['String']['output']>;
  /** Byla odeslána testovací zásilka */
  shipmentTested?: Maybe<Scalars['Boolean']['output']>;
  /** ok | failed | missing_options | cancel_failed | uncertain | unverified | no_api */
  status?: Maybe<Scalars['String']['output']>;
  /** Dopravce je nastavený správně; null = nelze ověřit nebo je potřeba zásah (uncertain, cancel_failed) */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** Server běží s CARRIER_TEST; dopravci bez testovacího prostředí se i tak ověřují produkčně */
  testMode?: Maybe<Scalars['Boolean']['output']>;
};

export type CompanyModule = {
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Modul */
  module?: Maybe<Module>;
};

export type Consent = {
  /** Text */
  body?: Maybe<Scalars['String']['output']>;
  /** Společnost */
  company?: Maybe<Company>;
  /** Vytvoření */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Aktualizace */
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type Currency = {
  /** ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Kurz */
  ratio?: Maybe<Scalars['Float']['output']>;
};

export type CurrencyRate = {
  /** Částka */
  amount?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  /** Měna */
  currency?: Maybe<Currency>;
  /** Datum */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Kurz */
  rate?: Maybe<Scalars['Float']['output']>;
};

export type Customer = {
  /** Adresy */
  addresses?: Maybe<Array<Maybe<Address>>>;
  /** Datum narození */
  birthday?: Maybe<Scalars['DateTime']['output']>;
  /** Název firmy */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Vazby souhlasů */
  consentRelations?: Maybe<Array<Maybe<CustomerConsent>>>;
  /** Cokoli... */
  customData?: Maybe<Scalars['String']['output']>;
  /** E-mail */
  email?: Maybe<Scalars['String']['output']>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Jméno */
  firstName?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Příjmení */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Min. dny expirace */
  minExpirationDays?: Maybe<Scalars['Int']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Poznámka */
  note?: Maybe<Scalars['String']['output']>;
  /** Telefon */
  phone?: Maybe<Scalars['String']['output']>;
  /** Cenová úroveň */
  priceLevel?: Maybe<PriceLevel>;
  /** Tagy */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Uživatelé */
  users?: Maybe<Array<Maybe<User>>>;
  /** Velkoobchod */
  wholesale?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerConsent = {
  /** Text */
  body?: Maybe<Scalars['String']['output']>;
  /** Souhlas */
  consent?: Maybe<Consent>;
  /** Vytvoření */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** Zákazník */
  customer?: Maybe<Customer>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Aktualizace */
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type Depot = {
  /** Pokladny */
  checkouts?: Maybe<Array<Maybe<Checkout>>>;
  /** Společnost */
  company?: Maybe<Company>;
  /** Dopravci firmy */
  companyCarriers?: Maybe<Array<Maybe<CompanyCarrier>>>;
  /** Vytvoření */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** Lze smazat */
  deletable?: Maybe<Scalars['Boolean']['output']>;
  /** E-mail příjem */
  emailIn?: Maybe<Scalars['String']['output']>;
  /** Aktivní k použití */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Instituce */
  institution?: Maybe<Institution>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Pozice */
  position?: Maybe<Scalars['Int']['output']>;
  /** Priorita skladu (vyšší = přednostní) */
  priority?: Maybe<Scalars['Int']['output']>;
  /** URL nedostupných */
  unavailablesUrl?: Maybe<Scalars['String']['output']>;
  /** Aktualizace */
  updated?: Maybe<Scalars['DateTime']['output']>;
  /** Uživatelé */
  users?: Maybe<Array<Maybe<User>>>;
};

export type DevLog = {
  /** Obsah */
  content?: Maybe<Scalars['String']['output']>;
  /** Vytvoření */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
};

export type DepotoExport = {
  /** Vytvoření */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** Vytvořil */
  createdBy?: Maybe<User>;
  /** Selhání */
  failed?: Maybe<Scalars['DateTime']['output']>;
  /** Soubor */
  file?: Maybe<File>;
  /** Filtr */
  filter?: Maybe<Scalars['String']['output']>;
  /** Vygenerováno */
  generated?: Maybe<Scalars['DateTime']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Poznámka */
  note?: Maybe<Scalars['String']['output']>;
  /** Typ */
  type?: Maybe<ExportType>;
  /** URL */
  url?: Maybe<Scalars['String']['output']>;
};

export type ExportType = {
  /** Formát */
  format?: Maybe<Scalars['String']['output']>;
  /** Skupina */
  group?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
};

export type File = {
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Hlavní */
  main?: Maybe<Scalars['Boolean']['output']>;
  /** MIME typ */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** Objednávka */
  order?: Maybe<Order>;
  /** Původní název souboru */
  originalFilename?: Maybe<Scalars['String']['output']>;
  /** Produkt */
  product?: Maybe<Product>;
  /** Velikost */
  size?: Maybe<Scalars['Int']['output']>;
  /** Text */
  text?: Maybe<Scalars['String']['output']>;
  /** Náhledy */
  thumbnails?: Maybe<Array<Maybe<FileThumbnail>>>;
  /** URL */
  url?: Maybe<Scalars['String']['output']>;
  /** UUID */
  uuid?: Maybe<Scalars['String']['output']>;
};

export type FileThumbnail = {
  /** Formát */
  format?: Maybe<Scalars['String']['output']>;
  /** MIME typ */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** URL */
  url?: Maybe<Scalars['String']['output']>;
};

export type Institution = {
  /** Pokladny */
  checkouts?: Maybe<Array<Maybe<Checkout>>>;
  /** Společnost */
  company?: Maybe<Company>;
  /** Sklady */
  depots?: Maybe<Array<Maybe<Depot>>>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
};

export type Inventory = {
  /** Schváleno */
  approved?: Maybe<Scalars['DateTime']['output']>;
  /** Vytvoření */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** Datum */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** Sklady */
  depots?: Maybe<Array<Maybe<Depot>>>;
  /** Soubory */
  files?: Maybe<Array<Maybe<File>>>;
  /** Dokončeno */
  finished?: Maybe<Scalars['DateTime']['output']>;
  /** Vygenerováno */
  generated?: Maybe<Scalars['DateTime']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** PMP příjem */
  pmpIn?: Maybe<ProductMovePack>;
  /** PMP výdej */
  pmpOut?: Maybe<ProductMovePack>;
  /** Značky */
  producers?: Maybe<Array<Maybe<Producer>>>;
  /** Zamítnuto */
  rejected?: Maybe<Scalars['DateTime']['output']>;
  /** Dodavatelé */
  suppliers?: Maybe<Array<Maybe<Supplier>>>;
  /** URL */
  url?: Maybe<Scalars['String']['output']>;
};

export type Leaflet = {
  /** Společnost */
  company?: Maybe<Company>;
  /** Země (ISO 3166-1 alpha-2) */
  countries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Výška */
  height?: Maybe<Scalars['Int']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Produkt */
  product?: Maybe<Product>;
  /** Text letáku */
  text?: Maybe<Scalars['String']['output']>;
  /** Šířka */
  width?: Maybe<Scalars['Int']['output']>;
};

export type LoggableHistoryChange = {
  /** Raw camelCase field name */
  field: Scalars['String']['output'];
  /** Krátký název cílové entity, pokud je hodnota asociace na jinou Loggable entitu */
  relatedClass?: Maybe<Scalars['String']['output']>;
  /** ID cílové Loggable entity */
  relatedId?: Maybe<Scalars['String']['output']>;
  /** Stringified scalar value; null when relatedClass is set (association) or when the original value was null */
  value?: Maybe<Scalars['String']['output']>;
};

export type LoggableHistoryEntry = {
  /** create | update | remove */
  action: Scalars['String']['output'];
  /** Pole změn polí entity v této verzi */
  changes: Array<LoggableHistoryChange>;
  /** Časová značka změny (ISO 8601) */
  loggedAt?: Maybe<Scalars['String']['output']>;
  /** Krátký název logované entity (např. "Product") */
  objectClass: Scalars['String']['output'];
  /** ID logované entity */
  objectId: Scalars['String']['output'];
  /** Username uživatele, který změnu provedl */
  username?: Maybe<Scalars['String']['output']>;
  /** Verze záznamu (1, 2, 3, ...) */
  version: Scalars['Int']['output'];
};

export type Module = {
  /** ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
};

export type Order = {
  /** Číslo dokladu */
  billNumber?: Maybe<Scalars['Int']['output']>;
  /** DEPRECATED - URL PDF účtenky */
  billUrl?: Maybe<Scalars['String']['output']>;
  /** Krabice */
  boxes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Dopravce */
  carrier?: Maybe<Carrier>;
  /** Nastavení dopravce pro objednávku (JSON), přebíjí CompanyCarrier.options */
  carrierOptions?: Maybe<Scalars['String']['output']>;
  /** Pokladna */
  checkout?: Maybe<Checkout>;
  /** Uzávěrka pokladny */
  checkoutClosing?: Maybe<CheckoutClosing>;
  /** Položky výprodeje */
  clearanceItems?: Maybe<Array<Maybe<ClearanceItem>>>;
  /** Společnost */
  company?: Maybe<Company>;
  /** Vytvoření */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** Vytvořil */
  createdBy?: Maybe<User>;
  /** Měna */
  currency?: Maybe<Currency>;
  /** Zákazník */
  customer?: Maybe<Customer>;
  /** Datum vystavení */
  dateBill?: Maybe<Scalars['DateTime']['output']>;
  /** Datum vytvoření */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** Datum splatnosti */
  dateDue?: Maybe<Scalars['DateTime']['output']>;
  /** Datum expedice */
  dateExpedition?: Maybe<Scalars['DateTime']['output']>;
  /** Od kdy uzamčena */
  dateLocked?: Maybe<Scalars['DateTimeAsString']['output']>;
  /** Datum zdanitelného plnění */
  dateTax?: Maybe<Scalars['DateTime']['output']>;
  /** Smazáno */
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** Sklady */
  depots?: Maybe<Array<Maybe<Depot>>>;
  /** EET účtenka */
  eetReceipt?: Maybe<Receipt>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Externí číslo */
  externalReference?: Maybe<Scalars['String']['output']>;
  /** Soubory */
  files?: Maybe<Array<Maybe<File>>>;
  /** Skupina */
  group?: Maybe<OrderGroup>;
  /** Pozice ve skupině */
  groupPosition?: Maybe<Scalars['Int']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Fakturační adresa */
  invoiceAddress?: Maybe<Address>;
  /** URL ISDOC faktury */
  invoiceIsdocUrl?: Maybe<Scalars['String']['output']>;
  /** URL PDF účtenky */
  invoiceReceiptUrl?: Maybe<Scalars['String']['output']>;
  /** URL PDF faktury */
  invoiceUrl?: Maybe<Scalars['String']['output']>;
  /** Lze upravit */
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  /** Zaplaceno */
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  /** Položky */
  items?: Maybe<Array<Maybe<OrderItem>>>;
  /** Uzamčena */
  locked?: Maybe<Scalars['Boolean']['output']>;
  /** Kým uzamčena */
  lockedBy?: Maybe<User>;
  /** Balíky přesunů */
  movePacks?: Maybe<Array<Maybe<ProductMovePack>>>;
  /** Poznámka */
  note?: Maybe<Scalars['String']['output']>;
  /** Balíky */
  packages?: Maybe<Array<Maybe<DepotoPackage>>>;
  /** Položky plateb */
  paymentItems?: Maybe<Array<Maybe<PaymentItem>>>;
  /** Cena celkem */
  priceAll?: Maybe<Scalars['Float']['output']>;
  /** Cena celkem bez DPH */
  priceAllWithoutVat?: Maybe<Scalars['Float']['output']>;
  /** Priorita */
  priority?: Maybe<Scalars['Int']['output']>;
  /** Interní poznámka */
  privateNote?: Maybe<Scalars['String']['output']>;
  /** Stav procesu */
  processStatus?: Maybe<ProcessStatus>;
  /** Vazba stavu procesu */
  processStatusRelation?: Maybe<OrderProcessStatus>;
  /** Vazby stavu procesu */
  processStatusRelations?: Maybe<Array<Maybe<OrderProcessStatus>>>;
  /** Datum změny stavu procesu */
  processStatusUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Zisk */
  profit?: Maybe<Scalars['Float']['output']>;
  /** Množství nedostupné */
  quantityUnavailable?: Maybe<Scalars['Int']['output']>;
  /** Nadřazený záznam */
  relatedParent?: Maybe<Order>;
  /** Číslo rezervace */
  reservationNumber?: Maybe<Scalars['Int']['output']>;
  /** URL PDF účtenky-rezervace */
  reservationReceiptUrl?: Maybe<Scalars['String']['output']>;
  /** URL PDF objednávky */
  reservationUrl?: Maybe<Scalars['String']['output']>;
  /** Zaokrouhlení */
  rounding?: Maybe<Scalars['Float']['output']>;
  /** Doručovací adresa */
  shippingAddress?: Maybe<Address>;
  /** Stav */
  status?: Maybe<OrderStatus>;
  /** Tagy */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Aktualizace */
  updated?: Maybe<Scalars['DateTime']['output']>;
  /** Rozpis DPH */
  vatAllocations?: Maybe<Array<Maybe<VatAllocation>>>;
  /** VS */
  vs?: Maybe<Scalars['Int']['output']>;
};

export type OrderGroup = {
  /** Položky výprodeje */
  clearanceItems?: Maybe<Array<Maybe<ClearanceItem>>>;
  /** Společnost */
  company?: Maybe<Company>;
  /** Vytvoření */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Objednávky */
  orders?: Maybe<Array<Maybe<Order>>>;
  /** Počet objednávek */
  ordersCount?: Maybe<Scalars['Int']['output']>;
  /** Tagy */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Aktualizace */
  updated?: Maybe<Scalars['DateTime']['output']>;
  /** Uživatel */
  user?: Maybe<User>;
  /** Uživatel Pozice */
  userPosition?: Maybe<Scalars['Int']['output']>;
};

export type OrderItem = {
  /** Šarže */
  batch?: Maybe<Scalars['String']['output']>;
  /** Položky výprodeje */
  clearanceItems?: Maybe<Array<Maybe<ClearanceItem>>>;
  /** Kód */
  code?: Maybe<Scalars['String']['output']>;
  /** EAN */
  ean?: Maybe<Scalars['String']['output']>;
  /** Datum expirace */
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Pro následné uplatnění */
  isForSubsequentSettlement?: Maybe<Scalars['Boolean']['output']>;
  /** Přesuny */
  moves?: Maybe<Array<Maybe<ProductMove>>>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Poznámka */
  note?: Maybe<Scalars['String']['output']>;
  /** Objednávka */
  order?: Maybe<Order>;
  /** Zabaleno */
  packed?: Maybe<Scalars['Boolean']['output']>;
  /** Vychystáno */
  picked?: Maybe<Scalars['Boolean']['output']>;
  /** Cena */
  price?: Maybe<Scalars['Float']['output']>;
  /** Cena celkem */
  priceAll?: Maybe<Scalars['Float']['output']>;
  /** Cena celkem bez DPH */
  priceAllWithoutVat?: Maybe<Scalars['Float']['output']>;
  /** Cena bez DPH */
  priceWithoutVat?: Maybe<Scalars['Float']['output']>;
  /** Produkt */
  product?: Maybe<Product>;
  /** Zisk */
  profit?: Maybe<Scalars['Float']['output']>;
  /** Množství */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** Množství nedostupné */
  quantityUnavailable?: Maybe<Scalars['Int']['output']>;
  /** Prodej */
  sale?: Maybe<Scalars['Float']['output']>;
  /** Sériové číslo */
  serial?: Maybe<Scalars['String']['output']>;
  /** Typ */
  type?: Maybe<Scalars['String']['output']>;
  /** DPH */
  vat?: Maybe<Vat>;
  /** Poukaz */
  voucher?: Maybe<Voucher>;
};

export type OrderProcessStatus = {
  /** Aktuální */
  actual?: Maybe<Scalars['Boolean']['output']>;
  /** Vytvoření */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** Vytvořil */
  createdBy?: Maybe<User>;
  /** Poznámka */
  note?: Maybe<Scalars['String']['output']>;
  /** Stav */
  status?: Maybe<ProcessStatus>;
};

export type OrderStatus = {
  /** ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
};

export type DepotoPackage = {
  /** Dopravce */
  carrier?: Maybe<Carrier>;
  /** Položky výprodeje */
  clearanceItems?: Maybe<Array<Maybe<ClearanceItem>>>;
  /** Kód */
  code?: Maybe<Scalars['String']['output']>;
  /** Společnost */
  company?: Maybe<Company>;
  /** Rozměr X */
  dimensionX?: Maybe<Scalars['Float']['output']>;
  /** Rozměr Y */
  dimensionY?: Maybe<Scalars['Float']['output']>;
  /** Rozměr Z */
  dimensionZ?: Maybe<Scalars['Float']['output']>;
  /** Povinné rozměry */
  dimensionsRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Likvidace */
  disposal?: Maybe<PackageDisposal>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Položky */
  items?: Maybe<Array<Maybe<OrderItem>>>;
  /** Objednávka */
  order?: Maybe<Order>;
  /** Odesláno */
  sent?: Maybe<Scalars['DateTime']['output']>;
  /** Stavy */
  statuses?: Maybe<Array<Maybe<PackageStatus>>>;
  /** Tarif */
  tariff?: Maybe<CarrierTariff>;
  /** URL ticketu */
  ticketUrl?: Maybe<Scalars['String']['output']>;
  /** Hmotnost */
  weight?: Maybe<Scalars['Float']['output']>;
  /** Povinná hmotnost */
  weightRequired?: Maybe<Scalars['Boolean']['output']>;
};

export type PackageDisposal = {
  /** Dopravce */
  carrier?: Maybe<Carrier>;
  /** Kód */
  code?: Maybe<Scalars['String']['output']>;
  /** Společnost */
  company?: Maybe<Company>;
  /** Soubory */
  files?: Maybe<Array<Maybe<File>>>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Balíky */
  packages?: Maybe<Array<Maybe<DepotoPackage>>>;
  /** Odesláno */
  sent?: Maybe<Scalars['DateTime']['output']>;
  /** URL ticketu */
  ticketUrl?: Maybe<Scalars['String']['output']>;
};

export type PackageStats = {
  /** Společnost */
  company?: Maybe<Company>;
  /** Země */
  country?: Maybe<Scalars['String']['output']>;
  /** Objednávka Částka */
  orderAmount?: Maybe<Scalars['Int']['output']>;
  /** Balík Částka */
  packageAmount?: Maybe<Scalars['Int']['output']>;
  /** Stav procesu */
  processStatus?: Maybe<ProcessStatus>;
};

export type PackageStatus = {
  /** Kód */
  code?: Maybe<Scalars['String']['output']>;
  /** Vytvoření */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Balík */
  package?: Maybe<DepotoPackage>;
  /** Text */
  text?: Maybe<Scalars['String']['output']>;
};

export type Paginator = {
  /** Aktuální */
  current?: Maybe<Scalars['Int']['output']>;
  /** Aktuální položka Počet */
  currentItemCount?: Maybe<Scalars['Int']['output']>;
  /** Koncová strana */
  endPage?: Maybe<Scalars['Int']['output']>;
  /** První */
  first?: Maybe<Scalars['Int']['output']>;
  /** První položka číslo */
  firstItemNumber?: Maybe<Scalars['Int']['output']>;
  /** První strana v rozsahu */
  firstPageInRange?: Maybe<Scalars['Int']['output']>;
  /** Poslední */
  last?: Maybe<Scalars['Int']['output']>;
  /** Poslední položka číslo */
  lastItemNumber?: Maybe<Scalars['Int']['output']>;
  /** Poslední strana v rozsahu */
  lastPageInRange?: Maybe<Scalars['Int']['output']>;
  /** Další */
  next?: Maybe<Scalars['Int']['output']>;
  /** Num položky Per Page */
  numItemsPerPage?: Maybe<Scalars['Int']['output']>;
  /** Počet stran */
  pageCount?: Maybe<Scalars['Int']['output']>;
  /** Rozsah stránek */
  pageRange?: Maybe<Scalars['Int']['output']>;
  /** Strany v rozsahu */
  pagesInRange?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Počáteční strana */
  startPage?: Maybe<Scalars['Int']['output']>;
  /** Celkový počet */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Parameter = {
  /** Společnost */
  company?: Maybe<Company>;
  /** Hodnoty výčtu */
  enumValues?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Text */
  text?: Maybe<Scalars['String']['output']>;
  /** Typ */
  type?: Maybe<Scalars['String']['output']>;
  /** Jednotka */
  unit?: Maybe<Scalars['String']['output']>;
};

export type Payment = {
  /** Společnost */
  company?: Maybe<Company>;
  /** Expedovat i nezaplacené objednávky */
  dispatchUnpaid?: Maybe<Scalars['Boolean']['output']>;
  /** EET povoleno */
  eetEnable?: Maybe<Scalars['Boolean']['output']>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Typ */
  type?: Maybe<PaymentType>;
};

export type PaymentItem = {
  /** Částka */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Pokladna */
  checkout?: Maybe<Checkout>;
  /** Datum zrušení */
  dateCancelled?: Maybe<Scalars['DateTime']['output']>;
  /** Datum vytvoření */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** Datum zaplacení */
  datePaid?: Maybe<Scalars['DateTime']['output']>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Zaplaceno */
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  /** Platba */
  payment?: Maybe<Payment>;
  /** Poukaz */
  voucher?: Maybe<Voucher>;
};

export type PaymentSales = {
  /** Částka */
  amount?: Maybe<Scalars['Int']['output']>;
  /** Platba */
  payment?: Maybe<Payment>;
  /** Prodeje */
  sales?: Maybe<Array<Maybe<Price>>>;
};

export type PaymentType = {
  /** ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
};

export type Price = {
  /** Měna */
  currency?: Maybe<Currency>;
  /** Hodnota */
  value?: Maybe<Scalars['Float']['output']>;
};

export type PriceLevel = {
  /** Společnost */
  company?: Maybe<Company>;
  /** Měna */
  currency?: Maybe<Currency>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Je procentní */
  isPercentage?: Maybe<Scalars['Boolean']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Procenta */
  percent?: Maybe<Scalars['Float']['output']>;
  /** S DPH */
  withVat?: Maybe<Scalars['Boolean']['output']>;
};

export type ProcessStatus = {
  /** ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Pozice */
  position?: Maybe<Scalars['Int']['output']>;
};

export type Producer = {
  /** Společnost */
  company?: Maybe<Company>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
};

export type Product = {
  /** Aktuální cena před slevou - včetně započtených akčních cen */
  actualBeforeSellPrice?: Maybe<Scalars['Float']['output']>;
  /** Aktuální prodejní cena - včetně započtených akčních cen */
  actualSellPrice?: Maybe<Scalars['Float']['output']>;
  /** Aktuální prodejní cena bez DPH */
  actualSellPriceWithoutVat?: Maybe<Scalars['Float']['output']>;
  /** Akční ceny */
  advancedPrices?: Maybe<Array<Maybe<ProductPrice>>>;
  /** Cena před slevou */
  beforeSellPrice?: Maybe<Scalars['Float']['output']>;
  /** Potomci setu */
  bundleChildren?: Maybe<Array<Maybe<ProductBundle>>>;
  /** Nadřazené sety */
  bundleParents?: Maybe<Array<Maybe<ProductBundle>>>;
  /** Kategorie */
  categories?: Maybe<Array<Maybe<Category>>>;
  /** Potomci / varianty produktu */
  children?: Maybe<Array<Maybe<Product>>>;
  /** Kód */
  code?: Maybe<Scalars['String']['output']>;
  /** Kód2 */
  code2?: Maybe<Scalars['String']['output']>;
  /** Kód3 */
  code3?: Maybe<Scalars['String']['output']>;
  /** Společnost */
  company?: Maybe<Company>;
  /** Vytvoření */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** Cokoli... */
  customData?: Maybe<Scalars['String']['output']>;
  /** Lze smazat */
  deletable?: Maybe<Scalars['Boolean']['output']>;
  /** Deprecated: používejte productDepots */
  depots?: Maybe<Array<Maybe<ProductDepot>>>;
  /** Popis */
  description?: Maybe<Scalars['String']['output']>;
  /** Rozměr X */
  dimensionX?: Maybe<Scalars['Float']['output']>;
  /** Rozměr Y */
  dimensionY?: Maybe<Scalars['Float']['output']>;
  /** Rozměr Z */
  dimensionZ?: Maybe<Scalars['Float']['output']>;
  /** Unikátní EAN 13 */
  ean?: Maybe<Scalars['String']['output']>;
  /** Unikátní EAN 13 */
  ean2?: Maybe<Scalars['String']['output']>;
  /** Unikátní EAN 13 */
  ean3?: Maybe<Scalars['String']['output']>;
  /** Unikátní EAN 13 */
  ean4?: Maybe<Scalars['String']['output']>;
  /** Unikátní EAN 13 */
  ean5?: Maybe<Scalars['String']['output']>;
  /** Je produkt aktnivní? */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Eviduje expirace a šarže */
  enabledBatchExpiration?: Maybe<Scalars['Boolean']['output']>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Soubory (mimo obrázků) */
  files?: Maybe<Array<Maybe<File>>>;
  /** Název včetně názvu rodičovského produktu */
  fullName?: Maybe<Scalars['String']['output']>;
  /** HS kód */
  hsCode?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Obrázky */
  images?: Maybe<Array<Maybe<File>>>;
  /** Pouze pro dospělé */
  isAdultOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Jedná se o set produktů (virtuální produkt) */
  isBundle?: Maybe<Scalars['Boolean']['output']>;
  /** Zastaralé - použijte deletable. */
  isDeletable?: Maybe<Scalars['Boolean']['output']>;
  /** Produkt je položka pro následné uplatnění (např. kupón) - pro EET */
  isForSubsequentSettlement?: Maybe<Scalars['Boolean']['output']>;
  /** Křehký */
  isFragile?: Maybe<Scalars['Boolean']['output']>;
  /** Nadrozměrný */
  isOversize?: Maybe<Scalars['Boolean']['output']>;
  /** PML */
  isPML?: Maybe<Scalars['Boolean']['output']>;
  /** Letáky */
  leaflets?: Maybe<Array<Maybe<Leaflet>>>;
  /** Hlavní kategorie */
  mainCategory?: Maybe<Category>;
  /** Hlavní obrázek */
  mainImage?: Maybe<File>;
  /** Metriky */
  metrics?: Maybe<Array<Maybe<ProductDepotMetric>>>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Poznámka */
  note?: Maybe<Scalars['String']['output']>;
  /** Země výroby */
  originCountry?: Maybe<Scalars['String']['output']>;
  /** Balení/Kartony */
  packs?: Maybe<Array<Maybe<ProductPack>>>;
  /** Rodičovský produkt */
  parent?: Maybe<Product>;
  /** Krátký popis */
  perex?: Maybe<Scalars['String']['output']>;
  /** Recyklační poplatek */
  phePrice?: Maybe<Scalars['Float']['output']>;
  /** Značka */
  producer?: Maybe<Producer>;
  /** Skladové zásoby */
  productDepots?: Maybe<Array<Maybe<ProductDepot>>>;
  /** Relace parametrů produktu */
  productParameters?: Maybe<Array<Maybe<ProductParameter>>>;
  /** Relace cenových úrovní produktu */
  productPriceLevels?: Maybe<Array<Maybe<ProductPriceLevel>>>;
  /** Výchozí nákupní měna */
  purchaseCurrency?: Maybe<Currency>;
  /** Výchozí nákupní cena */
  purchasePrice?: Maybe<Scalars['Float']['output']>;
  /** Počty */
  quantities?: Maybe<Array<Maybe<Quantity>>>;
  /** Počet dostupných kusů a všech skladech */
  quantityAvailable?: Maybe<Scalars['Float']['output']>;
  /** Počet kusů objednaný od dodavatele */
  quantityPurchase?: Maybe<Scalars['Float']['output']>;
  /** Počet kusů v rezervaci na všech skladech */
  quantityReservation?: Maybe<Scalars['Float']['output']>;
  /** Počet kusů skladem a všech skladech */
  quantityStock?: Maybe<Scalars['Float']['output']>;
  /** Počet nedostupných kusů v rezervaci */
  quantityUnavailable?: Maybe<Scalars['Int']['output']>;
  /** Eviduje sériová čísla */
  requiredSerialNumbers?: Maybe<Scalars['Boolean']['output']>;
  /** Položky k prodeji: jednotlivé expirace a šarže */
  sellItems?: Maybe<Array<Maybe<SellItem>>>;
  /** Prodejní cena */
  sellPrice?: Maybe<Scalars['Float']['output']>;
  /** Prodejní cena bez DPH */
  sellPriceWithoutVat?: Maybe<Scalars['Float']['output']>;
  /** Výchozí dodavatel */
  supplier?: Maybe<Supplier>;
  /** Tagy */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Aktualizace */
  updated?: Maybe<Scalars['DateTime']['output']>;
  /** DPH */
  vat?: Maybe<Vat>;
  /** Váha */
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ProductBundle = {
  /** Potomek */
  child?: Maybe<Product>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Nadřazený */
  parent?: Maybe<Product>;
  /** Množství */
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type ProductDepot = {
  /** Šarže */
  batch?: Maybe<Scalars['String']['output']>;
  /** Clearance položka ID */
  clearanceItemId?: Maybe<Scalars['String']['output']>;
  /** Vytvoření */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** Sklad */
  depot?: Maybe<Depot>;
  /** Datum expirace */
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Inventory množství skladem */
  inventoryQuantityStock?: Maybe<Scalars['Float']['output']>;
  /** Pozice */
  position?: Maybe<Scalars['String']['output']>;
  /** Pozice 1 (max. 5 znaků) */
  position1?: Maybe<Scalars['String']['output']>;
  /** Pozice 2 (max. 5 znaků) */
  position2?: Maybe<Scalars['String']['output']>;
  /** Pozice 3 (max. 5 znaků) */
  position3?: Maybe<Scalars['String']['output']>;
  /** Produkt */
  product?: Maybe<Product>;
  /** Nákup cena */
  purchasePrice?: Maybe<Scalars['Float']['output']>;
  /** Množství dostupné */
  quantityAvailable?: Maybe<Scalars['Float']['output']>;
  /** Množství rezervace */
  quantityReservation?: Maybe<Scalars['Float']['output']>;
  /** Množství skladem */
  quantityStock?: Maybe<Scalars['Float']['output']>;
  /** Množství nedostupné */
  quantityUnavailable?: Maybe<Scalars['Float']['output']>;
  /** Dodavatel */
  supplier?: Maybe<Supplier>;
  /** Aktualizace */
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductDepotMetric = {
  /** Vytvoření */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** Sklad */
  depot?: Maybe<Depot>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Produkt */
  product?: Maybe<Product>;
  /** Množství Maximum */
  quantityMaximum?: Maybe<Scalars['Int']['output']>;
  /** Množství Minimum */
  quantityMinimum?: Maybe<Scalars['Int']['output']>;
  /** Množství Optimum */
  quantityOptimum?: Maybe<Scalars['Int']['output']>;
  /** Množství nákup */
  quantityPurchase?: Maybe<Scalars['Int']['output']>;
  /** Množství skladem */
  quantityStock?: Maybe<Scalars['Int']['output']>;
  /** Aktualizace */
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductMove = {
  /** Částka */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Vytvoření */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** Vytvořil */
  createdBy?: Maybe<User>;
  /** Lze smazat */
  deletable?: Maybe<Scalars['Boolean']['output']>;
  /** Smazáno */
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Uzamčeno */
  locked?: Maybe<Scalars['Boolean']['output']>;
  /** Poznámka */
  note?: Maybe<Scalars['String']['output']>;
  /** Položka objednávky */
  orderItem?: Maybe<OrderItem>;
  /** Balík */
  pack?: Maybe<ProductMovePack>;
  /** Zabaleno */
  packed?: Maybe<Scalars['Int']['output']>;
  /** Vychystáno */
  picked?: Maybe<Scalars['Int']['output']>;
  /** Produkt */
  product?: Maybe<Product>;
  /** Sklad produktu od */
  productDepotFrom?: Maybe<ProductDepot>;
  /** Produkt sklad od množství skladem */
  productDepotFromQuantityStock?: Maybe<Scalars['Int']['output']>;
  /** Sklad produktu do */
  productDepotTo?: Maybe<ProductDepot>;
  /** Produkt sklad do množství skladem */
  productDepotToQuantityStock?: Maybe<Scalars['Int']['output']>;
  /** Nákup objednávka položka */
  purchaseOrderItem?: Maybe<PurchaseOrderItem>;
  /** Nákup cena */
  purchasePrice?: Maybe<Scalars['Float']['output']>;
  /** Nákup cena All */
  purchasePriceAll?: Maybe<Scalars['Float']['output']>;
  /** Nákup cena All s DPH */
  purchasePriceAllWithVat?: Maybe<Scalars['Float']['output']>;
  /** Nákup cena s DPH */
  purchasePriceWithVat?: Maybe<Scalars['Float']['output']>;
  /** Množství nedostupné */
  quantityUnavailable?: Maybe<Scalars['Float']['output']>;
  /** Sériová čísla */
  serialNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Aktualizace */
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductMovePack = {
  /** Pokladna */
  checkout?: Maybe<Checkout>;
  /** Společnost */
  company?: Maybe<Company>;
  /** Vytvořil */
  createdBy?: Maybe<User>;
  /** Datum vytvoření */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** Lze smazat */
  deletable?: Maybe<Scalars['Boolean']['output']>;
  /** Sklad od */
  depotFrom?: Maybe<Depot>;
  /** Sklad do */
  depotTo?: Maybe<Depot>;
  /** URL Excel s položkami */
  excelItemsUrl?: Maybe<Scalars['String']['output']>;
  /** URL Excel se sériovými čísly */
  excelSerialNumbersUrl?: Maybe<Scalars['String']['output']>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Externí reference */
  externalReference?: Maybe<Scalars['String']['output']>;
  /** Soubory */
  files?: Maybe<Array<Maybe<File>>>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Vedlejší náklady */
  incidentalCosts?: Maybe<Scalars['Float']['output']>;
  /** Přesuny */
  moves?: Maybe<Array<Maybe<ProductMove>>>;
  /** Poznámka */
  note?: Maybe<Scalars['String']['output']>;
  /** Číslo */
  number?: Maybe<Scalars['Int']['output']>;
  /** Objednávka */
  order?: Maybe<Order>;
  /** URL PDF bez cen */
  pdfWOPricesUrl?: Maybe<Scalars['String']['output']>;
  /** Nákup objednávka */
  purchaseOrder?: Maybe<PurchaseOrder>;
  /** Nákup cena */
  purchasePrice?: Maybe<Scalars['Float']['output']>;
  /** Nákup cena s DPH */
  purchasePriceWithVat?: Maybe<Scalars['Float']['output']>;
  /** Účel */
  purpose?: Maybe<ProductMovePurpose>;
  /** Tagy */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Typ */
  type?: Maybe<ProductMoveType>;
  /** URL */
  url?: Maybe<Scalars['String']['output']>;
};

export type ProductMovePurpose = {
  /** ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
};

export type ProductMoveType = {
  /** ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
};

export type ProductPack = {
  /** Kód */
  code?: Maybe<Scalars['String']['output']>;
  /** Unikátní EAN 13 */
  ean?: Maybe<Scalars['String']['output']>;
  /** Externí ID */
  externalId?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Poznámka */
  note?: Maybe<Scalars['String']['output']>;
  /** ID produktu */
  product?: Maybe<Product>;
  /** Množství */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** Hmotnost */
  weight?: Maybe<Scalars['Int']['output']>;
};

export type ProductParameter = {
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Parameter */
  parameter?: Maybe<Parameter>;
  /** Produkt */
  product?: Maybe<Product>;
  /** Hodnota */
  value?: Maybe<Scalars['StringOrArray']['output']>;
};

export type ProductPrice = {
  /** Dostupné */
  available?: Maybe<Scalars['Int']['output']>;
  /** Datum od */
  dateFrom?: Maybe<Scalars['DateTime']['output']>;
  /** Datum do */
  dateTo?: Maybe<Scalars['DateTime']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Aktuální */
  isActual?: Maybe<Scalars['Boolean']['output']>;
  /** Poznámka */
  note?: Maybe<Scalars['String']['output']>;
  /** Produkt */
  product?: Maybe<Product>;
  /** Prodejní cena */
  sellPrice?: Maybe<Scalars['Float']['output']>;
};

export type ProductPriceLevel = {
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Cenová úroveň */
  priceLevel?: Maybe<PriceLevel>;
  /** Produkt */
  product?: Maybe<Product>;
  /** Prodejní cena */
  sellPrice?: Maybe<Scalars['Float']['output']>;
};

export type ProductPurchasePrice = {
  /** Sklad produktu */
  productDepot?: Maybe<Depot>;
  /** Nákup cena */
  purchasePrice?: Maybe<Scalars['Float']['output']>;
  /** Množství */
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type Purchase = {
  /** Pokladny */
  checkouts?: Maybe<Array<Maybe<Checkout>>>;
  /** Vytvoření */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** Datum od */
  dateFrom?: Maybe<Scalars['DateTime']['output']>;
  /** Datum do */
  dateTo?: Maybe<Scalars['DateTime']['output']>;
  /** Sklady */
  depots?: Maybe<Array<Maybe<Depot>>>;
  /** Formát */
  format?: Maybe<Scalars['String']['output']>;
  /** Vygenerováno */
  generated?: Maybe<Scalars['DateTime']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Značky */
  producers?: Maybe<Array<Maybe<Producer>>>;
  /** Dodavatelé */
  suppliers?: Maybe<Array<Maybe<Supplier>>>;
  /** URL */
  url?: Maybe<Scalars['String']['output']>;
};

export type PurchaseOrder = {
  /** Společnost */
  company?: Maybe<Company>;
  /** Vytvoření */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** Vytvořil */
  createdBy?: Maybe<User>;
  /** Cokoli... */
  customData?: Maybe<Scalars['String']['output']>;
  /** Odhadované datum doručení */
  dateEstimatedArrival?: Maybe<Scalars['DateTime']['output']>;
  /** Lze smazat */
  deletable?: Maybe<Scalars['Boolean']['output']>;
  /** Sklad */
  depot?: Maybe<Depot>;
  /** URL Excel */
  excelUrl?: Maybe<Scalars['String']['output']>;
  /** URL Excel bez cen */
  excelWOPricesUrl?: Maybe<Scalars['String']['output']>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Externí reference */
  externalReference?: Maybe<Scalars['String']['output']>;
  /** Soubory */
  files?: Maybe<Array<Maybe<File>>>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Položky */
  items?: Maybe<Array<Maybe<PurchaseOrderItem>>>;
  /** Poznámka */
  note?: Maybe<Scalars['String']['output']>;
  /** Číslo */
  number?: Maybe<Scalars['String']['output']>;
  /** URL PDF */
  pdfUrl?: Maybe<Scalars['String']['output']>;
  /** URL PDF bez cen */
  pdfWOPricesUrl?: Maybe<Scalars['String']['output']>;
  /** Interní poznámka */
  privateNote?: Maybe<Scalars['String']['output']>;
  /** Balíky přesunu produktu */
  productMovePacks?: Maybe<Array<Maybe<ProductMovePack>>>;
  /** Nákup cena All */
  purchasePriceAll?: Maybe<Scalars['Float']['output']>;
  /** Nákup cena All s DPH */
  purchasePriceAllWithVat?: Maybe<Scalars['Float']['output']>;
  /** Stav */
  status?: Maybe<PurchaseOrderStatus>;
  /** Dodavatel */
  supplier?: Maybe<Supplier>;
  /** Reference dodavatele */
  supplierReference?: Maybe<Scalars['String']['output']>;
  /** Tagy */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Aktualizace */
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type PurchaseOrderItem = {
  /** Měna */
  currency?: Maybe<Currency>;
  /** Cokoli... */
  customData?: Maybe<Scalars['String']['output']>;
  /** Lze smazat */
  deletable?: Maybe<Scalars['Boolean']['output']>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Poznámka */
  note?: Maybe<Scalars['String']['output']>;
  /** Produkt */
  product?: Maybe<Product>;
  /** Přesuny produktu */
  productMoves?: Maybe<Array<Maybe<ProductMove>>>;
  /** Nákup objednávka */
  purchaseOrder?: Maybe<PurchaseOrder>;
  /** Nákup cena */
  purchasePrice?: Maybe<Scalars['Float']['output']>;
  /** Nákup cena All */
  purchasePriceAll?: Maybe<Scalars['Float']['output']>;
  /** Nákup cena All s DPH */
  purchasePriceAllWithVat?: Maybe<Scalars['Float']['output']>;
  /** Nákup cena s DPH */
  purchasePriceWithVat?: Maybe<Scalars['Float']['output']>;
  /** Množství */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** Již naskladněný počet kusů */
  quantityIn?: Maybe<Scalars['Float']['output']>;
  /** Stav */
  status?: Maybe<PurchaseOrderStatus>;
};

export type PurchaseOrderStatus = {
  /** ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Pozice */
  position?: Maybe<Scalars['Int']['output']>;
};

export type Quantity = {
  /** Sklad */
  depot?: Maybe<Depot>;
  /** Množství dostupné */
  quantityAvailable?: Maybe<Scalars['Float']['output']>;
  /** Množství nákup */
  quantityPurchase?: Maybe<Scalars['Float']['output']>;
  /** Množství rezervace */
  quantityReservation?: Maybe<Scalars['Float']['output']>;
  /** Množství skladem */
  quantityStock?: Maybe<Scalars['Float']['output']>;
};

export type Receipt = {
  /** BKP */
  bkp?: Maybe<Scalars['String']['output']>;
  /** ID EET pokladny */
  checkoutEetId?: Maybe<Scalars['Int']['output']>;
  /** Datum vytvoření */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** DIČ */
  dic?: Maybe<Scalars['String']['output']>;
  /** FIK */
  fik?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Číslo */
  number?: Maybe<Scalars['Int']['output']>;
  /** PKP */
  pkp?: Maybe<Scalars['String']['output']>;
  /** Testovací režim */
  playground?: Maybe<Scalars['Boolean']['output']>;
  /** Cena první snížené DPH */
  priceFirstReducedVat?: Maybe<Scalars['Int']['output']>;
  /** Cena pro následné uplatnění */
  priceForSubsequentSettlement?: Maybe<Scalars['Int']['output']>;
  /** Cena druhé snížené DPH */
  priceSecondReducedVat?: Maybe<Scalars['Int']['output']>;
  /** Cena základní DPH */
  priceStandardVat?: Maybe<Scalars['Int']['output']>;
  /** Cena použitá pro následné uplatnění */
  priceUsedSubsequentSettlement?: Maybe<Scalars['Int']['output']>;
  /** Cena nulová DPH */
  priceZeroVat?: Maybe<Scalars['Int']['output']>;
  /** ID EET prodejny */
  shopEetId?: Maybe<Scalars['Int']['output']>;
  /** Cena celkem */
  totalPrice?: Maybe<Scalars['Int']['output']>;
  /** DPH první snížená */
  vatFirstReduced?: Maybe<Scalars['Int']['output']>;
  /** DPH druhá snížená */
  vatSecondReduced?: Maybe<Scalars['Int']['output']>;
  /** DPH základní */
  vatStandard?: Maybe<Scalars['Int']['output']>;
  /** Ověřovací režim */
  verificationMode?: Maybe<Scalars['Boolean']['output']>;
};

export type Role = {
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Role */
  role?: Maybe<Scalars['String']['output']>;
};

export type RootSchemaMutation = {
  cancelReservation?: Maybe<cancelReservation>;
  createAddress?: Maybe<createAddress>;
  createCategory?: Maybe<createCategory>;
  createCert?: Maybe<createCert>;
  createCheckout?: Maybe<createCheckout>;
  createCheckoutClosing?: Maybe<createCheckoutClosing>;
  createCheckoutExtraOperation?: Maybe<createCheckoutExtraOperation>;
  createCompanyCarrier?: Maybe<createCompanyCarrier>;
  createConsent?: Maybe<createConsent>;
  createCustomer?: Maybe<createCustomer>;
  createCustomerConsent?: Maybe<createCustomerConsent>;
  createDepot?: Maybe<createDepot>;
  createDevLog?: Maybe<createDevLog>;
  createDisposal?: Maybe<createDisposal>;
  createEetReceipt?: Maybe<createEetReceipt>;
  createExport?: Maybe<createExport>;
  createExportInventory?: Maybe<createExportInventory>;
  createExportOrder?: Maybe<createExportOrder>;
  createExportPurchase?: Maybe<createExportPurchase>;
  createExportSale?: Maybe<createExportSale>;
  createExportStock?: Maybe<createExportStock>;
  createFile?: Maybe<createFile>;
  createInstitution?: Maybe<createInstitution>;
  createLeaflet?: Maybe<createLeaflet>;
  createOrder?: Maybe<createOrder>;
  createOrderGroup?: Maybe<createOrderGroup>;
  createOrderItem?: Maybe<createOrderItem>;
  createPackage?: Maybe<createPackage>;
  createParameter?: Maybe<createParameter>;
  createPayment?: Maybe<createPayment>;
  createPaymentItem?: Maybe<createPaymentItem>;
  createPriceLevel?: Maybe<createPricePriceLevel>;
  createProducer?: Maybe<createProducer>;
  createProduct?: Maybe<createProduct>;
  createProductBundle?: Maybe<createProductBundle>;
  createProductDepotMetric?: Maybe<createProductDepotMetric>;
  createProductMovePack?: Maybe<createProductMovePack>;
  createProductPack?: Maybe<createProductPack>;
  createProductParameter?: Maybe<createProductParameter>;
  createProductPrice?: Maybe<createProductPrice>;
  createProductPriceLevel?: Maybe<createProductPriceLevel>;
  createPurchaseOrder?: Maybe<createPurchaseOrder>;
  createPurchaseOrderItem?: Maybe<createPurchaseOrderItem>;
  createShop?: Maybe<createShop>;
  createSupplier?: Maybe<createSupplier>;
  createTag?: Maybe<createTag>;
  createUser?: Maybe<createUser>;
  createUserGroup?: Maybe<createUserGroup>;
  createVat?: Maybe<createVat>;
  createVoucher?: Maybe<createVoucher>;
  deleteAddress?: Maybe<deleteAddress>;
  deleteCategory?: Maybe<deleteCategory>;
  deleteCert?: Maybe<deleteCert>;
  deleteCheckout?: Maybe<deleteCheckout>;
  deleteCheckoutClosing?: Maybe<deleteCheckoutClosing>;
  deleteCheckoutExtraOperation?: Maybe<deleteCheckoutExtraOperation>;
  deleteCompany?: Maybe<deleteCompany>;
  deleteCompanyCarrier?: Maybe<deleteCompanyCarrier>;
  deleteConsent?: Maybe<deleteConsent>;
  deleteCustomer?: Maybe<deleteCustomer>;
  deleteCustomerConsent?: Maybe<deleteCustomerConsent>;
  deleteDepot?: Maybe<deleteDepot>;
  deleteDisposal?: Maybe<deleteDisposal>;
  deleteFile?: Maybe<deleteFile>;
  deleteInstitution?: Maybe<deleteInstitution>;
  deleteLeaflet?: Maybe<deleteLeaflet>;
  deleteOrderGroup?: Maybe<deleteOrderGroup>;
  deleteOrderItem?: Maybe<deleteOrderItem>;
  deletePackage?: Maybe<deletePackage>;
  deleteParameter?: Maybe<deleteParameter>;
  deletePayment?: Maybe<deletePayment>;
  deletePaymentItem?: Maybe<deletePaymentItem>;
  deletePriceLevel?: Maybe<deletePriceLevel>;
  deleteProducer?: Maybe<deleteProducer>;
  deleteProduct?: Maybe<deleteProduct>;
  deleteProductBundle?: Maybe<deleteProductBundle>;
  deleteProductDepotMetric?: Maybe<deleteProductDepotMetric>;
  deleteProductMove?: Maybe<deleteProductMove>;
  deleteProductMovePack?: Maybe<deleteProductMovePack>;
  deleteProductPack?: Maybe<deleteProductPack>;
  deleteProductParameter?: Maybe<deleteProductParameter>;
  deleteProductPrice?: Maybe<deleteProductPrice>;
  deleteProductPriceLevel?: Maybe<deleteProductPriceLevel>;
  deletePurchaseOrder?: Maybe<deletePurchaseOrder>;
  deletePurchaseOrderItem?: Maybe<deletePurchaseOrderItem>;
  deleteReservation?: Maybe<deleteReservation>;
  deleteShop?: Maybe<deleteShop>;
  deleteSupplier?: Maybe<deleteSupplier>;
  deleteTag?: Maybe<deleteTag>;
  deleteUser?: Maybe<deleteUser>;
  deleteUserGroup?: Maybe<deleteUserGroup>;
  deleteVat?: Maybe<deleteVat>;
  deleteVoucher?: Maybe<deleteVoucher>;
  refreshExportInventory?: Maybe<refreshExportInventory>;
  refreshProductDepots?: Maybe<refreshProductDepots>;
  resetPackage?: Maybe<resetPackage>;
  sendDisposal?: Maybe<sendDisposal>;
  sendEetReceipt?: Maybe<sendEetReceipt>;
  sendPackage?: Maybe<sendPackage>;
  testCompanyCarrier?: Maybe<testCompanyCarrier>;
  updateAddress?: Maybe<updateAddress>;
  updateCategory?: Maybe<updateCategory>;
  updateCert?: Maybe<updateCert>;
  updateCheckout?: Maybe<updateCheckout>;
  updateCheckoutClosing?: Maybe<updateCheckoutClosing>;
  updateCheckoutExtraOperation?: Maybe<updateCheckoutExtraOperation>;
  updateClearanceItem?: Maybe<updateClearanceItem>;
  updateCompany?: Maybe<updateCompany>;
  updateCompanyCarrier?: Maybe<updateCompanyCarrier>;
  updateConsent?: Maybe<updateConsent>;
  updateCustomer?: Maybe<updateCustomer>;
  updateDepot?: Maybe<updateDepot>;
  updateDisposal?: Maybe<updateDisposal>;
  updateExportInventory?: Maybe<updateExportInventory>;
  updateFile?: Maybe<updateFile>;
  updateInstitution?: Maybe<updateInstitution>;
  updateLeaflet?: Maybe<updateLeaflet>;
  updateOrder?: Maybe<updateOrder>;
  updateOrderGroup?: Maybe<updateOrderGroup>;
  updateOrderItem?: Maybe<updateOrderItem>;
  updatePackage?: Maybe<updatePackage>;
  updateParameter?: Maybe<updateParameter>;
  updatePayment?: Maybe<updatePayment>;
  updatePaymentItem?: Maybe<updatePaymentItem>;
  updatePriceLevel?: Maybe<updatePriceLevel>;
  updateProducer?: Maybe<updateProducer>;
  updateProduct?: Maybe<updateProduct>;
  updateProductBundle?: Maybe<updateProductBundle>;
  updateProductDepot?: Maybe<updateProductDepot>;
  updateProductDepotMetric?: Maybe<updateProductDepotMetric>;
  updateProductMove?: Maybe<updateProductMove>;
  updateProductMovePack?: Maybe<updateProductMovePack>;
  updateProductPack?: Maybe<updateProductPack>;
  updateProductParameter?: Maybe<updateProductParameter>;
  updateProductPrice?: Maybe<updateProductPrice>;
  updateProductPriceLevel?: Maybe<updateProductPriceLevel>;
  updatePurchaseOrder?: Maybe<updatePurchaseOrder>;
  updatePurchaseOrderItem?: Maybe<updatePurchaseOrderItem>;
  updateShop?: Maybe<updateShop>;
  updateSupplier?: Maybe<updateSupplier>;
  updateTag?: Maybe<updateTag>;
  updateUser?: Maybe<updateUser>;
  updateUserGroup?: Maybe<updateUserGroup>;
  updateVat?: Maybe<updateVat>;
  updateVoucher?: Maybe<updateVoucher>;
};


export type RootSchemaMutationcancelReservationArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationcreateAddressArgs = {
  branchId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  customData?: InputMaybe<Scalars['String']['input']>;
  customer?: InputMaybe<Scalars['Int']['input']>;
  dic?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  ic?: InputMaybe<Scalars['String']['input']>;
  isBilling?: InputMaybe<Scalars['Boolean']['input']>;
  isStored?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zasilkovnaAddressId?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationcreateCategoryArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationcreateCertArgs = {
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  pkcs12: Scalars['String']['input'];
};


export type RootSchemaMutationcreateCheckoutArgs = {
  amount?: InputMaybe<Scalars['String']['input']>;
  autoDispatched?: InputMaybe<Scalars['Boolean']['input']>;
  autoPacking?: InputMaybe<Scalars['Boolean']['input']>;
  autoPicking?: InputMaybe<Scalars['Boolean']['input']>;
  billFooter?: InputMaybe<Scalars['String']['input']>;
  depots?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eetEnable?: InputMaybe<Scalars['Boolean']['input']>;
  eetId?: InputMaybe<Scalars['Int']['input']>;
  eetPlayground?: InputMaybe<Scalars['Boolean']['input']>;
  eetVerificationMode?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  eventTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventUrl?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  institution?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  negativeReservation?: InputMaybe<Scalars['Boolean']['input']>;
  nextBillNumber?: InputMaybe<Scalars['Int']['input']>;
  nextReservationNumber?: InputMaybe<Scalars['Int']['input']>;
  payments?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  reservationOnlyOneDepot?: InputMaybe<Scalars['Boolean']['input']>;
  returnsDepot?: InputMaybe<Scalars['Int']['input']>;
  shop?: InputMaybe<Scalars['Int']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type RootSchemaMutationcreateCheckoutClosingArgs = {
  amountClosed?: InputMaybe<Scalars['String']['input']>;
  amountOpen: Scalars['String']['input'];
  amountRealClosed?: InputMaybe<Scalars['String']['input']>;
  amountRealOpen?: InputMaybe<Scalars['String']['input']>;
  checkout: Scalars['Int']['input'];
  dateClosed?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  dateOpen: Scalars['DateTimeAsString']['input'];
  enumeration?: InputMaybe<Scalars['String']['input']>;
  noteClosed?: InputMaybe<Scalars['String']['input']>;
  noteOpen?: InputMaybe<Scalars['String']['input']>;
  userClosed?: InputMaybe<Scalars['Int']['input']>;
  userOpen?: InputMaybe<Scalars['Int']['input']>;
};


export type RootSchemaMutationcreateCheckoutExtraOperationArgs = {
  amount: Scalars['String']['input'];
  checkout: Scalars['Int']['input'];
  dateCreated?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationcreateCompanyCarrierArgs = {
  carrier: Scalars['String']['input'];
  checkout?: InputMaybe<Scalars['Int']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationcreateConsentArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type RootSchemaMutationcreateCustomerArgs = {
  birthday?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  customData?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  minExpirationDays?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  plainPassword?: InputMaybe<Scalars['String']['input']>;
  priceLevel?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  wholesale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootSchemaMutationcreateCustomerConsentArgs = {
  consent: Scalars['Int']['input'];
  customer: Scalars['Int']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationcreateDepotArgs = {
  checkouts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  emailIn?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  institution?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type RootSchemaMutationcreateDevLogArgs = {
  content?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationcreateDisposalArgs = {
  carrier?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['Int']['input']>;
  packages?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type RootSchemaMutationcreateEetReceiptArgs = {
  checkout: Scalars['Int']['input'];
  currency: Scalars['String']['input'];
  dateCreated: Scalars['String']['input'];
  number: Scalars['Int']['input'];
  priceFirstReducedVat?: InputMaybe<Scalars['Int']['input']>;
  priceForSubsequentSettlement?: InputMaybe<Scalars['Int']['input']>;
  priceSecondReducedVat?: InputMaybe<Scalars['Int']['input']>;
  priceStandardVat?: InputMaybe<Scalars['Int']['input']>;
  priceUsedSubsequentSettlement?: InputMaybe<Scalars['Int']['input']>;
  priceZeroVat?: InputMaybe<Scalars['Int']['input']>;
  totalPrice: Scalars['Int']['input'];
  vatFirstReduced?: InputMaybe<Scalars['Int']['input']>;
  vatSecondReduced?: InputMaybe<Scalars['Int']['input']>;
  vatStandard?: InputMaybe<Scalars['Int']['input']>;
};


export type RootSchemaMutationcreateExportArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};


export type RootSchemaMutationcreateExportInventoryArgs = {
  approved?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  depots?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  producers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rejected?: InputMaybe<Scalars['String']['input']>;
  suppliers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type RootSchemaMutationcreateExportOrderArgs = {
  checkouts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dateFrom: Scalars['DateTimeAsString']['input'];
  dateTo: Scalars['DateTimeAsString']['input'];
  format?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationcreateExportPurchaseArgs = {
  checkouts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dateFrom: Scalars['DateTimeAsString']['input'];
  dateTo: Scalars['DateTimeAsString']['input'];
  depots?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  format?: InputMaybe<Scalars['String']['input']>;
  producers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  suppliers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type RootSchemaMutationcreateExportSaleArgs = {
  checkouts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dateFrom: Scalars['DateTimeAsString']['input'];
  dateTo: Scalars['DateTimeAsString']['input'];
  format?: InputMaybe<Scalars['String']['input']>;
  producers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  suppliers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type RootSchemaMutationcreateExportStockArgs = {
  date?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  depots?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  format?: InputMaybe<Scalars['String']['input']>;
  producers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  suppliers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type RootSchemaMutationcreateFileArgs = {
  base64Data: Scalars['String']['input'];
  disposal?: InputMaybe<Scalars['Int']['input']>;
  inventory?: InputMaybe<Scalars['Int']['input']>;
  mimeType: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  originalFilename: Scalars['String']['input'];
  product?: InputMaybe<Scalars['Int']['input']>;
  productMovePack?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrder?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
};


export type RootSchemaMutationcreateInstitutionArgs = {
  checkouts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  depots?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type RootSchemaMutationcreateLeafletArgs = {
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  height?: InputMaybe<Scalars['Int']['input']>;
  product: Scalars['Int']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type RootSchemaMutationcreateOrderArgs = {
  billNumber?: InputMaybe<Scalars['Int']['input']>;
  boxes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  carrierOptions?: InputMaybe<Scalars['String']['input']>;
  checkout: Scalars['Int']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  customer?: InputMaybe<Scalars['Int']['input']>;
  dateBill?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  dateCreated?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  dateDue?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  dateExpedition?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  dateTax?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groupPosition?: InputMaybe<Scalars['Int']['input']>;
  invoiceAddress?: InputMaybe<Scalars['Int']['input']>;
  items?: InputMaybe<Array<InputMaybe<createOrderItem_>>>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paymentItems?: InputMaybe<Array<InputMaybe<createPaymentItem_>>>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  privateNote?: InputMaybe<Scalars['String']['input']>;
  processStatusRelation?: InputMaybe<processStatusRelation>;
  relatedParent?: InputMaybe<Scalars['Int']['input']>;
  reservationNumber?: InputMaybe<Scalars['Int']['input']>;
  rounding?: InputMaybe<Scalars['Float']['input']>;
  shippingAddress?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  vs?: InputMaybe<Scalars['Int']['input']>;
};


export type RootSchemaMutationcreateOrderGroupArgs = {
  name: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  user?: InputMaybe<Scalars['Int']['input']>;
  userPosition?: InputMaybe<Scalars['Int']['input']>;
};


export type RootSchemaMutationcreateOrderItemArgs = {
  batch?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  isForSubsequentSettlement?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  packed?: InputMaybe<Scalars['Boolean']['input']>;
  picked?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  product?: InputMaybe<Scalars['Int']['input']>;
  productDepots?: InputMaybe<Array<InputMaybe<orderItemProductDepot>>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sale?: InputMaybe<Scalars['Float']['input']>;
  serial?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['Int']['input']>;
  voucher?: InputMaybe<Scalars['Int']['input']>;
};


export type RootSchemaMutationcreatePackageArgs = {
  carrier?: InputMaybe<Scalars['String']['input']>;
  dimensionX?: InputMaybe<Scalars['Float']['input']>;
  dimensionY?: InputMaybe<Scalars['Float']['input']>;
  dimensionZ?: InputMaybe<Scalars['Float']['input']>;
  items?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tariff?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};


export type RootSchemaMutationcreateParameterArgs = {
  enumValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationcreatePaymentArgs = {
  dispatchUnpaid?: InputMaybe<Scalars['Boolean']['input']>;
  eetEnable?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationcreatePaymentItemArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkout?: InputMaybe<Scalars['Int']['input']>;
  dateCancelled?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  dateCreated?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  datePaid?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  payment: Scalars['Int']['input'];
  voucher?: InputMaybe<Scalars['Int']['input']>;
};


export type RootSchemaMutationcreatePriceLevelArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  isPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  percent?: InputMaybe<Scalars['Float']['input']>;
  withVat?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootSchemaMutationcreateProducerArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type RootSchemaMutationcreateProductArgs = {
  beforeSellPrice?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  children?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  code2?: InputMaybe<Scalars['String']['input']>;
  code3?: InputMaybe<Scalars['String']['input']>;
  customData?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimensionX?: InputMaybe<Scalars['Float']['input']>;
  dimensionY?: InputMaybe<Scalars['Float']['input']>;
  dimensionZ?: InputMaybe<Scalars['Float']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  ean2?: InputMaybe<Scalars['String']['input']>;
  ean3?: InputMaybe<Scalars['String']['input']>;
  ean4?: InputMaybe<Scalars['String']['input']>;
  ean5?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledBatchExpiration?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  hsCode?: InputMaybe<Scalars['String']['input']>;
  isAdultOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isBundle?: InputMaybe<Scalars['Boolean']['input']>;
  isForSubsequentSettlement?: InputMaybe<Scalars['Boolean']['input']>;
  isFragile?: InputMaybe<Scalars['Boolean']['input']>;
  isOversize?: InputMaybe<Scalars['Boolean']['input']>;
  isPML?: InputMaybe<Scalars['Boolean']['input']>;
  mainCategory?: InputMaybe<Scalars['Int']['input']>;
  mainImage?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  originCountry?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['Int']['input']>;
  perex?: InputMaybe<Scalars['String']['input']>;
  phePrice?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Scalars['Int']['input']>;
  purchaseCurrency?: InputMaybe<Scalars['String']['input']>;
  purchasePrice?: InputMaybe<Scalars['String']['input']>;
  requiredSerialNumbers?: InputMaybe<Scalars['Boolean']['input']>;
  sellPrice?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  vat?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationcreateProductBundleArgs = {
  child: Scalars['Int']['input'];
  parent: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};


export type RootSchemaMutationcreateProductDepotMetricArgs = {
  depot: Scalars['Int']['input'];
  product: Scalars['Int']['input'];
  quantityMaximum?: InputMaybe<Scalars['Int']['input']>;
  quantityMinimum?: InputMaybe<Scalars['Int']['input']>;
  quantityOptimum?: InputMaybe<Scalars['Int']['input']>;
};


export type RootSchemaMutationcreateProductMovePackArgs = {
  checkout?: InputMaybe<Scalars['Int']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  incidentalCosts?: InputMaybe<Scalars['Float']['input']>;
  moves?: InputMaybe<Array<InputMaybe<createProductMove>>>;
  note?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrder?: InputMaybe<Scalars['Int']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  type: Scalars['String']['input'];
};


export type RootSchemaMutationcreateProductPackArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  product: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
};


export type RootSchemaMutationcreateProductParameterArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  parameter: Scalars['Int']['input'];
  product: Scalars['Int']['input'];
  value: Scalars['StringOrArray']['input'];
};


export type RootSchemaMutationcreateProductPriceArgs = {
  available?: InputMaybe<Scalars['Int']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  dateTo?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  product: Scalars['Int']['input'];
  sellPrice?: InputMaybe<Scalars['Float']['input']>;
};


export type RootSchemaMutationcreateProductPriceLevelArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  priceLevel: Scalars['Int']['input'];
  product: Scalars['Int']['input'];
  sellPrice?: InputMaybe<Scalars['Float']['input']>;
};


export type RootSchemaMutationcreatePurchaseOrderArgs = {
  company?: InputMaybe<Scalars['Int']['input']>;
  customData?: InputMaybe<Scalars['String']['input']>;
  dateEstimatedArrival?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  depot: Scalars['Int']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  items: Array<InputMaybe<createPurchaseOrderItem_>>;
  note?: InputMaybe<Scalars['String']['input']>;
  privateNote?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplier: Scalars['Int']['input'];
  supplierReference?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type RootSchemaMutationcreatePurchaseOrderItemArgs = {
  currency: Scalars['String']['input'];
  customData?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  product: Scalars['Int']['input'];
  purchaseOrder: Scalars['Int']['input'];
  purchasePrice?: InputMaybe<Scalars['Float']['input']>;
  quantity: Scalars['Int']['input'];
};


export type RootSchemaMutationcreateShopArgs = {
  cert?: InputMaybe<Scalars['Int']['input']>;
  checkouts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  eetId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationcreateSupplierArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type RootSchemaMutationcreateTagArgs = {
  color?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type RootSchemaMutationcreateUserArgs = {
  checkouts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  depots?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  email: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  groups?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lastName: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  plainPassword?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type RootSchemaMutationcreateUserGroupArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type RootSchemaMutationcreateVatArgs = {
  default: Scalars['Boolean']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  percent: Scalars['String']['input'];
};


export type RootSchemaMutationcreateVoucherArgs = {
  code: Scalars['String']['input'];
  discountPercent?: InputMaybe<Scalars['Float']['input']>;
  discountType: Scalars['String']['input'];
  discountValue?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  isPayment?: InputMaybe<Scalars['Boolean']['input']>;
  maxUse?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  used?: InputMaybe<Scalars['Int']['input']>;
  validFrom?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  validTo?: InputMaybe<Scalars['DateTimeAsString']['input']>;
};


export type RootSchemaMutationdeleteAddressArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteCertArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteCheckoutArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteCheckoutClosingArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteCheckoutExtraOperationArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteCompanyArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteCompanyCarrierArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteConsentArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteCustomerArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteCustomerConsentArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteDepotArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteDisposalArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteFileArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteInstitutionArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteLeafletArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteOrderGroupArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteOrderItemArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeletePackageArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteParameterArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeletePaymentArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeletePaymentItemArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeletePriceLevelArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteProducerArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteProductArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteProductBundleArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteProductDepotMetricArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteProductMoveArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteProductMovePackArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteProductPackArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteProductParameterArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteProductPriceArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteProductPriceLevelArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeletePurchaseOrderArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeletePurchaseOrderItemArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteReservationArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteShopArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteSupplierArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteTagArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteUserArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteUserGroupArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteVatArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationdeleteVoucherArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationrefreshExportInventoryArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationrefreshProductDepotsArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationresetPackageArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationsendDisposalArgs = {
  id: Scalars['String']['input'];
};


export type RootSchemaMutationsendEetReceiptArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationsendPackageArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationtestCompanyCarrierArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaMutationupdateAddressArgs = {
  branchId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customData?: InputMaybe<Scalars['String']['input']>;
  customer?: InputMaybe<Scalars['Int']['input']>;
  dic?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  ic?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isBilling?: InputMaybe<Scalars['Boolean']['input']>;
  isStored?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zasilkovnaAddressId?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationupdateCategoryArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationupdateCertArgs = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationupdateCheckoutArgs = {
  amount?: InputMaybe<Scalars['String']['input']>;
  autoDispatched?: InputMaybe<Scalars['Boolean']['input']>;
  autoPacking?: InputMaybe<Scalars['Boolean']['input']>;
  autoPicking?: InputMaybe<Scalars['Boolean']['input']>;
  billFooter?: InputMaybe<Scalars['String']['input']>;
  depots?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eetEnable?: InputMaybe<Scalars['Boolean']['input']>;
  eetId?: InputMaybe<Scalars['Int']['input']>;
  eetPlayground?: InputMaybe<Scalars['Boolean']['input']>;
  eetVerificationMode?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  eventTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventUrl?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  institution?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  negativeReservation?: InputMaybe<Scalars['Boolean']['input']>;
  nextBillNumber?: InputMaybe<Scalars['Int']['input']>;
  nextReservationNumber?: InputMaybe<Scalars['Int']['input']>;
  payments?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  reservationOnlyOneDepot?: InputMaybe<Scalars['Boolean']['input']>;
  returnsDepot?: InputMaybe<Scalars['Int']['input']>;
  shop?: InputMaybe<Scalars['Int']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type RootSchemaMutationupdateCheckoutClosingArgs = {
  amountClosed?: InputMaybe<Scalars['String']['input']>;
  amountOpen?: InputMaybe<Scalars['String']['input']>;
  amountRealClosed?: InputMaybe<Scalars['String']['input']>;
  amountRealOpen?: InputMaybe<Scalars['String']['input']>;
  checkout?: InputMaybe<Scalars['Int']['input']>;
  dateClosed?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  dateOpen?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  enumeration?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  noteClosed?: InputMaybe<Scalars['String']['input']>;
  noteOpen?: InputMaybe<Scalars['String']['input']>;
  userClosed?: InputMaybe<Scalars['Int']['input']>;
  userOpen?: InputMaybe<Scalars['Int']['input']>;
};


export type RootSchemaMutationupdateCheckoutExtraOperationArgs = {
  amount?: InputMaybe<Scalars['String']['input']>;
  checkout?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  id: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationupdateClearanceItemArgs = {
  id: Scalars['String']['input'];
  locations?: InputMaybe<Array<InputMaybe<updateClearanceItemLocations>>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  orderGroup?: InputMaybe<Scalars['Int']['input']>;
  orderItem?: InputMaybe<Scalars['Int']['input']>;
  package?: InputMaybe<Scalars['Int']['input']>;
  packed?: InputMaybe<Scalars['Int']['input']>;
  picked?: InputMaybe<Scalars['Int']['input']>;
};


export type RootSchemaMutationupdateCompanyArgs = {
  batchExpirationMode?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customOptions?: InputMaybe<Scalars['String']['input']>;
  defaultVoucherValidity?: InputMaybe<Scalars['Int']['input']>;
  dic?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabledPositions?: InputMaybe<Scalars['Boolean']['input']>;
  ic?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  logo?: InputMaybe<Scalars['Int']['input']>;
  multiPurposeVouchers?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextCode?: InputMaybe<Scalars['Int']['input']>;
  nextEan?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  registrationNote?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationupdateCompanyCarrierArgs = {
  carrier?: InputMaybe<Scalars['String']['input']>;
  checkout?: InputMaybe<Scalars['Int']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  options?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationupdateConsentArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationupdateCustomerArgs = {
  birthday?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  customData?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  minExpirationDays?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  plainPassword?: InputMaybe<Scalars['String']['input']>;
  priceLevel?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  wholesale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootSchemaMutationupdateDepotArgs = {
  checkouts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  emailIn?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  institution?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type RootSchemaMutationupdateDisposalArgs = {
  carrier?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  packages?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type RootSchemaMutationupdateExportInventoryArgs = {
  approved?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  depots?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id: Scalars['Int']['input'];
  producers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rejected?: InputMaybe<Scalars['String']['input']>;
  suppliers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type RootSchemaMutationupdateFileArgs = {
  base64Data?: InputMaybe<Scalars['String']['input']>;
  disposal?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  inventory?: InputMaybe<Scalars['Int']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  originalFilename?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['Int']['input']>;
  productMovePack?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrder?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationupdateInstitutionArgs = {
  checkouts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  depots?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationupdateLeafletArgs = {
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  product?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type RootSchemaMutationupdateOrderArgs = {
  billNumber?: InputMaybe<Scalars['Int']['input']>;
  boxes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  carrierOptions?: InputMaybe<Scalars['String']['input']>;
  checkout?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customer?: InputMaybe<Scalars['Int']['input']>;
  dateBill?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  dateCreated?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  dateDue?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  dateExpedition?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  dateTax?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groupPosition?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  invoiceAddress?: InputMaybe<Scalars['Int']['input']>;
  items?: InputMaybe<Array<InputMaybe<updateOrderItem_>>>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paymentItems?: InputMaybe<Array<InputMaybe<updatePaymentItem_>>>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  privateNote?: InputMaybe<Scalars['String']['input']>;
  processStatusRelation?: InputMaybe<processStatusRelation>;
  relatedParent?: InputMaybe<Scalars['Int']['input']>;
  reservationNumber?: InputMaybe<Scalars['Int']['input']>;
  rounding?: InputMaybe<Scalars['Float']['input']>;
  shippingAddress?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  vs?: InputMaybe<Scalars['Int']['input']>;
};


export type RootSchemaMutationupdateOrderGroupArgs = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  user?: InputMaybe<Scalars['Int']['input']>;
  userPosition?: InputMaybe<Scalars['Int']['input']>;
};


export type RootSchemaMutationupdateOrderItemArgs = {
  batch?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isForSubsequentSettlement?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  packed?: InputMaybe<Scalars['Boolean']['input']>;
  picked?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  product?: InputMaybe<Scalars['Int']['input']>;
  productDepots?: InputMaybe<Array<InputMaybe<orderItemProductDepot>>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sale?: InputMaybe<Scalars['Float']['input']>;
  serial?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['Int']['input']>;
  voucher?: InputMaybe<Scalars['Int']['input']>;
};


export type RootSchemaMutationupdatePackageArgs = {
  carrier?: InputMaybe<Scalars['String']['input']>;
  dimensionX?: InputMaybe<Scalars['Float']['input']>;
  dimensionY?: InputMaybe<Scalars['Float']['input']>;
  dimensionZ?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  items?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  tariff?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};


export type RootSchemaMutationupdateParameterArgs = {
  enumValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationupdatePaymentArgs = {
  dispatchUnpaid?: InputMaybe<Scalars['Boolean']['input']>;
  eetEnable?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationupdatePaymentItemArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkout?: InputMaybe<Scalars['Int']['input']>;
  dateCancelled?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  dateCreated?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  datePaid?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  payment?: InputMaybe<Scalars['Int']['input']>;
  voucher?: InputMaybe<Scalars['Int']['input']>;
};


export type RootSchemaMutationupdatePriceLevelArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percent?: InputMaybe<Scalars['Float']['input']>;
  withVat?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootSchemaMutationupdateProducerArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationupdateProductArgs = {
  beforeSellPrice?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  children?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  code2?: InputMaybe<Scalars['String']['input']>;
  code3?: InputMaybe<Scalars['String']['input']>;
  customData?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimensionX?: InputMaybe<Scalars['Float']['input']>;
  dimensionY?: InputMaybe<Scalars['Float']['input']>;
  dimensionZ?: InputMaybe<Scalars['Float']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  ean2?: InputMaybe<Scalars['String']['input']>;
  ean3?: InputMaybe<Scalars['String']['input']>;
  ean4?: InputMaybe<Scalars['String']['input']>;
  ean5?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledBatchExpiration?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  hsCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isAdultOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isBundle?: InputMaybe<Scalars['Boolean']['input']>;
  isForSubsequentSettlement?: InputMaybe<Scalars['Boolean']['input']>;
  isFragile?: InputMaybe<Scalars['Boolean']['input']>;
  isOversize?: InputMaybe<Scalars['Boolean']['input']>;
  isPML?: InputMaybe<Scalars['Boolean']['input']>;
  mainCategory?: InputMaybe<Scalars['Int']['input']>;
  mainImage?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  originCountry?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['Int']['input']>;
  perex?: InputMaybe<Scalars['String']['input']>;
  phePrice?: InputMaybe<Scalars['String']['input']>;
  producer?: InputMaybe<Scalars['Int']['input']>;
  purchaseCurrency?: InputMaybe<Scalars['String']['input']>;
  purchasePrice?: InputMaybe<Scalars['String']['input']>;
  requiredSerialNumbers?: InputMaybe<Scalars['Boolean']['input']>;
  sellPrice?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  vat?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationupdateProductBundleArgs = {
  child?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  parent?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};


export type RootSchemaMutationupdateProductDepotArgs = {
  batch?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  id: Scalars['Int']['input'];
  inventoryQuantityStock?: InputMaybe<Scalars['Float']['input']>;
  position1?: InputMaybe<Scalars['String']['input']>;
  position2?: InputMaybe<Scalars['String']['input']>;
  position3?: InputMaybe<Scalars['String']['input']>;
  purchasePrice?: InputMaybe<Scalars['Float']['input']>;
  supplier?: InputMaybe<Scalars['Int']['input']>;
};


export type RootSchemaMutationupdateProductDepotMetricArgs = {
  id: Scalars['Int']['input'];
  quantityMaximum?: InputMaybe<Scalars['Int']['input']>;
  quantityMinimum?: InputMaybe<Scalars['Int']['input']>;
  quantityOptimum?: InputMaybe<Scalars['Int']['input']>;
};


export type RootSchemaMutationupdateProductMoveArgs = {
  id: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  serialNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type RootSchemaMutationupdateProductMovePackArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type RootSchemaMutationupdateProductPackArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  product: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
};


export type RootSchemaMutationupdateProductParameterArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  parameter: Scalars['Int']['input'];
  product: Scalars['Int']['input'];
  value?: InputMaybe<Scalars['StringOrArray']['input']>;
};


export type RootSchemaMutationupdateProductPriceArgs = {
  available?: InputMaybe<Scalars['Int']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  dateTo?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  id: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  product: Scalars['Int']['input'];
  sellPrice?: InputMaybe<Scalars['Float']['input']>;
};


export type RootSchemaMutationupdateProductPriceLevelArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  priceLevel: Scalars['Int']['input'];
  product: Scalars['Int']['input'];
  sellPrice?: InputMaybe<Scalars['Float']['input']>;
};


export type RootSchemaMutationupdatePurchaseOrderArgs = {
  customData?: InputMaybe<Scalars['String']['input']>;
  dateEstimatedArrival?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  depot?: InputMaybe<Scalars['Int']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id: Scalars['Int']['input'];
  items?: InputMaybe<Array<InputMaybe<updatePurchaseOrderItem_>>>;
  note?: InputMaybe<Scalars['String']['input']>;
  privateNote?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['Int']['input']>;
  supplierReference?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type RootSchemaMutationupdatePurchaseOrderItemArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  customData?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['Int']['input']>;
  purchasePrice?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationupdateShopArgs = {
  cert?: InputMaybe<Scalars['Int']['input']>;
  checkouts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  eetId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationupdateSupplierArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationupdateTagArgs = {
  color?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationupdateUserArgs = {
  checkouts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  depots?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id: Scalars['Int']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  plainPassword?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type RootSchemaMutationupdateUserGroupArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type RootSchemaMutationupdateVatArgs = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  percent?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaMutationupdateVoucherArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  discountPercent?: InputMaybe<Scalars['Float']['input']>;
  discountType?: InputMaybe<Scalars['String']['input']>;
  discountValue?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isPayment?: InputMaybe<Scalars['Boolean']['input']>;
  maxUse?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  used?: InputMaybe<Scalars['Int']['input']>;
  validFrom?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  validTo?: InputMaybe<Scalars['DateTimeAsString']['input']>;
};

export type RootSchemaQuery = {
  address?: Maybe<address>;
  addresses?: Maybe<addresses>;
  carriers?: Maybe<carriers>;
  categories?: Maybe<categories>;
  category?: Maybe<category>;
  cert?: Maybe<cert>;
  certs?: Maybe<certs>;
  checkout?: Maybe<checkout>;
  checkoutClosing?: Maybe<checkoutClosing>;
  checkoutClosings?: Maybe<checkoutClosings>;
  checkoutExtraOperation?: Maybe<checkoutExtraOperation>;
  checkoutExtraOperations?: Maybe<checkoutExtraOperations>;
  checkouts?: Maybe<checkouts>;
  clearanceItem?: Maybe<clearanceItem>;
  company?: Maybe<company>;
  companyCarrier?: Maybe<companyCarrier>;
  companyCarriers?: Maybe<companyCarriers>;
  consent?: Maybe<consent>;
  consents?: Maybe<consents>;
  currencies?: Maybe<currencies>;
  currencyRate?: Maybe<currencyRate>;
  customer?: Maybe<customer>;
  customers?: Maybe<customers>;
  depot?: Maybe<depot>;
  depots?: Maybe<depots>;
  disposal?: Maybe<disposal>;
  disposals?: Maybe<disposals>;
  eetReceipts?: Maybe<eetReceipts>;
  eventTypes?: Maybe<eventTypes>;
  export?: Maybe<depotoExport>;
  exportInventories?: Maybe<exportInventories>;
  exportInventory?: Maybe<exportInventory>;
  exportOrders?: Maybe<exportOrders>;
  exportPurchases?: Maybe<exportPurchases>;
  exportSales?: Maybe<exportSales>;
  exportStocks?: Maybe<exportStocks>;
  exportTypes?: Maybe<exportTypes>;
  exports?: Maybe<exports>;
  file?: Maybe<file>;
  files?: Maybe<files>;
  institution?: Maybe<institution>;
  institutions?: Maybe<institutions>;
  isUserEmailUnique?: Maybe<isUserEmailUnique>;
  leaflet?: Maybe<leaflet>;
  leaflets?: Maybe<leaflets>;
  loggableHistory?: Maybe<loggableHistoryResult>;
  modules?: Maybe<modules>;
  nextCode?: Maybe<nextCode>;
  nextEan?: Maybe<nextEan>;
  order?: Maybe<order>;
  orderGroup?: Maybe<orderGroup>;
  orderGroups?: Maybe<orderGroups>;
  orderItem?: Maybe<orderItem>;
  orderItems?: Maybe<orderItems>;
  orders?: Maybe<orders>;
  package?: Maybe<depotoPackage>;
  packages?: Maybe<packages>;
  parameter?: Maybe<parameter>;
  parameters?: Maybe<parameters>;
  payment?: Maybe<payment>;
  paymentItem?: Maybe<paymentItem>;
  paymentItems?: Maybe<paymentItems>;
  paymentTypes?: Maybe<paymentTypes>;
  payments?: Maybe<payments>;
  priceLevel?: Maybe<priceLevel>;
  priceLevels?: Maybe<priceLevels>;
  processStatuses?: Maybe<processStatuses>;
  producer?: Maybe<producer>;
  producers?: Maybe<producers>;
  product?: Maybe<product>;
  productDepot?: Maybe<productDepot>;
  productDepotMetric?: Maybe<productDepotMetric>;
  productDepotMetrics?: Maybe<productDepotMetrics>;
  productDepots?: Maybe<productDepots>;
  productMovePack?: Maybe<productMovePack>;
  productMovePacks?: Maybe<productMovePacks>;
  productMovePurposes?: Maybe<productMovePurposes>;
  productMoves?: Maybe<productMoves>;
  productPack?: Maybe<productPack>;
  productPacks?: Maybe<productPacks>;
  productParameter?: Maybe<productParameter>;
  productParameters?: Maybe<productParameters>;
  productPriceLevel?: Maybe<productPriceLevel>;
  productPriceLevels?: Maybe<productPriceLevels>;
  productPrices?: Maybe<productPrices>;
  productPurchasePrice?: Maybe<productPurchasePrice>;
  productSellItems?: Maybe<productSellItems>;
  productSellPrice?: Maybe<productSellPrice>;
  products?: Maybe<products>;
  productsOtherCompanies?: Maybe<productsOtherCompanies>;
  purchaseOrder?: Maybe<purchaseOrder>;
  purchaseOrderItem?: Maybe<purchaseOrderItem>;
  purchaseOrderItems?: Maybe<purchaseOrderItems>;
  purchaseOrderStatuses?: Maybe<purchaseOrderStatuses>;
  purchaseOrders?: Maybe<purchaseOrders>;
  roles?: Maybe<Array<Maybe<Role>>>;
  shop?: Maybe<shop>;
  shops?: Maybe<shops>;
  soldItems?: Maybe<soldItems>;
  stats?: Maybe<packageStats>;
  statsBestsellers?: Maybe<statsBestsellers>;
  statsCarrierUsage?: Maybe<statsCarrierUsage>;
  statsPaymentSales?: Maybe<statsPaymentSales>;
  supplier?: Maybe<supplier>;
  suppliers?: Maybe<suppliers>;
  tag?: Maybe<tag>;
  tagTypes?: Maybe<tagTypes>;
  tags?: Maybe<tags>;
  user?: Maybe<user>;
  userGroup?: Maybe<userGroup>;
  userGroups?: Maybe<userGroups>;
  userMyProfile?: Maybe<userMyProfile>;
  users?: Maybe<users>;
  vat?: Maybe<vat>;
  vats?: Maybe<vats>;
  voucher?: Maybe<voucher>;
  vouchers?: Maybe<vouchers>;
};


export type RootSchemaQueryaddressArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQueryaddressesArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<addressesFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQuerycarriersArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<carriersFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQuerycategoriesArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<categoryFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQuerycategoryArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQuerycertArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQuerycertsArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<filters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQuerycheckoutArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQuerycheckoutClosingArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQuerycheckoutClosingsArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<checkoutClosingFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQuerycheckoutExtraOperationArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQuerycheckoutExtraOperationsArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<checkoutExtraOperationFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQuerycheckoutsArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<checkoutFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryclearanceItemArgs = {
  id: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  orderGroup?: InputMaybe<Scalars['Int']['input']>;
  orderItem?: InputMaybe<Scalars['Int']['input']>;
  package?: InputMaybe<Scalars['Int']['input']>;
};


export type RootSchemaQuerycompanyArgs = {
  id: Scalars['String']['input'];
};


export type RootSchemaQuerycompanyCarrierArgs = {
  id: Scalars['String']['input'];
};


export type RootSchemaQuerycompanyCarriersArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<companyCarrierFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryconsentArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQueryconsentsArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<consentsFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQuerycurrenciesArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<currenciesFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQuerycurrencyRateArgs = {
  currency: Scalars['String']['input'];
  date: Scalars['DateTimeAsString']['input'];
};


export type RootSchemaQuerycustomerArgs = {
  id: Scalars['String']['input'];
};


export type RootSchemaQuerycustomersArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<customerFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQuerydepotArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQuerydepotsArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<depotFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQuerydisposalArgs = {
  id: Scalars['String']['input'];
};


export type RootSchemaQuerydisposalsArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<disposalFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryeetReceiptsArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<eetReceiptFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQuerydepotoExportArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQueryexportInventoriesArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<exportInventoryFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryexportInventoryArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQueryexportOrdersArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<exportOrderFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryexportPurchasesArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<exportPurchaseFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryexportSalesArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<exportSaleFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryexportStocksArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<exportStockFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryexportTypesArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<exportTypeFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryexportsArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<exportFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryfileArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQueryfilesArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<fileFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryinstitutionArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQueryinstitutionsArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<institutionFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryisUserEmailUniqueArgs = {
  email: Scalars['String']['input'];
};


export type RootSchemaQueryleafletArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQueryleafletsArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<leafletFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryloggableHistoryArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  objectClass: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQuerymodulesArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<modulesFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryorderArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQueryorderGroupArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQueryorderGroupsArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<orderGroupFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryorderItemArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQueryorderItemsArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<orderItemFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryordersArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<orderFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQuerydepotoPackageArgs = {
  id: Scalars['String']['input'];
};


export type RootSchemaQuerypackagesArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<packageFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryparameterArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQueryparametersArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<parametersFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQuerypaymentArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQuerypaymentItemArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQuerypaymentItemsArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<paymentItemsFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQuerypaymentTypesArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<paymentTypeFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQuerypaymentsArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<paymentFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQuerypriceLevelArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQuerypriceLevelsArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<priceLevelFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryprocessStatusesArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<processStatusesFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryproducerArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQueryproducersArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<producerFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryproductArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQueryproductDepotArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQueryproductDepotMetricArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQueryproductDepotMetricsArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<productDepotMetricFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryproductDepotsArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<productDepotFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryproductMovePackArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQueryproductMovePacksArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<productMovePackFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryproductMovePurposesArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<productMovePurposesFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryproductMovesArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<productMoveFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryproductPackArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQueryproductPacksArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<productPackFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryproductParameterArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQueryproductParametersArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<productParameterFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryproductPriceLevelArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQueryproductPriceLevelsArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<productPriceLevelFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryproductPricesArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<productPriceFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryproductPurchasePriceArgs = {
  depot: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};


export type RootSchemaQueryproductSellItemsArgs = {
  checkout?: InputMaybe<Scalars['Int']['input']>;
  depots?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  product: Scalars['Int']['input'];
};


export type RootSchemaQueryproductSellPriceArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  priceLevel?: InputMaybe<Scalars['Int']['input']>;
  product: Scalars['Int']['input'];
};


export type RootSchemaQueryproductsArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyDate?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<productFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryproductsOtherCompaniesArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyDate?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<productFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQuerypurchaseOrderArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQuerypurchaseOrderItemArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQuerypurchaseOrderItemsArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<purchaseOrderItemFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQuerypurchaseOrderStatusesArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<purchaseOrderStatusesFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQuerypurchaseOrdersArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<purchaseOrderFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryshopArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQueryshopsArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<shopFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQuerysoldItemsArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<soldItemFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQuerystatsArgs = {
  filters?: InputMaybe<packageStatsFilters>;
};


export type RootSchemaQuerystatsBestsellersArgs = {
  checkout?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['DateTimeAsString']['input'];
  results?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<statsBestsellersSort>;
  status?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTimeAsString']['input'];
};


export type RootSchemaQuerystatsCarrierUsageArgs = {
  checkout?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['DateTimeAsString']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTimeAsString']['input'];
};


export type RootSchemaQuerystatsPaymentSalesArgs = {
  checkout?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['DateTimeAsString']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTimeAsString']['input'];
};


export type RootSchemaQuerysupplierArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQuerysuppliersArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<supplierFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQuerytagArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQuerytagTypesArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<tagTypeFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQuerytagsArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<tagFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryuserArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQueryuserGroupArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQueryuserGroupsArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<userGroupFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryusersArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<userFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryvatArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQueryvatsArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<vatFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type RootSchemaQueryvoucherArgs = {
  id: Scalars['Int']['input'];
};


export type RootSchemaQueryvouchersArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<voucherFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type Sale = {
  /** Pokladny */
  checkouts?: Maybe<Array<Maybe<Checkout>>>;
  /** Vytvoření */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** Datum od */
  dateFrom?: Maybe<Scalars['DateTime']['output']>;
  /** Datum do */
  dateTo?: Maybe<Scalars['DateTime']['output']>;
  /** Formát */
  format?: Maybe<Scalars['String']['output']>;
  /** Vygenerováno */
  generated?: Maybe<Scalars['DateTime']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Značky */
  producers?: Maybe<Array<Maybe<Producer>>>;
  /** Dodavatelé */
  suppliers?: Maybe<Array<Maybe<Supplier>>>;
  /** URL */
  url?: Maybe<Scalars['String']['output']>;
};

export type SellItem = {
  /** Šarže */
  batch?: Maybe<Scalars['String']['output']>;
  /** Datum expirace */
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Produkt */
  product?: Maybe<Product>;
  /** Sklady produktu */
  productDepots?: Maybe<Array<Maybe<ProductDepot>>>;
  /** Množství dostupné */
  quantityAvailable?: Maybe<Scalars['Int']['output']>;
  /** Množství rezervace */
  quantityReservation?: Maybe<Scalars['Int']['output']>;
  /** Množství skladem */
  quantityStock?: Maybe<Scalars['Int']['output']>;
};

export type SellPrice = {
  /** Prodejní cena */
  sellPrice?: Maybe<Scalars['Float']['output']>;
  /** Prodejní cena bez DPH */
  sellPriceWithoutVat?: Maybe<Scalars['Float']['output']>;
};

export type Shop = {
  /** Certifikát */
  cert?: Maybe<Cert>;
  /** Pokladny */
  checkouts?: Maybe<Array<Maybe<Checkout>>>;
  /** Město */
  city?: Maybe<Scalars['String']['output']>;
  /** Společnost */
  company?: Maybe<Company>;
  /** Země */
  country?: Maybe<Scalars['String']['output']>;
  /** EET ID */
  eetId?: Maybe<Scalars['Int']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Ulice */
  street?: Maybe<Scalars['String']['output']>;
  /** PSČ */
  zip?: Maybe<Scalars['String']['output']>;
};

export type SoldItem = {
  /** Kód */
  code?: Maybe<Scalars['String']['output']>;
  /** EAN */
  ean?: Maybe<Scalars['String']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Cena celkem */
  priceAll?: Maybe<Scalars['Float']['output']>;
  /** Cena celkem bez DPH */
  priceAllWithoutVat?: Maybe<Scalars['Float']['output']>;
  /** Produkt */
  product?: Maybe<Product>;
  /** Zisk */
  profit?: Maybe<Scalars['Float']['output']>;
  /** Množství */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** Typ */
  type?: Maybe<Scalars['String']['output']>;
};

export type Stock = {
  /** Vytvoření */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** Datum */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** Sklady */
  depots?: Maybe<Array<Maybe<Depot>>>;
  /** Formát */
  format?: Maybe<Scalars['String']['output']>;
  /** Vygenerováno */
  generated?: Maybe<Scalars['DateTime']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Značky */
  producers?: Maybe<Array<Maybe<Producer>>>;
  /** Dodavatelé */
  suppliers?: Maybe<Array<Maybe<Supplier>>>;
  /** URL */
  url?: Maybe<Scalars['String']['output']>;
};

export type Supplier = {
  /** Společnost */
  company?: Maybe<Company>;
  /** Lze smazat */
  deletable?: Maybe<Scalars['Boolean']['output']>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
};

export type Tag = {
  /** Barva */
  color?: Maybe<Scalars['String']['output']>;
  /** Společnost */
  company?: Maybe<Company>;
  /** Vytvoření */
  created?: Maybe<Scalars['DateTimeAsString']['output']>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Typ */
  type?: Maybe<Scalars['String']['output']>;
  /** Aktualizace */
  updated?: Maybe<Scalars['DateTimeAsString']['output']>;
};

export type TagType = {
  /** ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
};

export type Tariff = {
  /** ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
};

export type User = {
  /** Pokladny */
  checkouts?: Maybe<Array<Maybe<Checkout>>>;
  /** Společnost */
  company?: Maybe<Company>;
  /** Zákazníci */
  customers?: Maybe<Array<Maybe<Customer>>>;
  /** Lze smazat */
  deletable?: Maybe<Scalars['Boolean']['output']>;
  /** Sklady */
  depots?: Maybe<Array<Maybe<Depot>>>;
  /** E-mail */
  email?: Maybe<Scalars['String']['output']>;
  /** Povoleno */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Jméno */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Skupiny */
  groups?: Maybe<Array<Maybe<UserGroup>>>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Příjmení */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Jazyk */
  locale?: Maybe<Scalars['String']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Telefon */
  phone?: Maybe<Scalars['String']['output']>;
  /** PIN */
  pin?: Maybe<Scalars['String']['output']>;
  /** Role */
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UserGroup = {
  /** Společnost */
  company?: Maybe<Company>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Role */
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Vat = {
  /** Koeficient */
  coefficient?: Maybe<Scalars['Float']['output']>;
  /** Společnost */
  company?: Maybe<Company>;
  /** Vytvoření */
  created?: Maybe<Scalars['DateTimeAsString']['output']>;
  /** Výchozí */
  default?: Maybe<Scalars['Boolean']['output']>;
  /** Lze smazat */
  deletable?: Maybe<Scalars['Boolean']['output']>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Procenta */
  percent?: Maybe<Scalars['Float']['output']>;
  /** Aktualizace */
  updated?: Maybe<Scalars['DateTimeAsString']['output']>;
};

export type VatAllocation = {
  /** Cena */
  price?: Maybe<Scalars['Float']['output']>;
  /** Cena bez DPH */
  priceWithoutVat?: Maybe<Scalars['Float']['output']>;
  /** DPH */
  vat?: Maybe<Vat>;
  /** Částka DPH */
  vatPrice?: Maybe<Scalars['Float']['output']>;
};

export type Voucher = {
  /** Kód */
  code?: Maybe<Scalars['String']['output']>;
  /** Společnost */
  company?: Maybe<Company>;
  /** Procento slevy */
  discountPercent?: Maybe<Scalars['Float']['output']>;
  /** Typ slevy */
  discountType?: Maybe<Scalars['String']['output']>;
  /** Hodnota slevy */
  discountValue?: Maybe<Scalars['Float']['output']>;
  /** Povoleno */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Externí identifikátor */
  externalId?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Je platba */
  isPayment?: Maybe<Scalars['Boolean']['output']>;
  /** Platný */
  isValid?: Maybe<Scalars['Boolean']['output']>;
  /** Max. použití */
  maxUse?: Maybe<Scalars['Int']['output']>;
  /** Název */
  name?: Maybe<Scalars['String']['output']>;
  /** Položky objednávky */
  orderItems?: Maybe<Array<Maybe<Product>>>;
  /** Položky plateb */
  paymentItems?: Maybe<Array<Maybe<Product>>>;
  /** Produkt */
  product?: Maybe<Product>;
  /** Použito */
  used?: Maybe<Scalars['Int']['output']>;
  /** Platné od */
  validFrom?: Maybe<Scalars['DateTimeAsString']['output']>;
  /** Platné do */
  validTo?: Maybe<Scalars['DateTimeAsString']['output']>;
};

export type address = {
  data?: Maybe<Address>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type addresses = {
  items?: Maybe<Array<Maybe<Address>>>;
  paginator?: Maybe<Paginator>;
};

export type addressesFilters = {
  customer?: InputMaybe<Scalars['Int']['input']>;
  dic?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  ic?: InputMaybe<Scalars['String']['input']>;
  isBilling?: InputMaybe<Scalars['Boolean']['input']>;
  isStored?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type cancelReservation = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type carriers = {
  items?: Maybe<Array<Maybe<Carrier>>>;
  paginator?: Maybe<Paginator>;
};

export type carriersFilters = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type categories = {
  items?: Maybe<Array<Maybe<Category>>>;
  paginator?: Maybe<Paginator>;
};

export type category = {
  data?: Maybe<Category>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type categoryFilters = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  hasParent?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tagsNegate?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type cert = {
  data?: Maybe<Cert>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type certs = {
  items?: Maybe<Array<Maybe<Cert>>>;
  paginator?: Maybe<Paginator>;
};

export type checkout = {
  data?: Maybe<Checkout>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type checkoutClosing = {
  data?: Maybe<CheckoutClosing>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type checkoutClosingFilters = {
  checkouts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type checkoutClosings = {
  items?: Maybe<Array<Maybe<CheckoutClosing>>>;
  paginator?: Maybe<Paginator>;
};

export type checkoutExtraOperation = {
  data?: Maybe<CheckoutExtraOperation>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type checkoutExtraOperationFilters = {
  checkout?: InputMaybe<Scalars['Int']['input']>;
  checkoutClosing?: InputMaybe<Scalars['Int']['input']>;
  checkouts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type checkoutExtraOperations = {
  items?: Maybe<Array<Maybe<CheckoutExtraOperation>>>;
  paginator?: Maybe<Paginator>;
};

export type checkoutFilters = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type checkouts = {
  items?: Maybe<Array<Maybe<Checkout>>>;
  paginator?: Maybe<Paginator>;
};

export type clearanceItem = {
  data?: Maybe<ClearanceItem>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type company = {
  data?: Maybe<Company>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type companyCarrier = {
  data?: Maybe<CompanyCarrier>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type companyCarrierFilters = {
  carrier?: InputMaybe<Scalars['String']['input']>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
};

export type companyCarriers = {
  items?: Maybe<Array<Maybe<CompanyCarrier>>>;
  paginator?: Maybe<Paginator>;
};

export type consent = {
  data?: Maybe<Consent>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type consents = {
  items?: Maybe<Array<Maybe<Consent>>>;
  paginator?: Maybe<Paginator>;
};

export type consentsFilters = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type createAddress = {
  data?: Maybe<Address>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createCategory = {
  data?: Maybe<Category>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createCert = {
  data?: Maybe<Cert>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createCheckout = {
  data?: Maybe<Checkout>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createCheckoutClosing = {
  data?: Maybe<CheckoutClosing>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createCheckoutExtraOperation = {
  data?: Maybe<CheckoutExtraOperation>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createCompanyCarrier = {
  data?: Maybe<CompanyCarrier>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createConsent = {
  data?: Maybe<Consent>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createCustomer = {
  data?: Maybe<Customer>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createCustomerConsent = {
  data?: Maybe<CustomerConsent>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createDepot = {
  data?: Maybe<Depot>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createDevLog = {
  data?: Maybe<DevLog>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createDisposal = {
  data?: Maybe<PackageDisposal>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createEetReceipt = {
  data?: Maybe<Receipt>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createExport = {
  data?: Maybe<DepotoExport>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createExportInventory = {
  data?: Maybe<Inventory>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createExportOrder = {
  data?: Maybe<exportOrder>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createExportPurchase = {
  data?: Maybe<Purchase>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createExportSale = {
  data?: Maybe<Sale>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createExportStock = {
  data?: Maybe<Stock>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createFile = {
  data?: Maybe<File>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createInstitution = {
  data?: Maybe<Institution>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createLeaflet = {
  data?: Maybe<Leaflet>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createOrder = {
  data?: Maybe<Order>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createOrderGroup = {
  data?: Maybe<OrderGroup>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createOrderItem = {
  data?: Maybe<OrderItem>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createOrderItem_ = {
  batch?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  isForSubsequentSettlement?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  packed?: InputMaybe<Scalars['Boolean']['input']>;
  picked?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  product?: InputMaybe<Scalars['Int']['input']>;
  productDepots?: InputMaybe<Array<InputMaybe<orderItemProductDepot>>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sale?: InputMaybe<Scalars['Float']['input']>;
  serial?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['Int']['input']>;
  voucher?: InputMaybe<Scalars['Int']['input']>;
};

export type createPackage = {
  data?: Maybe<DepotoPackage>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createParameter = {
  data?: Maybe<Parameter>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createPayment = {
  data?: Maybe<Payment>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createPaymentItem = {
  data?: Maybe<PaymentItem>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createPaymentItem_ = {
  amount: Scalars['Float']['input'];
  checkout?: InputMaybe<Scalars['Int']['input']>;
  dateCancelled?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  dateCreated?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  datePaid?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  payment: Scalars['Int']['input'];
  voucher?: InputMaybe<Scalars['Int']['input']>;
};

export type createPricePriceLevel = {
  data?: Maybe<PriceLevel>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createProducer = {
  data?: Maybe<Producer>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createProduct = {
  data?: Maybe<Product>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createProductBundle = {
  data?: Maybe<ProductBundle>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createProductDepotMetric = {
  data?: Maybe<ProductDepotMetric>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createProductMove = {
  amount: Scalars['Float']['input'];
  batch?: InputMaybe<Scalars['String']['input']>;
  depotFrom?: InputMaybe<Scalars['Int']['input']>;
  depotTo?: InputMaybe<Scalars['Int']['input']>;
  expirationDate?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderItem?: InputMaybe<Scalars['Int']['input']>;
  position1?: InputMaybe<Scalars['String']['input']>;
  position2?: InputMaybe<Scalars['String']['input']>;
  position3?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['Int']['input']>;
  productDepot?: InputMaybe<Scalars['Int']['input']>;
  purchaseCurrency?: InputMaybe<Scalars['String']['input']>;
  purchaseCurrencyDate?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  purchaseOrderItem?: InputMaybe<Scalars['Int']['input']>;
  purchasePrice?: InputMaybe<Scalars['Float']['input']>;
  serialNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  supplier?: InputMaybe<Scalars['Int']['input']>;
};

export type createProductMovePack = {
  data?: Maybe<ProductMovePack>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createProductPack = {
  data?: Maybe<ProductPack>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createProductParameter = {
  data?: Maybe<ProductParameter>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createProductPrice = {
  data?: Maybe<ProductPrice>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createProductPriceLevel = {
  data?: Maybe<ProductPriceLevel>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createPurchaseOrder = {
  data?: Maybe<PurchaseOrder>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createPurchaseOrderItem = {
  data?: Maybe<PurchaseOrderItem>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createPurchaseOrderItem_ = {
  currency: Scalars['String']['input'];
  customData?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  product: Scalars['Int']['input'];
  purchasePrice?: InputMaybe<Scalars['Float']['input']>;
  quantity: Scalars['Int']['input'];
};

export type createShop = {
  data?: Maybe<Shop>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createSupplier = {
  data?: Maybe<Supplier>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createTag = {
  data?: Maybe<Tag>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createUser = {
  data?: Maybe<User>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createUserGroup = {
  data?: Maybe<UserGroup>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createVat = {
  data?: Maybe<Vat>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type createVoucher = {
  data?: Maybe<Voucher>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type created = {
  left_date?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  right_date?: InputMaybe<Scalars['DateTimeAsString']['input']>;
};

export type currencies = {
  items?: Maybe<Array<Maybe<Currency>>>;
  paginator?: Maybe<Paginator>;
};

export type currenciesFilters = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type currencyRate = {
  data?: Maybe<CurrencyRate>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type customer = {
  data?: Maybe<Customer>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type customerFilters = {
  checkouts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  fulltext?: InputMaybe<Scalars['String']['input']>;
  priceLevel?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tagsNegate?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type customers = {
  items?: Maybe<Array<Maybe<Customer>>>;
  paginator?: Maybe<Paginator>;
};

export type dateBill = {
  left_date?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  right_date?: InputMaybe<Scalars['DateTimeAsString']['input']>;
};

export type dateCreated = {
  left_date?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  right_date?: InputMaybe<Scalars['DateTimeAsString']['input']>;
};

export type dateDue = {
  left_date?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  right_date?: InputMaybe<Scalars['DateTimeAsString']['input']>;
};

export type dateEstimatedArrival = {
  left_date?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  right_date?: InputMaybe<Scalars['DateTimeAsString']['input']>;
};

export type dateExpedition = {
  left_date?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  right_date?: InputMaybe<Scalars['DateTimeAsString']['input']>;
};

export type dateTax = {
  left_date?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  right_date?: InputMaybe<Scalars['DateTimeAsString']['input']>;
};

export type deleteAddress = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteCategory = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteCert = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteCheckout = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteCheckoutClosing = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteCheckoutExtraOperation = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteCompany = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteCompanyCarrier = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteConsent = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteCustomer = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteCustomerConsent = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteDepot = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteDisposal = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteFile = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteInstitution = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteLeaflet = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteOrderGroup = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteOrderItem = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deletePackage = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteParameter = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deletePayment = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deletePaymentItem = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deletePriceLevel = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteProducer = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteProduct = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteProductBundle = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteProductDepotMetric = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteProductMove = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteProductMovePack = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteProductPack = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteProductParameter = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteProductPrice = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteProductPriceLevel = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deletePurchaseOrder = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deletePurchaseOrderItem = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteReservation = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteShop = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteSupplier = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteTag = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteUser = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteUserGroup = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteVat = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type deleteVoucher = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type depot = {
  data?: Maybe<Depot>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type depotFilters = {
  checkouts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type depots = {
  items?: Maybe<Array<Maybe<Depot>>>;
  paginator?: Maybe<Paginator>;
};

export type disposal = {
  data?: Maybe<PackageDisposal>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type disposalFilters = {
  carrier?: InputMaybe<Scalars['String']['input']>;
  carriers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type disposals = {
  items?: Maybe<Array<Maybe<PackageDisposal>>>;
  paginator?: Maybe<Paginator>;
};

export type eetReceiptFilters = {
  checkouts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  hasFik?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  playground?: InputMaybe<Scalars['Boolean']['input']>;
  verificationMode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type eetReceipts = {
  items?: Maybe<Array<Maybe<Receipt>>>;
  paginator?: Maybe<Paginator>;
};

export type eventTypes = {
  items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type depotoExport = {
  data?: Maybe<DepotoExport>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type exportFilters = {
  group?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type exportInventories = {
  items?: Maybe<Array<Maybe<Inventory>>>;
  paginator?: Maybe<Paginator>;
};

export type exportInventory = {
  data?: Maybe<Inventory>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type exportInventoryFilters = {
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  checkouts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  finished?: InputMaybe<Scalars['Boolean']['input']>;
  producers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rejected?: InputMaybe<Scalars['Boolean']['input']>;
  suppliers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type exportOrder = {
  /** Pokladny */
  checkouts?: Maybe<Array<Maybe<Checkout>>>;
  /** Vytvoření */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** Datum od */
  dateFrom?: Maybe<Scalars['DateTime']['output']>;
  /** Datum do */
  dateTo?: Maybe<Scalars['DateTime']['output']>;
  /** Formát */
  format?: Maybe<Scalars['String']['output']>;
  /** Vygenerováno */
  generated?: Maybe<Scalars['DateTime']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Stav */
  status?: Maybe<OrderStatus>;
  /** URL */
  url?: Maybe<Scalars['String']['output']>;
};

export type exportOrderFilters = {
  checkouts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type exportOrders = {
  items?: Maybe<Array<Maybe<exportOrder>>>;
  paginator?: Maybe<Paginator>;
};

export type exportPurchaseFilters = {
  checkouts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  depots?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  producers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  suppliers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type exportPurchases = {
  items?: Maybe<Array<Maybe<Purchase>>>;
  paginator?: Maybe<Paginator>;
};

export type exportSaleFilters = {
  checkouts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  producers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  suppliers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type exportSales = {
  items?: Maybe<Array<Maybe<Sale>>>;
  paginator?: Maybe<Paginator>;
};

export type exportStockFilters = {
  depots?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  producers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  suppliers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type exportStocks = {
  items?: Maybe<Array<Maybe<Stock>>>;
  paginator?: Maybe<Paginator>;
};

export type exportTypeFilters = {
  group?: InputMaybe<Scalars['String']['input']>;
};

export type exportTypes = {
  items?: Maybe<Array<Maybe<ExportType>>>;
  paginator?: Maybe<Paginator>;
};

export type exports = {
  items?: Maybe<Array<Maybe<DepotoExport>>>;
  paginator?: Maybe<Paginator>;
};

export type file = {
  data?: Maybe<File>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type fileFilters = {
  order?: InputMaybe<Scalars['Int']['input']>;
  product?: InputMaybe<Scalars['Int']['input']>;
};

export type files = {
  items?: Maybe<Array<Maybe<File>>>;
  paginator?: Maybe<Paginator>;
};

export type filters = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type institution = {
  data?: Maybe<Institution>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type institutionFilters = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type institutions = {
  items?: Maybe<Array<Maybe<Institution>>>;
  paginator?: Maybe<Paginator>;
};

export type isUserEmailUnique = {
  data?: Maybe<Scalars['Boolean']['output']>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type leaflet = {
  data?: Maybe<Leaflet>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type leafletFilters = {
  product?: InputMaybe<Scalars['Int']['input']>;
};

export type leaflets = {
  items?: Maybe<Array<Maybe<Leaflet>>>;
  paginator?: Maybe<Paginator>;
};

export type loggableHistoryResult = {
  items?: Maybe<Array<Maybe<LoggableHistoryEntry>>>;
  paginator?: Maybe<Paginator>;
};

export type modules = {
  items?: Maybe<Array<Maybe<Module>>>;
  paginator?: Maybe<Paginator>;
};

export type modulesFilters = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type nextCode = {
  data?: Maybe<Scalars['Int']['output']>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type nextEan = {
  data?: Maybe<Scalars['Int']['output']>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type order = {
  data?: Maybe<Order>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type orderFilters = {
  billNumber?: InputMaybe<Scalars['Int']['input']>;
  box?: InputMaybe<Scalars['String']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  carriers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  checkouts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  createdBy?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  customer?: InputMaybe<Scalars['Int']['input']>;
  customerFulltext?: InputMaybe<Scalars['String']['input']>;
  dateBill?: InputMaybe<dateBill>;
  dateCreated?: InputMaybe<dateCreated>;
  dateDue?: InputMaybe<dateDue>;
  dateExpedition?: InputMaybe<dateExpedition>;
  dateLocked?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  dateTax?: InputMaybe<dateTax>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  depots?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  fulltext?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  hasAvailableProducts?: InputMaybe<Scalars['Boolean']['input']>;
  hasGroup?: InputMaybe<Scalars['Boolean']['input']>;
  isFragile?: InputMaybe<Scalars['Boolean']['input']>;
  isOversize?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  item?: InputMaybe<Scalars['String']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  lockedBy?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  onlyDepots?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  package?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  processStatus?: InputMaybe<Scalars['String']['input']>;
  processStatusChange?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  processStatusUpdated?: InputMaybe<processStatusUpdated>;
  reservationNumber?: InputMaybe<Scalars['Int']['input']>;
  shippingCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tagsNegate?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated?: InputMaybe<updated>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type orderGroup = {
  data?: Maybe<OrderGroup>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type orderGroupFilters = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  processStatus?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tagsNegate?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type orderGroups = {
  items?: Maybe<Array<Maybe<OrderGroup>>>;
  paginator?: Maybe<Paginator>;
};

export type orderItem = {
  data?: Maybe<OrderItem>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type orderItemFilters = {
  carrier?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  processStatus?: InputMaybe<Scalars['String']['input']>;
  productDepot?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type orderItemProductDepot = {
  productDepot: Scalars['Int']['input'];
  quantity: Scalars['Float']['input'];
};

export type orderItems = {
  items?: Maybe<Array<Maybe<OrderItem>>>;
  paginator?: Maybe<Paginator>;
};

export type orders = {
  items?: Maybe<Array<Maybe<Order>>>;
  paginator?: Maybe<Paginator>;
};

export type depotoPackage = {
  data?: Maybe<DepotoPackage>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type packageFilters = {
  carrier?: InputMaybe<Scalars['String']['input']>;
  carriers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  disposal?: InputMaybe<Scalars['Int']['input']>;
  hasDisposal?: InputMaybe<Scalars['Boolean']['input']>;
  isSent?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  orderProcessStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sent?: InputMaybe<Scalars['String']['input']>;
};

export type packageStats = {
  items?: Maybe<Array<Maybe<PackageStats>>>;
  paginator?: Maybe<Paginator>;
};

export type packageStatsFilters = {
  carrier?: InputMaybe<Scalars['String']['input']>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  fromDate?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  toDate?: InputMaybe<Scalars['DateTimeAsString']['input']>;
};

export type packages = {
  items?: Maybe<Array<Maybe<DepotoPackage>>>;
  paginator?: Maybe<Paginator>;
};

export type parameter = {
  data?: Maybe<Parameter>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type parameters = {
  items?: Maybe<Array<Maybe<Parameter>>>;
  paginator?: Maybe<Paginator>;
};

export type parametersFilters = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type payment = {
  data?: Maybe<Payment>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type paymentFilters = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  company?: InputMaybe<Scalars['Int']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type paymentItem = {
  data?: Maybe<PaymentItem>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type paymentItems = {
  items?: Maybe<Array<Maybe<PaymentItem>>>;
  paginator?: Maybe<Paginator>;
};

export type paymentItemsFilters = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  payment?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type paymentSum = {
  /** Počet */
  count?: Maybe<Scalars['Int']['output']>;
  /** Platba */
  payment?: Maybe<Payment>;
  /** Suma */
  sum?: Maybe<Scalars['Int']['output']>;
};

export type paymentTypeFilters = {
  const?: InputMaybe<Scalars['String']['input']>;
};

export type paymentTypes = {
  items?: Maybe<Array<Maybe<PaymentType>>>;
  paginator?: Maybe<Paginator>;
};

export type payments = {
  items?: Maybe<Array<Maybe<Payment>>>;
  paginator?: Maybe<Paginator>;
};

export type priceLevel = {
  data?: Maybe<PriceLevel>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type priceLevelFilters = {
  currency?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  isPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  withVat?: InputMaybe<Scalars['Boolean']['input']>;
};

export type priceLevels = {
  items?: Maybe<Array<Maybe<PriceLevel>>>;
  paginator?: Maybe<Paginator>;
};

export type processStatusRelation = {
  note?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type processStatusUpdated = {
  left_date?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  right_date?: InputMaybe<Scalars['DateTimeAsString']['input']>;
};

export type processStatuses = {
  items?: Maybe<Array<Maybe<ProcessStatus>>>;
  paginator?: Maybe<Paginator>;
};

export type processStatusesFilters = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type producer = {
  data?: Maybe<Producer>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type producerFilters = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type producers = {
  items?: Maybe<Array<Maybe<Producer>>>;
  paginator?: Maybe<Paginator>;
};

export type product = {
  data?: Maybe<Product>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type productDepot = {
  data?: Maybe<ProductDepot>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type productDepotFilters = {
  availability?: InputMaybe<Scalars['String']['input']>;
  depot?: InputMaybe<Scalars['Int']['input']>;
  fulltext?: InputMaybe<Scalars['String']['input']>;
  position1?: InputMaybe<Scalars['String']['input']>;
  position2?: InputMaybe<Scalars['String']['input']>;
  position3?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['Int']['input']>;
  supplier?: InputMaybe<Scalars['Int']['input']>;
};

export type productDepotMetric = {
  data?: Maybe<ProductDepotMetric>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type productDepotMetricFilters = {
  depot?: InputMaybe<Scalars['Int']['input']>;
  product?: InputMaybe<Scalars['Int']['input']>;
};

export type productDepotMetrics = {
  items?: Maybe<Array<Maybe<ProductDepotMetric>>>;
  paginator?: Maybe<Paginator>;
};

export type productDepots = {
  items?: Maybe<Array<Maybe<ProductDepot>>>;
  paginator?: Maybe<Paginator>;
};

export type productFilters = {
  availability?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  company?: InputMaybe<Scalars['Int']['input']>;
  createdFrom?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  defaultSuppliers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  depots?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ean?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledBatchExpiration?: InputMaybe<Scalars['Boolean']['input']>;
  expirationDateTo?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  fulltext?: InputMaybe<Scalars['String']['input']>;
  hasBeforeSellPrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasHsCode?: InputMaybe<Scalars['Boolean']['input']>;
  hasPhePrice?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isAdultOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isAutomaticOrders?: InputMaybe<Scalars['Boolean']['input']>;
  isBundle?: InputMaybe<Scalars['Boolean']['input']>;
  isPML?: InputMaybe<Scalars['Boolean']['input']>;
  listType?: InputMaybe<Scalars['String']['input']>;
  metricDepots?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  metrics?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position1?: InputMaybe<Scalars['String']['input']>;
  position2?: InputMaybe<Scalars['String']['input']>;
  position3?: InputMaybe<Scalars['String']['input']>;
  producers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  requiredSerialNumbers?: InputMaybe<Scalars['Boolean']['input']>;
  suppliers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tagsNegate?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updatedFrom?: InputMaybe<Scalars['DateTimeAsString']['input']>;
};

export type productMoveFilters = {
  batch?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  checkouts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  created?: InputMaybe<created>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  depotFrom?: InputMaybe<Scalars['Int']['input']>;
  depotTo?: InputMaybe<Scalars['Int']['input']>;
  depots?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  expirationDate?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  product?: InputMaybe<Scalars['Int']['input']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  withoutCheckout?: InputMaybe<Scalars['Boolean']['input']>;
};

export type productMovePack = {
  data?: Maybe<ProductMovePack>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type productMovePackFilters = {
  checkouts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  created?: InputMaybe<created>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  depot?: InputMaybe<Scalars['Int']['input']>;
  depotFrom?: InputMaybe<Scalars['Int']['input']>;
  depotTo?: InputMaybe<Scalars['Int']['input']>;
  depots?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  depotsFrom?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  depotsTo?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  fulltext?: InputMaybe<Scalars['String']['input']>;
  incidentalCosts?: InputMaybe<Scalars['Float']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  orderFulltext?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['Int']['input']>;
  productFulltext?: InputMaybe<Scalars['String']['input']>;
  purchaseOrder?: InputMaybe<Scalars['Int']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tagsNegate?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  withOrder?: InputMaybe<Scalars['Boolean']['input']>;
  withoutCheckout?: InputMaybe<Scalars['Boolean']['input']>;
};

export type productMovePacks = {
  items?: Maybe<Array<Maybe<ProductMovePack>>>;
  paginator?: Maybe<Paginator>;
};

export type productMovePurposes = {
  items?: Maybe<Array<Maybe<ProductMovePurpose>>>;
  paginator?: Maybe<Paginator>;
};

export type productMovePurposesFilters = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type productMoves = {
  items?: Maybe<Array<Maybe<ProductMove>>>;
  paginator?: Maybe<Paginator>;
};

export type productPack = {
  data?: Maybe<ProductPack>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type productPackFilters = {
  code?: InputMaybe<Scalars['String']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type productPacks = {
  items?: Maybe<Array<Maybe<ProductPack>>>;
  paginator?: Maybe<Paginator>;
};

export type productParameter = {
  data?: Maybe<ProductParameter>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type productParameterFilters = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  parameter?: InputMaybe<Scalars['Int']['input']>;
  product?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type productParameters = {
  items?: Maybe<Array<Maybe<ProductParameter>>>;
  paginator?: Maybe<Paginator>;
};

export type productPriceFilters = {
  product?: InputMaybe<Scalars['Int']['input']>;
};

export type productPriceLevel = {
  data?: Maybe<ProductPriceLevel>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type productPriceLevelFilters = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  priceLevel?: InputMaybe<Scalars['Int']['input']>;
  product?: InputMaybe<Scalars['Int']['input']>;
};

export type productPriceLevels = {
  items?: Maybe<Array<Maybe<ProductPriceLevel>>>;
  paginator?: Maybe<Paginator>;
};

export type productPrices = {
  items?: Maybe<Array<Maybe<ProductPrice>>>;
  paginator?: Maybe<Paginator>;
};

export type productPurchasePrice = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  items?: Maybe<Array<Maybe<ProductPurchasePrice>>>;
};

export type productSellItems = {
  items?: Maybe<Array<Maybe<SellItem>>>;
};

export type productSellPrice = {
  data?: Maybe<SellPrice>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type products = {
  items?: Maybe<Array<Maybe<Product>>>;
  paginator?: Maybe<Paginator>;
};

export type productsOtherCompanies = {
  items?: Maybe<Array<Maybe<Product>>>;
  paginator?: Maybe<Paginator>;
};

export type purchaseOrder = {
  data?: Maybe<PurchaseOrder>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type purchaseOrderFilters = {
  company?: InputMaybe<Scalars['Int']['input']>;
  created?: InputMaybe<created>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  dateEstimatedArrival?: InputMaybe<dateEstimatedArrival>;
  depot?: InputMaybe<Scalars['Int']['input']>;
  depots?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  fulltext?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  showStocked?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['Int']['input']>;
  supplierReference?: InputMaybe<Scalars['String']['input']>;
  suppliers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tagsNegate?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated?: InputMaybe<updated>;
};

export type purchaseOrderItem = {
  data?: Maybe<PurchaseOrderItem>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type purchaseOrderItemFilters = {
  company?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  depot?: InputMaybe<Scalars['Int']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  fulltext?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrder?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['Int']['input']>;
};

export type purchaseOrderItems = {
  items?: Maybe<Array<Maybe<PurchaseOrderItem>>>;
  paginator?: Maybe<Paginator>;
};

export type purchaseOrderStatuses = {
  items?: Maybe<Array<Maybe<PurchaseOrderStatus>>>;
  paginator?: Maybe<Paginator>;
};

export type purchaseOrderStatusesFilters = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type purchaseOrders = {
  items?: Maybe<Array<Maybe<PurchaseOrder>>>;
  paginator?: Maybe<Paginator>;
};

export type refreshExportInventory = {
  data?: Maybe<Inventory>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type refreshProductDepots = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type resetPackage = {
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type sendDisposal = {
  data?: Maybe<PackageDisposal>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type sendEetReceipt = {
  data?: Maybe<Receipt>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type sendPackage = {
  data?: Maybe<DepotoPackage>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type shop = {
  data?: Maybe<Shop>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type shopFilters = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type shops = {
  items?: Maybe<Array<Maybe<Shop>>>;
  paginator?: Maybe<Paginator>;
};

export type soldItemFilters = {
  carriers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  checkouts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  customer?: InputMaybe<Scalars['Int']['input']>;
  customerFulltext?: InputMaybe<Scalars['String']['input']>;
  dateBill?: InputMaybe<dateBill>;
  dateCreated?: InputMaybe<dateCreated>;
  depots?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  orderTags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  payments?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  processStatus?: InputMaybe<Scalars['String']['input']>;
  processStatusUpdated?: InputMaybe<processStatusUpdated>;
  producers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  product?: InputMaybe<Scalars['Int']['input']>;
  productFulltext?: InputMaybe<Scalars['String']['input']>;
  productTags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  shippingCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  suppliers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type soldItems = {
  items?: Maybe<Array<Maybe<SoldItem>>>;
  paginator?: Maybe<Paginator>;
};

export type statsBestsellers = {
  items?: Maybe<Array<Maybe<Bestsellers>>>;
};

export enum statsBestsellersSort {
  amount = 'amount',
  sales = 'sales'
}

export type statsCarrierUsage = {
  items?: Maybe<Array<Maybe<CarrierUsage>>>;
};

export type statsPaymentSales = {
  items?: Maybe<Array<Maybe<PaymentSales>>>;
};

export type supplier = {
  data?: Maybe<Supplier>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type supplierFilters = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type suppliers = {
  items?: Maybe<Array<Maybe<Supplier>>>;
  paginator?: Maybe<Paginator>;
};

export type tag = {
  data?: Maybe<Tag>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type tagFilters = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type tagTypeFilters = {
  const?: InputMaybe<Scalars['String']['input']>;
};

export type tagTypes = {
  items?: Maybe<Array<Maybe<TagType>>>;
  paginator?: Maybe<Paginator>;
};

export type tags = {
  items?: Maybe<Array<Maybe<Tag>>>;
  paginator?: Maybe<Paginator>;
};

export type testCompanyCarrier = {
  data?: Maybe<CompanyCarrierTest>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateAddress = {
  data?: Maybe<Address>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateCategory = {
  data?: Maybe<Category>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateCert = {
  data?: Maybe<Depot>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateCheckout = {
  data?: Maybe<Checkout>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateCheckoutClosing = {
  data?: Maybe<CheckoutClosing>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateCheckoutExtraOperation = {
  data?: Maybe<CheckoutExtraOperation>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateClearanceItem = {
  data?: Maybe<ClearanceItem>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateClearanceItemLocations = {
  amount: Scalars['Int']['input'];
  batch?: InputMaybe<Scalars['String']['input']>;
  depot?: InputMaybe<Scalars['Int']['input']>;
  expirationDate?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  position1?: InputMaybe<Scalars['String']['input']>;
  position2?: InputMaybe<Scalars['String']['input']>;
  position3?: InputMaybe<Scalars['String']['input']>;
  productDepot?: InputMaybe<Scalars['Int']['input']>;
};

export type updateCompany = {
  data?: Maybe<Company>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateCompanyCarrier = {
  data?: Maybe<CompanyCarrier>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateConsent = {
  data?: Maybe<Consent>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateCustomer = {
  data?: Maybe<Customer>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateDepot = {
  data?: Maybe<Depot>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateDisposal = {
  data?: Maybe<PackageDisposal>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateExportInventory = {
  data?: Maybe<Inventory>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateFile = {
  data?: Maybe<File>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateInstitution = {
  data?: Maybe<Institution>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateLeaflet = {
  data?: Maybe<Leaflet>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateOrder = {
  data?: Maybe<Order>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateOrderGroup = {
  data?: Maybe<OrderGroup>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateOrderItem = {
  data?: Maybe<OrderItem>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateOrderItem_ = {
  batch?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isForSubsequentSettlement?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  packed?: InputMaybe<Scalars['Boolean']['input']>;
  picked?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['Int']['input']>;
  productDepots?: InputMaybe<Array<InputMaybe<orderItemProductDepot>>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sale?: InputMaybe<Scalars['String']['input']>;
  serial?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['Int']['input']>;
  voucher?: InputMaybe<Scalars['Int']['input']>;
};

export type updatePackage = {
  data?: Maybe<DepotoPackage>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateParameter = {
  data?: Maybe<Parameter>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updatePayment = {
  data?: Maybe<Payment>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updatePaymentItem = {
  data?: Maybe<PaymentItem>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updatePaymentItem_ = {
  amount?: InputMaybe<Scalars['String']['input']>;
  checkout?: InputMaybe<Scalars['Int']['input']>;
  dateCancelled?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  dateCreated?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  datePaid?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  payment?: InputMaybe<Scalars['Int']['input']>;
  voucher?: InputMaybe<Scalars['Int']['input']>;
};

export type updatePriceLevel = {
  data?: Maybe<PriceLevel>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateProducer = {
  data?: Maybe<Producer>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateProduct = {
  data?: Maybe<Product>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateProductBundle = {
  data?: Maybe<ProductBundle>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateProductDepot = {
  data?: Maybe<ProductDepot>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateProductDepotMetric = {
  data?: Maybe<ProductDepotMetric>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateProductMove = {
  data?: Maybe<ProductMove>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateProductMovePack = {
  data?: Maybe<ProductMovePack>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateProductPack = {
  data?: Maybe<ProductPack>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateProductParameter = {
  data?: Maybe<ProductParameter>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateProductPrice = {
  data?: Maybe<ProductPrice>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateProductPriceLevel = {
  data?: Maybe<ProductPriceLevel>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updatePurchaseOrder = {
  data?: Maybe<PurchaseOrder>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updatePurchaseOrderItem = {
  data?: Maybe<PurchaseOrderItem>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updatePurchaseOrderItem_ = {
  currency: Scalars['String']['input'];
  customData?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  product: Scalars['Int']['input'];
  purchasePrice?: InputMaybe<Scalars['Float']['input']>;
  quantity: Scalars['Int']['input'];
};

export type updateShop = {
  data?: Maybe<Shop>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateSupplier = {
  data?: Maybe<Supplier>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateTag = {
  data?: Maybe<Tag>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateUser = {
  data?: Maybe<User>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateUserGroup = {
  data?: Maybe<UserGroup>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateVat = {
  data?: Maybe<Vat>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updateVoucher = {
  data?: Maybe<Voucher>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type updated = {
  left_date?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  right_date?: InputMaybe<Scalars['DateTimeAsString']['input']>;
};

export type user = {
  data?: Maybe<User>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type userFilters = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  fulltext?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  pin?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type userGroup = {
  data?: Maybe<UserGroup>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type userGroupFilters = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type userGroups = {
  items?: Maybe<Array<Maybe<UserGroup>>>;
  paginator?: Maybe<Paginator>;
};

export type userMyProfile = {
  data?: Maybe<User>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type users = {
  items?: Maybe<Array<Maybe<User>>>;
  paginator?: Maybe<Paginator>;
};

export type vat = {
  data?: Maybe<Vat>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type vatFilters = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percent?: InputMaybe<Scalars['Float']['input']>;
};

export type vats = {
  items?: Maybe<Array<Maybe<Vat>>>;
  paginator?: Maybe<Paginator>;
};

export type voucher = {
  data?: Maybe<Voucher>;
  /** Strojově čitelný popis chyb: položka i popisuje errors[i]. Vybírejte vždy všechna podpole. */
  errorDetails?: Maybe<Array<Maybe<ApiError>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type voucherCreatedFilter = {
  left_date?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  right_date?: InputMaybe<Scalars['DateTimeAsString']['input']>;
};

export type voucherFilters = {
  code?: InputMaybe<Scalars['String']['input']>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  created?: InputMaybe<voucherCreatedFilter>;
  discountType?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  isPayment?: InputMaybe<Scalars['Boolean']['input']>;
  isUsed?: InputMaybe<Scalars['Boolean']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  validDate?: InputMaybe<voucherValidFilter>;
};

export type voucherValidFilter = {
  left_date?: InputMaybe<Scalars['DateTimeAsString']['input']>;
  right_date?: InputMaybe<Scalars['DateTimeAsString']['input']>;
};

export type vouchers = {
  items?: Maybe<Array<Maybe<Voucher>>>;
  paginator?: Maybe<Paginator>;
};

export type OrderListItem_OrderFragment = { id?: number | null, reservationNumber?: number | null, dateCreated?: any | null, isPaid?: boolean | null, quantityUnavailable?: number | null, boxes?: Array<string | null> | null, dateExpedition?: any | null, note?: string | null, privateNote?: string | null, priority?: number | null, externalReference?: string | null, processStatusUpdated?: any | null, carrier?: { id?: string | null, name?: string | null, color?: string | null } | null, depots?: Array<{ id?: number | null, name?: string | null } | null> | null, shippingAddress?: { id?: number | null, firstName?: string | null, lastName?: string | null, street?: string | null, city?: string | null, country?: string | null } | null, checkout?: { id?: number | null, name?: string | null } | null, tags?: Array<(
    { id?: number | null }
    & { ' $fragmentRefs'?: { 'TagComponent_TagFragmentFragment': TagComponent_TagFragmentFragment } }
  ) | null> | null, items?: Array<{ id?: number | null, product?: { id?: number | null, isFragile?: boolean | null, isOversize?: boolean | null } | null } | null> | null, processStatus?: { id?: string | null, name?: string | null } | null } & { ' $fragmentName'?: 'OrderListItem_OrderFragment' };

export type CreateFileMutationVariables = Exact<{
  base64Data: Scalars['String']['input'];
  text: Scalars['String']['input'];
  originalFilename: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateFileMutation = { createFile?: { errors?: Array<string | null> | null, data?: { id?: number | null, text?: string | null, originalFilename?: string | null, mimeType?: string | null, size?: number | null, url?: string | null } | null } | null };

export type DeleteFileMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteFileMutation = { deleteFile?: { errors?: Array<string | null> | null } | null };

export type OrderFiles_OrderFragmentFragment = { id?: number | null, reservationUrl?: string | null, invoiceUrl?: string | null, files?: Array<{ id?: number | null, url?: string | null, originalFilename?: string | null, mimeType?: string | null, size?: number | null } | null> | null, movePacks?: Array<{ id?: number | null, pdfWOPricesUrl?: string | null } | null> | null, items?: Array<{ product?: { id?: number | null, name?: string | null, mainImage?: { thumbnails?: Array<{ format?: string | null, url?: string | null } | null> | null } | null, tags?: Array<(
        { id?: number | null }
        & { ' $fragmentRefs'?: { 'TagComponent_TagFragmentFragment': TagComponent_TagFragmentFragment } }
      ) | null> | null, files?: Array<{ id?: number | null, url?: string | null, originalFilename?: string | null, mimeType?: string | null, size?: number | null } | null> | null } | null } | null> | null } & { ' $fragmentName'?: 'OrderFiles_OrderFragmentFragment' };

export type OrdersListQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  filters?: InputMaybe<orderFilters>;
  sort?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrdersListQuery = { orders?: { items?: Array<(
      { id?: number | null }
      & { ' $fragmentRefs'?: { 'OrderListItem_OrderFragment': OrderListItem_OrderFragment } }
    ) | null> | null, paginator?: { current?: number | null, totalCount?: number | null, endPage?: number | null } | null } | null };

export type OrderHistoryItemQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type OrderHistoryItemQuery = { order?: { data?: (
      { id?: number | null }
      & { ' $fragmentRefs'?: { 'OrderListItem_OrderFragment': OrderListItem_OrderFragment } }
    ) | null } | null };

export type TagComponent_TagFragmentFragment = { id?: number | null, name?: string | null, color?: string | null } & { ' $fragmentName'?: 'TagComponent_TagFragmentFragment' };

export type BasicEntities_TagFragmentFragment = (
  { id?: number | null, name?: string | null, color?: string | null, externalId?: string | null, type?: string | null }
  & { ' $fragmentRefs'?: { 'TagComponent_TagFragmentFragment': TagComponent_TagFragmentFragment } }
) & { ' $fragmentName'?: 'BasicEntities_TagFragmentFragment' };

export type BasicEntities_DepotFragmentFragment = { id?: number | null, name?: string | null, company?: { id?: number | null } | null } & { ' $fragmentName'?: 'BasicEntities_DepotFragmentFragment' };

export type BasicEntities_CarrierFragmentFragment = { id?: string | null, name?: string | null, color?: string | null } & { ' $fragmentName'?: 'BasicEntities_CarrierFragmentFragment' };

export type BasicEntities_CheckoutFragmentFragment = { id?: number | null, name?: string | null } & { ' $fragmentName'?: 'BasicEntities_CheckoutFragmentFragment' };

export type BasicEntities_CurrencyFragmentFragment = { id?: string | null, name?: string | null } & { ' $fragmentName'?: 'BasicEntities_CurrencyFragmentFragment' };

export type BasicEntities_PaymentFragmentFragment = { id?: number | null, name?: string | null } & { ' $fragmentName'?: 'BasicEntities_PaymentFragmentFragment' };

export type BasicEntitiesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type BasicEntitiesQueryQuery = { tags?: { items?: Array<{ ' $fragmentRefs'?: { 'BasicEntities_TagFragmentFragment': BasicEntities_TagFragmentFragment } } | null> | null } | null, depots?: { items?: Array<{ ' $fragmentRefs'?: { 'BasicEntities_DepotFragmentFragment': BasicEntities_DepotFragmentFragment } } | null> | null } | null, carriers?: { items?: Array<{ ' $fragmentRefs'?: { 'BasicEntities_CarrierFragmentFragment': BasicEntities_CarrierFragmentFragment } } | null> | null } | null, checkouts?: { items?: Array<{ ' $fragmentRefs'?: { 'BasicEntities_CheckoutFragmentFragment': BasicEntities_CheckoutFragmentFragment } } | null> | null } | null, currencies?: { items?: Array<{ ' $fragmentRefs'?: { 'BasicEntities_CurrencyFragmentFragment': BasicEntities_CurrencyFragmentFragment } } | null> | null } | null, payments?: { items?: Array<{ ' $fragmentRefs'?: { 'BasicEntities_PaymentFragmentFragment': BasicEntities_PaymentFragmentFragment } } | null> | null } | null };

export type CreateDisposalMutationVariables = Exact<{
  company?: InputMaybe<Scalars['Int']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  packages?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
}>;


export type CreateDisposalMutation = { createDisposal?: { errors?: Array<string | null> | null, data?: { id?: number | null } | null } | null };

export type SendDisposalMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SendDisposalMutation = { sendDisposal?: { errors?: Array<string | null> | null, data?: { id?: number | null } | null } | null };

export type PackagesForDisposalQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  filters?: InputMaybe<packageFilters>;
  sort?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
}>;


export type PackagesForDisposalQuery = { packages?: { items?: Array<(
      { id?: number | null, order?: { carrier?: { id?: string | null, name?: string | null } | null } | null }
      & { ' $fragmentRefs'?: { 'DisposalCreateTable_PackageFragmentFragment': DisposalCreateTable_PackageFragmentFragment } }
    ) | null> | null, paginator?: { current?: number | null, endPage?: number | null, totalCount?: number | null } | null } | null };

export type DisposalCreateTable_PackageFragmentFragment = { id?: number | null, code?: string | null, order?: { id?: number | null, carrier?: { name?: string | null } | null, company?: { id?: number | null, name?: string | null } | null, shippingAddress?: { firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, street?: string | null, city?: string | null, zip?: string | null, country?: string | null } | null } | null } & { ' $fragmentName'?: 'DisposalCreateTable_PackageFragmentFragment' };

export type DisposalsListQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  filters?: InputMaybe<disposalFilters>;
  sort?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
}>;


export type DisposalsListQuery = { disposals?: { items?: Array<(
      { id?: number | null, sent?: any | null, company?: { id?: number | null } | null, packages?: Array<{ id?: number | null } | null> | null }
      & { ' $fragmentRefs'?: { 'DisposalTable_DisposalFragmentFragment': DisposalTable_DisposalFragmentFragment } }
    ) | null> | null, paginator?: { current?: number | null, totalCount?: number | null, endPage?: number | null } | null } | null };

export type DisposalTable_DisposalFragmentFragment = { id?: number | null, code?: string | null, ticketUrl?: string | null, sent?: any | null, carrier?: { id?: string | null, name?: string | null } | null, company?: { id?: number | null, name?: string | null } | null, packages?: Array<{ id?: number | null, order?: { id?: number | null, shippingAddress?: { companyName?: string | null, firstName?: string | null, lastName?: string | null } | null } | null } | null> | null } & { ' $fragmentName'?: 'DisposalTable_DisposalFragmentFragment' };

export type GroupsListQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  filters?: InputMaybe<orderGroupFilters>;
  sort?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
}>;


export type GroupsListQuery = { orderGroups?: { items?: Array<(
      { id?: number | null }
      & { ' $fragmentRefs'?: { 'GroupListItem_OrderGroupFragment': GroupListItem_OrderGroupFragment } }
    ) | null> | null, paginator?: { current?: number | null, totalCount?: number | null, endPage?: number | null } | null } | null };

export type GroupListItem_OrderGroupFragment = { id?: number | null, name?: string | null, created?: any | null, ordersCount?: number | null, tags?: Array<(
    { id?: number | null, name?: string | null, color?: string | null }
    & { ' $fragmentRefs'?: { 'TagComponent_TagFragmentFragment': TagComponent_TagFragmentFragment } }
  ) | null> | null, user?: { id?: number | null, name?: string | null } | null } & { ' $fragmentName'?: 'GroupListItem_OrderGroupFragment' };

export type ClearanceItemsInTable_OrderFragmentFragment = { clearanceItems?: Array<(
    { id?: string | null, position?: string | null, amount?: number | null, batch?: string | null, expirationDate?: any | null, picked?: number | null, product?: (
      { ean?: string | null, ean2?: string | null, ean3?: string | null, ean4?: string | null, ean5?: string | null, code?: string | null }
      & { ' $fragmentRefs'?: { 'ProductCell_ProductFragmentFragment': ProductCell_ProductFragmentFragment } }
    ) | null }
    & { ' $fragmentRefs'?: { 'EditExpeditionBatchPositionModal_ClearanceItemFragmentFragment': EditExpeditionBatchPositionModal_ClearanceItemFragmentFragment } }
  ) | null> | null, processStatus?: { id?: string | null } | null } & { ' $fragmentName'?: 'ClearanceItemsInTable_OrderFragmentFragment' };

export type OrderHeader_OrderFragmentFragment = { id?: number | null, reservationNumber?: number | null, isPaid?: boolean | null, note?: string | null, privateNote?: string | null, processStatus?: { name?: string | null } | null, files?: Array<{ id?: number | null } | null> | null, shippingAddress?: { firstName?: string | null, lastName?: string | null } | null, tags?: Array<(
    { id?: number | null, name?: string | null, color?: string | null }
    & { ' $fragmentRefs'?: { 'TagComponent_TagFragmentFragment': TagComponent_TagFragmentFragment } }
  ) | null> | null, items?: Array<{ id?: number | null, product?: { isFragile?: boolean | null, isOversize?: boolean | null } | null } | null> | null } & { ' $fragmentName'?: 'OrderHeader_OrderFragmentFragment' };

export type OrderDetailQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type OrderDetailQuery = { order?: { errors?: Array<string | null> | null, data?: { ' $fragmentRefs'?: { 'OrderDetail_OrderFragmentFragment': OrderDetail_OrderFragmentFragment } } | null } | null };

export type OrderDetail_OrderFragmentFragment = (
  { id?: number | null }
  & { ' $fragmentRefs'?: { 'EditExpeditionBatchPositionModal_OrderFragmentFragment': EditExpeditionBatchPositionModal_OrderFragmentFragment;'ClearanceItemsInTable_OrderFragmentFragment': ClearanceItemsInTable_OrderFragmentFragment;'PickingCheckboxCell_OrderFragmentFragment': PickingCheckboxCell_OrderFragmentFragment;'OrderReturns_OrderFragmentFragment': OrderReturns_OrderFragmentFragment;'OrderProducts_OrderFragmentFragment': OrderProducts_OrderFragmentFragment;'OrderItemsTable_OrderFragmentFragment': OrderItemsTable_OrderFragmentFragment;'Footer_OrderFragmentFragment': Footer_OrderFragmentFragment;'PackingCheckboxCell_OrderFragmentFragment': PackingCheckboxCell_OrderFragmentFragment;'CarrierCurrencyPayment_OrderFragmentFragment': CarrierCurrencyPayment_OrderFragmentFragment;'PackageDetail_OrderFragmentFragment': PackageDetail_OrderFragmentFragment;'ReturnAllModal_OrderFragmentFragment': ReturnAllModal_OrderFragmentFragment;'EditReturnItemModal_OrderFragmentFragment': EditReturnItemModal_OrderFragmentFragment;'OrderItemsInPackages_OrderFragmentFragment': OrderItemsInPackages_OrderFragmentFragment;'OrderInfo_OrderFragmentFragment': OrderInfo_OrderFragmentFragment;'OrderStateHistory_OrderFragmentFragment': OrderStateHistory_OrderFragmentFragment;'OrderDetailsInfo_OrderFragmentFragment': OrderDetailsInfo_OrderFragmentFragment;'OrderFiles_OrderFragmentFragment': OrderFiles_OrderFragmentFragment;'OrderHeader_OrderFragmentFragment': OrderHeader_OrderFragmentFragment;'UseOrderPicking_OrderFragmentFragment': UseOrderPicking_OrderFragmentFragment;'OrderListItem_OrderFragment': OrderListItem_OrderFragment } }
) & { ' $fragmentName'?: 'OrderDetail_OrderFragmentFragment' };

export type OrderDetails_AddressFragmentFragment = { id?: number | null, firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null, companyName?: string | null, ic?: string | null, dic?: string | null, street?: string | null, zip?: string | null, note?: string | null, city?: string | null, country?: string | null, state?: string | null, branchId?: string | null } & { ' $fragmentName'?: 'OrderDetails_AddressFragmentFragment' };

export type OrderDetailsInfo_OrderFragmentFragment = { id?: number | null, note?: string | null, privateNote?: string | null, shippingAddress?: (
    { id?: number | null }
    & { ' $fragmentRefs'?: { 'OrderDetails_AddressFragmentFragment': OrderDetails_AddressFragmentFragment } }
  ) | null, carrier?: { id?: string | null, name?: string | null } | null, currency?: { id?: string | null, name?: string | null } | null, tags?: Array<{ id?: number | null, name?: string | null, color?: string | null } | null> | null, paymentItems?: Array<{ id?: number | null, amount?: number | null, isPaid?: boolean | null, payment?: { id?: number | null, name?: string | null, type?: { id?: string | null, name?: string | null } | null } | null } | null> | null, packages?: Array<{ id?: number | null, sent?: any | null, code?: string | null, weight?: number | null, dimensionX?: number | null, dimensionY?: number | null, dimensionZ?: number | null, carrier?: { id?: string | null, name?: string | null } | null, tariff?: { id?: number | null, name?: string | null } | null } | null> | null } & { ' $fragmentName'?: 'OrderDetailsInfo_OrderFragmentFragment' };

export type ResetPackageFromOrderInfoMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ResetPackageFromOrderInfoMutation = { resetPackage?: { errors?: Array<string | null> | null } | null };

export type UpdateOrderMutationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  carrier?: InputMaybe<Scalars['String']['input']>;
  shippingAddress?: InputMaybe<Scalars['Int']['input']>;
  paymentItems?: InputMaybe<Array<InputMaybe<updatePaymentItem_>> | InputMaybe<updatePaymentItem_>>;
  note?: InputMaybe<Scalars['String']['input']>;
  privateNote?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOrderMutationMutation = { updateOrder?: { errors?: Array<string | null> | null, data?: { id?: number | null, isPaid?: boolean | null, note?: string | null, privateNote?: string | null, currency?: { id?: string | null } | null, paymentItems?: Array<{ id?: number | null, isPaid?: boolean | null, amount?: number | null, payment?: { id?: number | null } | null } | null> | null, shippingAddress?: { ' $fragmentRefs'?: { 'OrderDetails_AddressFragmentFragment': OrderDetails_AddressFragmentFragment } } | null, carrier?: { id?: string | null, name?: string | null, requiredShippingAddress?: boolean | null, tariffs?: Array<{ id?: number | null, name?: string | null } | null> | null } | null, tags?: Array<{ id?: number | null, name?: string | null, color?: string | null } | null> | null } | null } | null };

export type UpdateAddressMutationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  ic?: InputMaybe<Scalars['String']['input']>;
  dic?: InputMaybe<Scalars['String']['input']>;
  branchId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateAddressMutationMutation = { updateAddress?: { errors?: Array<string | null> | null, data?: { ' $fragmentRefs'?: { 'OrderDetails_AddressFragmentFragment': OrderDetails_AddressFragmentFragment } } | null } | null };

export type CreateAddressMutationMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  ic?: InputMaybe<Scalars['String']['input']>;
  dic?: InputMaybe<Scalars['String']['input']>;
  branchId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateAddressMutationMutation = { createAddress?: { errors?: Array<string | null> | null, data?: (
      { id?: number | null }
      & { ' $fragmentRefs'?: { 'OrderDetails_AddressFragmentFragment': OrderDetails_AddressFragmentFragment } }
    ) | null } | null };

export type OrderItemsTable_OrderItemFragmentFragment = (
  { id?: number | null, name?: string | null, ean?: string | null, code?: string | null, note?: string | null, quantity?: number | null, quantityUnavailable?: number | null, product?: (
    { id?: number | null, name?: string | null, ean?: string | null, ean2?: string | null, ean3?: string | null, ean4?: string | null, ean5?: string | null, code?: string | null, isBundle?: boolean | null, note?: string | null, bundleChildren?: Array<{ quantity?: number | null, child?: (
        { id?: number | null, name?: string | null, code?: string | null, note?: string | null, ean?: string | null, ean2?: string | null, ean3?: string | null, ean4?: string | null, ean5?: string | null }
        & { ' $fragmentRefs'?: { 'ProductCell_ProductFragmentFragment': ProductCell_ProductFragmentFragment } }
      ) | null } | null> | null }
    & { ' $fragmentRefs'?: { 'ProductCell_ProductFragmentFragment': ProductCell_ProductFragmentFragment } }
  ) | null, clearanceItems?: Array<{ id?: string | null, position?: string | null, amount?: number | null, expirationDate?: any | null, picked?: number | null, packed?: number | null, product?: { id?: number | null } | null } | null> | null }
  & { ' $fragmentRefs'?: { 'EditOrderItemModal_OrderItemFragmentFragment': EditOrderItemModal_OrderItemFragmentFragment } }
) & { ' $fragmentName'?: 'OrderItemsTable_OrderItemFragmentFragment' };

export type OrderItemsTable_OrderFragmentFragment = { id?: number | null, processStatus?: { id?: string | null } | null } & { ' $fragmentName'?: 'OrderItemsTable_OrderFragmentFragment' };

export type UpdateClearanceItemBulkMutationVariables = Exact<{
  id: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  picked?: InputMaybe<Scalars['Int']['input']>;
  packed?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateClearanceItemBulkMutation = { updateClearanceItem?: { errors?: Array<string | null> | null, data?: { id?: string | null, picked?: number | null, packed?: number | null } | null } | null };

export type UpdateOrder_OrderProductsMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  boxes: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateOrder_OrderProductsMutation = { updateOrder?: { data?: { id?: number | null, boxes?: Array<string | null> | null } | null } | null };

export type CreateOrderFileFromCameraInProductsMutationVariables = Exact<{
  base64Data: Scalars['String']['input'];
  text: Scalars['String']['input'];
  originalFilename: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateOrderFileFromCameraInProductsMutation = { createFile?: { errors?: Array<string | null> | null, data?: { id?: number | null } | null } | null };

export type OrderProducts_OrderFragmentFragment = { id?: number | null, boxes?: Array<string | null> | null, items?: Array<(
    { id?: number | null, type?: string | null }
    & { ' $fragmentRefs'?: { 'OrderItemsTable_OrderItemFragmentFragment': OrderItemsTable_OrderItemFragmentFragment } }
  ) | null> | null, clearanceItems?: Array<{ id?: string | null, amount?: number | null } | null> | null, processStatus?: { id?: string | null, name?: string | null } | null } & { ' $fragmentName'?: 'OrderProducts_OrderFragmentFragment' };

export type OrderReturns_OrderFragmentFragment = { id?: number | null, reservationNumber?: number | null, processStatus?: { id?: string | null, name?: string | null } | null, checkout?: { id?: number | null, returnsDepot?: { id?: number | null, name?: string | null } | null, depots?: Array<{ id?: number | null, name?: string | null } | null> | null } | null, items?: Array<(
    { id?: number | null, type?: string | null, quantity?: number | null, product?: (
      { id?: number | null, name?: string | null, requiredSerialNumbers?: boolean | null }
      & { ' $fragmentRefs'?: { 'ProductCell_ProductFragmentFragment': ProductCell_ProductFragmentFragment } }
    ) | null, clearanceItems?: Array<{ id?: string | null, amount?: number | null, position1?: string | null, position2?: string | null, position3?: string | null, batch?: string | null, expirationDate?: any | null, product?: (
        { id?: number | null, name?: string | null, code?: string | null, ean?: string | null, ean2?: string | null, ean3?: string | null, ean4?: string | null, ean5?: string | null, requiredSerialNumbers?: boolean | null }
        & { ' $fragmentRefs'?: { 'ProductCell_ProductFragmentFragment': ProductCell_ProductFragmentFragment } }
      ) | null, productDepots?: Array<{ depot?: { id?: number | null } | null } | null> | null } | null> | null }
    & { ' $fragmentRefs'?: { 'OrderReturnsTable_OrderItemFragmentFragment': OrderReturnsTable_OrderItemFragmentFragment } }
  ) | null> | null } & { ' $fragmentName'?: 'OrderReturns_OrderFragmentFragment' };

export type GetProductMovePacksQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type GetProductMovePacksQuery = { productMovePacks?: { items?: Array<(
      { id?: number | null, moves?: Array<{ serialNumbers?: Array<string | null> | null, amount?: number | null, orderItem?: { id?: number | null } | null, product?: { id?: number | null } | null } | null> | null }
      & { ' $fragmentRefs'?: { 'CompletedReturnsTable_ProductMovePackFragmentFragment': CompletedReturnsTable_ProductMovePackFragmentFragment } }
    ) | null> | null } | null };

export type ActiveReturnsTable_DepotFragmentFragment = { id?: number | null, name?: string | null } & { ' $fragmentName'?: 'ActiveReturnsTable_DepotFragmentFragment' };

export type DeletePaymentItemMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeletePaymentItemMutation = { deletePaymentItem?: { errors?: Array<string | null> | null } | null };

export type CarrierCurrencyPayment_OrderFragmentFragment = { id?: number | null, currency?: { id?: string | null } | null, paymentItems?: Array<{ id?: number | null, amount?: number | null, isPaid?: boolean | null, payment?: { id?: number | null, name?: string | null } | null } | null> | null } & { ' $fragmentName'?: 'CarrierCurrencyPayment_OrderFragmentFragment' };

export type CompletedReturnsTable_ProductMoveFragmentFragment = { id?: number | null, amount?: number | null, productDepotTo?: { position?: string | null, expirationDate?: any | null, batch?: string | null, depot?: { id?: number | null, name?: string | null } | null } | null, product?: { id?: number | null, name?: string | null, code?: string | null, ean?: string | null, mainImage?: { thumbnails?: Array<{ format?: string | null, url?: string | null } | null> | null } | null } | null } & { ' $fragmentName'?: 'CompletedReturnsTable_ProductMoveFragmentFragment' };

export type CompletedReturnsTable_ProductMovePackFragmentFragment = { id?: number | null, number?: number | null, dateCreated?: any | null, moves?: Array<{ ' $fragmentRefs'?: { 'CompletedReturnsTable_ProductMoveFragmentFragment': CompletedReturnsTable_ProductMoveFragmentFragment } } | null> | null } & { ' $fragmentName'?: 'CompletedReturnsTable_ProductMovePackFragmentFragment' };

export type UpdateClearanceItemLocationsMutationVariables = Exact<{
  id: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  locations: Array<InputMaybe<updateClearanceItemLocations>> | InputMaybe<updateClearanceItemLocations>;
}>;


export type UpdateClearanceItemLocationsMutation = { updateClearanceItem?: { errors?: Array<string | null> | null } | null };

export type EditExpeditionBatchPositionModal_ClearanceItemFragmentFragment = { id?: string | null, amount?: number | null, product?: { id?: number | null, fullName?: string | null, productDepots?: Array<{ id?: number | null, batch?: string | null, expirationDate?: any | null, quantityAvailable?: number | null, quantityStock?: number | null, quantityReservation?: number | null, position?: string | null, position1?: string | null, position2?: string | null, position3?: string | null, depot?: { id?: number | null } | null } | null> | null } | null, productDepots?: Array<{ id?: number | null, batch?: string | null, expirationDate?: any | null, position1?: string | null, position2?: string | null, depot?: { id?: number | null } | null } | null> | null } & { ' $fragmentName'?: 'EditExpeditionBatchPositionModal_ClearanceItemFragmentFragment' };

export type EditExpeditionBatchPositionModal_OrderFragmentFragment = { id?: number | null, checkout?: { depots?: Array<{ id?: number | null } | null> | null } | null, clearanceItems?: Array<{ ' $fragmentRefs'?: { 'EditExpeditionBatchPositionModal_ClearanceItemFragmentFragment': EditExpeditionBatchPositionModal_ClearanceItemFragmentFragment } } | null> | null } & { ' $fragmentName'?: 'EditExpeditionBatchPositionModal_OrderFragmentFragment' };

export type UpdateOrderItemMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  note: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
}>;


export type UpdateOrderItemMutation = { updateOrderItem?: { errors?: Array<string | null> | null, data?: { ' $fragmentRefs'?: { 'EditOrderItemModal_OrderItemFragmentFragment': EditOrderItemModal_OrderItemFragmentFragment;'OrderItemsTable_OrderItemFragmentFragment': OrderItemsTable_OrderItemFragmentFragment } } | null } | null };

export type DeleteOrderItemMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteOrderItemMutation = { deleteOrderItem?: { errors?: Array<string | null> | null } | null };

export type EditOrderItemModal_OrderItemFragmentFragment = { id?: number | null, name?: string | null, note?: string | null, quantity?: number | null, order?: { id?: number | null } | null } & { ' $fragmentName'?: 'EditOrderItemModal_OrderItemFragmentFragment' };

export type EditReturnItemModal_OrderItemFragmentFragment = { id?: number | null, name?: string | null, code?: string | null, ean?: string | null, quantity?: number | null, note?: string | null, product?: { id?: number | null, name?: string | null, isBundle?: boolean | null } | null, moves?: Array<{ id?: number | null, amount?: number | null, productDepotFrom?: { id?: number | null, batch?: string | null, expirationDate?: any | null, position1?: string | null, position2?: string | null, position3?: string | null, depot?: { id?: number | null, name?: string | null } | null, supplier?: { id?: number | null, name?: string | null } | null } | null } | null> | null } & { ' $fragmentName'?: 'EditReturnItemModal_OrderItemFragmentFragment' };

export type EditReturnItemModal_OrderFragmentFragment = { id?: number | null, company?: { id?: number | null } | null } & { ' $fragmentName'?: 'EditReturnItemModal_OrderFragmentFragment' };

export type Footer_OrderFragmentFragment = { id?: number | null, reservationUrl?: string | null, invoiceUrl?: string | null, processStatus?: { id?: string | null, name?: string | null } | null, processStatusRelations?: Array<{ created?: any | null, status?: { id?: string | null } | null } | null> | null, carrier?: { id?: string | null, name?: string | null, requiredShippingAddress?: boolean | null } | null, shippingAddress?: { id?: number | null } | null, clearanceItems?: Array<{ id?: string | null, picked?: number | null, packed?: number | null, amount?: number | null } | null> | null, items?: Array<{ id?: number | null, type?: string | null, packed?: boolean | null } | null> | null, packages?: Array<{ sent?: any | null, id?: number | null, ticketUrl?: string | null, carrier?: { id?: string | null, name?: string | null, color?: string | null, position?: number | null, tariffs?: Array<{ id?: number | null, name?: string | null } | null> | null } | null } | null> | null, movePacks?: Array<{ id?: number | null, pdfWOPricesUrl?: string | null } | null> | null } & { ' $fragmentName'?: 'Footer_OrderFragmentFragment' };

export type OrderInfo_CheckoutFragmentFragment = { id?: number | null, name?: string | null } & { ' $fragmentName'?: 'OrderInfo_CheckoutFragmentFragment' };

export type OrderInfo_OrderFragmentFragment = { id?: number | null, reservationNumber?: number | null, billNumber?: number | null, dateCreated?: any | null, dateExpedition?: any | null, priority?: number | null, createdBy?: { id?: number | null, name?: string | null } | null, checkout?: { ' $fragmentRefs'?: { 'OrderInfo_CheckoutFragmentFragment': OrderInfo_CheckoutFragmentFragment } } | null } & { ' $fragmentName'?: 'OrderInfo_OrderFragmentFragment' };

export type CreateNewPackageMutationVariables = Exact<{
  order: Scalars['Int']['input'];
  items: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  tariff?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  carrier: Scalars['String']['input'];
  dimensionX?: InputMaybe<Scalars['Float']['input']>;
  dimensionY?: InputMaybe<Scalars['Float']['input']>;
  dimensionZ?: InputMaybe<Scalars['Float']['input']>;
}>;


export type CreateNewPackageMutation = { createPackage?: { errors?: Array<string | null> | null, data?: { id?: number | null, code?: string | null, sent?: any | null, weight?: number | null, dimensionX?: number | null, dimensionY?: number | null, dimensionZ?: number | null, carrier?: { id?: string | null, name?: string | null, tariffs?: Array<{ id?: number | null, name?: string | null } | null> | null } | null, tariff?: { id?: number | null, name?: string | null } | null, items?: Array<{ id?: number | null, type?: string | null } | null> | null } | null } | null };

export type DeletePackageMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeletePackageMutation = { deletePackage?: { errors?: Array<string | null> | null } | null };

export type UpdatePackageMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  items: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  tariff?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  dimensionX?: InputMaybe<Scalars['Float']['input']>;
  dimensionY?: InputMaybe<Scalars['Float']['input']>;
  dimensionZ?: InputMaybe<Scalars['Float']['input']>;
}>;


export type UpdatePackageMutation = { updatePackage?: { errors?: Array<string | null> | null, data?: { id?: number | null, code?: string | null, sent?: any | null, weight?: number | null, dimensionX?: number | null, dimensionY?: number | null, dimensionZ?: number | null, carrier?: { id?: string | null, name?: string | null, tariffs?: Array<{ id?: number | null, name?: string | null } | null> | null } | null, tariff?: { id?: number | null, name?: string | null } | null, items?: Array<{ id?: number | null, type?: string | null } | null> | null } | null } | null };

export type ResetPackageMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ResetPackageMutation = { resetPackage?: { errors?: Array<string | null> | null } | null };

export type OrderItemsInPackages_OrderFragmentFragment = { id?: number | null, carrier?: { id?: string | null, name?: string | null, tariffs?: Array<{ id?: number | null, name?: string | null } | null> | null } | null, processStatus?: { id?: string | null } | null, shippingAddress?: { id?: number | null } | null, items?: Array<(
    { id?: number | null, type?: string | null, packed?: boolean | null }
    & { ' $fragmentRefs'?: { 'OrderItemsTable_OrderItemFragmentFragment': OrderItemsTable_OrderItemFragmentFragment } }
  ) | null> | null, packages?: Array<{ id?: number | null, code?: string | null, sent?: any | null, weight?: number | null, dimensionX?: number | null, dimensionY?: number | null, dimensionZ?: number | null, carrier?: { id?: string | null, name?: string | null, tariffs?: Array<{ id?: number | null, name?: string | null } | null> | null } | null, tariff?: { id?: number | null, name?: string | null } | null, items?: Array<{ id?: number | null, type?: string | null } | null> | null } | null> | null } & { ' $fragmentName'?: 'OrderItemsInPackages_OrderFragmentFragment' };

export type OrderReturnsTable_OrderItemFragmentFragment = (
  { id?: number | null, name?: string | null, code?: string | null, ean?: string | null, quantity?: number | null, type?: string | null, product?: (
    { code?: string | null, ean?: string | null, ean2?: string | null, ean3?: string | null, ean4?: string | null, ean5?: string | null, bundleChildren?: Array<{ child?: (
        { ean2?: string | null, ean3?: string | null, ean4?: string | null, ean5?: string | null }
        & { ' $fragmentRefs'?: { 'ProductCell_ProductFragmentFragment': ProductCell_ProductFragmentFragment } }
      ) | null } | null> | null }
    & { ' $fragmentRefs'?: { 'ProductCell_ProductFragmentFragment': ProductCell_ProductFragmentFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'EditReturnItemModal_OrderItemFragmentFragment': EditReturnItemModal_OrderItemFragmentFragment } }
) & { ' $fragmentName'?: 'OrderReturnsTable_OrderItemFragmentFragment' };

export type OrderStateHistory_OrderFragmentFragment = { id?: number | null, processStatusRelations?: Array<{ created?: any | null, note?: string | null, status?: { id?: string | null } | null, createdBy?: { name?: string | null, email?: string | null } | null } | null> | null } & { ' $fragmentName'?: 'OrderStateHistory_OrderFragmentFragment' };

export type SendPackageMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type SendPackageMutation = { sendPackage?: { errors?: Array<string | null> | null } | null };

export type UpdateOrderItemPackingMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  packed: Scalars['Boolean']['input'];
}>;


export type UpdateOrderItemPackingMutation = { updateOrderItem?: { errors?: Array<string | null> | null, data?: { id?: number | null, packed?: boolean | null } | null } | null };

export type PackageDetail_OrderFragmentFragment = { id?: number | null, carrier?: { id?: string | null, name?: string | null, requiredShippingAddress?: boolean | null, tariffs?: Array<{ id?: number | null, name?: string | null } | null> | null } | null, shippingAddress?: { id?: number | null } | null, packages?: Array<{ ticketUrl?: string | null, id?: number | null, code?: string | null, sent?: any | null, carrier?: { id?: string | null, name?: string | null, tariffs?: Array<{ id?: number | null, name?: string | null } | null> | null } | null } | null> | null } & { ' $fragmentName'?: 'PackageDetail_OrderFragmentFragment' };

export type UpdateClearanceItemPackingResetMutationVariables = Exact<{
  id: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  packed?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateClearanceItemPackingResetMutation = { updateClearanceItem?: { errors?: Array<string | null> | null, data?: { id?: string | null, packed?: number | null, amount?: number | null } | null } | null };

export type PackingCheckboxCell_OrderFragmentFragment = { id?: number | null, items?: Array<{ id?: number | null, packed?: boolean | null, clearanceItems?: Array<{ id?: string | null } | null> | null } | null> | null, processStatus?: { id?: string | null } | null } & { ' $fragmentName'?: 'PackingCheckboxCell_OrderFragmentFragment' };

export type UpdateClearanceItemPickingMutationVariables = Exact<{
  id: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  picked?: InputMaybe<Scalars['Int']['input']>;
  packed?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateClearanceItemPickingMutation = { updateClearanceItem?: { errors?: Array<string | null> | null, data?: { picked?: number | null, packed?: number | null, amount?: number | null } | null } | null };

export type PickingCheckboxCell_OrderFragmentFragment = { id?: number | null, clearanceItems?: Array<{ id?: string | null, picked?: number | null, packed?: number | null, amount?: number | null } | null> | null, processStatus?: { id?: string | null } | null } & { ' $fragmentName'?: 'PickingCheckboxCell_OrderFragmentFragment' };

export type ProductCell_ProductFragmentFragment = { id?: number | null, fullName?: string | null, code?: string | null, ean?: string | null, name?: string | null, isFragile?: boolean | null, isOversize?: boolean | null, mainImage?: { thumbnails?: Array<{ format?: string | null, url?: string | null } | null> | null } | null, files?: Array<{ id?: number | null } | null> | null, tags?: Array<(
    { id?: number | null }
    & { ' $fragmentRefs'?: { 'TagComponent_TagFragmentFragment': TagComponent_TagFragmentFragment } }
  ) | null> | null } & { ' $fragmentName'?: 'ProductCell_ProductFragmentFragment' };

export type ReturnAllModal_OrderItemFragmentFragment = { id?: number | null, clearanceItems?: Array<{ id?: string | null, productDepots?: Array<{ depot?: { id?: number | null } | null } | null> | null } | null> | null } & { ' $fragmentName'?: 'ReturnAllModal_OrderItemFragmentFragment' };

export type ReturnAllModal_OrderFragmentFragment = { id?: number | null, company?: { id?: number | null } | null, items?: Array<{ ' $fragmentRefs'?: { 'ReturnAllModal_OrderItemFragmentFragment': ReturnAllModal_OrderItemFragmentFragment } } | null> | null } & { ' $fragmentName'?: 'ReturnAllModal_OrderFragmentFragment' };

export type UseOrderPicking_OrderFragmentFragment = { id?: number | null, processStatus?: { id?: string | null } | null, items?: Array<{ id?: number | null, clearanceItems?: Array<{ id?: string | null } | null> | null } | null> | null, clearanceItems?: Array<{ id?: string | null, amount?: number | null, picked?: number | null, packed?: number | null, product?: { id?: number | null, fullName?: string | null, ean?: string | null, ean2?: string | null, ean3?: string | null, ean4?: string | null, ean5?: string | null, code?: string | null } | null } | null> | null } & { ' $fragmentName'?: 'UseOrderPicking_OrderFragmentFragment' };

export type UpdateClearanceItemPickingHookMutationVariables = Exact<{
  id: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  picked?: InputMaybe<Scalars['Int']['input']>;
  packed?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateClearanceItemPickingHookMutation = { updateClearanceItem?: { errors?: Array<string | null> | null, data?: { id?: string | null, picked?: number | null, packed?: number | null, amount?: number | null } | null } | null };

export type UpdateOrderItemsPickingHookMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  picked?: InputMaybe<Scalars['Boolean']['input']>;
  packed?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateOrderItemsPickingHookMutation = { updateOrderItem?: { errors?: Array<string | null> | null, data?: { id?: number | null, picked?: boolean | null, packed?: boolean | null } | null } | null };

export type UpdateOrderProcessStatusMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  status: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOrderProcessStatusMutation = { updateOrder?: { errors?: Array<string | null> | null, data?: { processStatus?: { id?: string | null } | null } | null } | null };

export type SendPackageMutationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type SendPackageMutationMutation = { sendPackage?: { errors?: Array<string | null> | null, data?: { id?: number | null, ticketUrl?: string | null, carrier?: { id?: string | null } | null } | null } | null };

export type CreateProductMovePackReturnMutationVariables = Exact<{
  type: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  moves: Array<InputMaybe<createProductMove>> | InputMaybe<createProductMove>;
}>;


export type CreateProductMovePackReturnMutation = { createProductMovePack?: { errors?: Array<string | null> | null, data?: { id?: number | null } | null } | null };

export type UpdateOrderProcessStatusForReturnsMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  status: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOrderProcessStatusForReturnsMutation = { updateOrder?: { errors?: Array<string | null> | null, data?: { id?: number | null, processStatus?: { id?: string | null, name?: string | null } | null } | null } | null };

export type GroupClearanceItems_OrderGroupFragment = { id?: number | null, clearanceItems?: Array<{ id?: string | null, amount?: number | null, position?: string | null, expirationDate?: any | null, batch?: string | null, product?: (
      { ean?: string | null, code?: string | null }
      & { ' $fragmentRefs'?: { 'ProductCell_ProductFragmentFragment': ProductCell_ProductFragmentFragment } }
    ) | null } | null> | null } & { ' $fragmentName'?: 'GroupClearanceItems_OrderGroupFragment' };

export type GroupOrdersTables_OrderGroupFragment = { id?: number | null, orders?: Array<{ id?: number | null, reservationNumber?: number | null, clearanceItems?: Array<{ id?: string | null } | null> | null, carrier?: { id?: string | null, name?: string | null } | null } | null> | null } & { ' $fragmentName'?: 'GroupOrdersTables_OrderGroupFragment' };

export type OrderGroupDetailQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type OrderGroupDetailQuery = { orderGroup?: { errors?: Array<string | null> | null, data?: (
      { orders?: Array<{ id?: number | null } | null> | null }
      & { ' $fragmentRefs'?: { 'Header_OrderGroupFragment': Header_OrderGroupFragment;'GroupOrders_OrderGroupFragment': GroupOrders_OrderGroupFragment;'GroupClearanceItems_OrderGroupFragment': GroupClearanceItems_OrderGroupFragment;'SubmitAllOrders_OrderGroupFragment': SubmitAllOrders_OrderGroupFragment } }
    ) | null } | null };

export type GroupOrders_OrderGroupFragment = { id?: number | null, orders?: Array<(
    { id?: number | null, reservationNumber?: number | null, clearanceItems?: Array<{ id?: string | null } | null> | null, carrier?: { id?: string | null, name?: string | null } | null }
    & { ' $fragmentRefs'?: { 'OrderListItem_OrderFragment': OrderListItem_OrderFragment } }
  ) | null> | null } & { ' $fragmentName'?: 'GroupOrders_OrderGroupFragment' };

export type Header_OrderGroupFragment = { id?: number | null, name?: string | null, user?: { id?: number | null, name?: string | null } | null, tags?: Array<(
    { id?: number | null, name?: string | null, color?: string | null }
    & { ' $fragmentRefs'?: { 'TagComponent_TagFragmentFragment': TagComponent_TagFragmentFragment } }
  ) | null> | null, orders?: Array<{ id?: number | null } | null> | null } & { ' $fragmentName'?: 'Header_OrderGroupFragment' };

export type SubmitAllOrders_OrderGroupFragment = { id?: number | null, orders?: Array<{ id?: number | null, processStatus?: { id?: string | null } | null, items?: Array<{ id?: number | null, clearanceItems?: Array<{ id?: string | null } | null> | null } | null> | null, packages?: Array<{ id?: number | null, items?: Array<{ id?: number | null } | null> | null } | null> | null, carrier?: { id?: string | null } | null } | null> | null } & { ' $fragmentName'?: 'SubmitAllOrders_OrderGroupFragment' };

export type SubmitOrderMutationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  status: Scalars['String']['input'];
}>;


export type SubmitOrderMutationMutation = { updateOrder?: { errors?: Array<string | null> | null, data?: { processStatus?: { id?: string | null } | null } | null } | null };

export type CreatePackageForGroupOrderMutationMutationVariables = Exact<{
  order: Scalars['Int']['input'];
  items: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  carrier: Scalars['String']['input'];
}>;


export type CreatePackageForGroupOrderMutationMutation = { createPackage?: { errors?: Array<string | null> | null, data?: { id?: number | null } | null } | null };

export type SendPackageForGroupOrderMutationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type SendPackageForGroupOrderMutationMutation = { sendPackage?: { errors?: Array<string | null> | null, data?: { id?: number | null, ticketUrl?: string | null, carrier?: { id?: string | null } | null } | null } | null };

export const TagComponent_TagFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagComponent_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<TagComponent_TagFragmentFragment, unknown>;
export const BasicEntities_TagFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicEntities_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagComponent_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<BasicEntities_TagFragmentFragment, unknown>;
export const BasicEntities_DepotFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicEntities_DepotFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Depot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<BasicEntities_DepotFragmentFragment, unknown>;
export const BasicEntities_CarrierFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicEntities_CarrierFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Carrier"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<BasicEntities_CarrierFragmentFragment, unknown>;
export const BasicEntities_CheckoutFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicEntities_CheckoutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<BasicEntities_CheckoutFragmentFragment, unknown>;
export const BasicEntities_CurrencyFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicEntities_CurrencyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Currency"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<BasicEntities_CurrencyFragmentFragment, unknown>;
export const BasicEntities_PaymentFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicEntities_PaymentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Payment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<BasicEntities_PaymentFragmentFragment, unknown>;
export const DisposalCreateTable_PackageFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisposalCreateTable_PackageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Package"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]} as unknown as DocumentNode<DisposalCreateTable_PackageFragmentFragment, unknown>;
export const DisposalTable_DisposalFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisposalTable_DisposalFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PackageDisposal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ticketUrl"}},{"kind":"Field","name":{"kind":"Name","value":"sent"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DisposalTable_DisposalFragmentFragment, unknown>;
export const GroupListItem_OrderGroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupListItem_OrderGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"ordersCount"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagComponent_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<GroupListItem_OrderGroupFragment, unknown>;
export const EditExpeditionBatchPositionModal_ClearanceItemFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditExpeditionBatchPositionModal_ClearanceItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClearanceItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"productDepots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"quantityAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"quantityStock"}},{"kind":"Field","name":{"kind":"Name","value":"quantityReservation"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"position1"}},{"kind":"Field","name":{"kind":"Name","value":"position2"}},{"kind":"Field","name":{"kind":"Name","value":"position3"}},{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"productDepots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"position1"}},{"kind":"Field","name":{"kind":"Name","value":"position2"}}]}}]}}]} as unknown as DocumentNode<EditExpeditionBatchPositionModal_ClearanceItemFragmentFragment, unknown>;
export const EditExpeditionBatchPositionModal_OrderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditExpeditionBatchPositionModal_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditExpeditionBatchPositionModal_ClearanceItemFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditExpeditionBatchPositionModal_ClearanceItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClearanceItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"productDepots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"quantityAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"quantityStock"}},{"kind":"Field","name":{"kind":"Name","value":"quantityReservation"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"position1"}},{"kind":"Field","name":{"kind":"Name","value":"position2"}},{"kind":"Field","name":{"kind":"Name","value":"position3"}},{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"productDepots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"position1"}},{"kind":"Field","name":{"kind":"Name","value":"position2"}}]}}]}}]} as unknown as DocumentNode<EditExpeditionBatchPositionModal_OrderFragmentFragment, unknown>;
export const ProductCell_ProductFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCell_ProductFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isFragile"}},{"kind":"Field","name":{"kind":"Name","value":"isOversize"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagComponent_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<ProductCell_ProductFragmentFragment, unknown>;
export const ClearanceItemsInTable_OrderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClearanceItemsInTable_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"picked"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditExpeditionBatchPositionModal_ClearanceItemFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagComponent_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCell_ProductFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isFragile"}},{"kind":"Field","name":{"kind":"Name","value":"isOversize"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditExpeditionBatchPositionModal_ClearanceItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClearanceItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"productDepots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"quantityAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"quantityStock"}},{"kind":"Field","name":{"kind":"Name","value":"quantityReservation"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"position1"}},{"kind":"Field","name":{"kind":"Name","value":"position2"}},{"kind":"Field","name":{"kind":"Name","value":"position3"}},{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"productDepots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"position1"}},{"kind":"Field","name":{"kind":"Name","value":"position2"}}]}}]}}]} as unknown as DocumentNode<ClearanceItemsInTable_OrderFragmentFragment, unknown>;
export const PickingCheckboxCell_OrderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PickingCheckboxCell_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"picked"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PickingCheckboxCell_OrderFragmentFragment, unknown>;
export const EditReturnItemModal_OrderItemFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditReturnItemModal_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isBundle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"moves"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"productDepotFrom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"position1"}},{"kind":"Field","name":{"kind":"Name","value":"position2"}},{"kind":"Field","name":{"kind":"Name","value":"position3"}},{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EditReturnItemModal_OrderItemFragmentFragment, unknown>;
export const OrderReturnsTable_OrderItemFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderReturnsTable_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"Field","name":{"kind":"Name","value":"bundleChildren"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"child"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditReturnItemModal_OrderItemFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagComponent_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCell_ProductFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isFragile"}},{"kind":"Field","name":{"kind":"Name","value":"isOversize"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditReturnItemModal_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isBundle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"moves"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"productDepotFrom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"position1"}},{"kind":"Field","name":{"kind":"Name","value":"position2"}},{"kind":"Field","name":{"kind":"Name","value":"position3"}},{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrderReturnsTable_OrderItemFragmentFragment, unknown>;
export const OrderReturns_OrderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderReturns_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reservationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"returnsDepot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"depots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"requiredSerialNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"position1"}},{"kind":"Field","name":{"kind":"Name","value":"position2"}},{"kind":"Field","name":{"kind":"Name","value":"position3"}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"Field","name":{"kind":"Name","value":"requiredSerialNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productDepots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderReturnsTable_OrderItemFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagComponent_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCell_ProductFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isFragile"}},{"kind":"Field","name":{"kind":"Name","value":"isOversize"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditReturnItemModal_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isBundle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"moves"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"productDepotFrom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"position1"}},{"kind":"Field","name":{"kind":"Name","value":"position2"}},{"kind":"Field","name":{"kind":"Name","value":"position3"}},{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderReturnsTable_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"Field","name":{"kind":"Name","value":"bundleChildren"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"child"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditReturnItemModal_OrderItemFragment"}}]}}]} as unknown as DocumentNode<OrderReturns_OrderFragmentFragment, unknown>;
export const EditOrderItemModal_OrderItemFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditOrderItemModal_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<EditOrderItemModal_OrderItemFragmentFragment, unknown>;
export const OrderItemsTable_OrderItemFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderItemsTable_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantityUnavailable"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"isBundle"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"bundleChildren"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"child"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"picked"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditOrderItemModal_OrderItemFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagComponent_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCell_ProductFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isFragile"}},{"kind":"Field","name":{"kind":"Name","value":"isOversize"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditOrderItemModal_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<OrderItemsTable_OrderItemFragmentFragment, unknown>;
export const OrderProducts_OrderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderProducts_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"boxes"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderItemsTable_OrderItemFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagComponent_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCell_ProductFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isFragile"}},{"kind":"Field","name":{"kind":"Name","value":"isOversize"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditOrderItemModal_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderItemsTable_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantityUnavailable"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"isBundle"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"bundleChildren"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"child"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"picked"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditOrderItemModal_OrderItemFragment"}}]}}]} as unknown as DocumentNode<OrderProducts_OrderFragmentFragment, unknown>;
export const OrderItemsTable_OrderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderItemsTable_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<OrderItemsTable_OrderFragmentFragment, unknown>;
export const Footer_OrderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Footer_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processStatusRelations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"requiredShippingAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"picked"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sent"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticketUrl"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"tariffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"movePacks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pdfWOPricesUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reservationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceUrl"}}]}}]} as unknown as DocumentNode<Footer_OrderFragmentFragment, unknown>;
export const PackingCheckboxCell_OrderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PackingCheckboxCell_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PackingCheckboxCell_OrderFragmentFragment, unknown>;
export const CarrierCurrencyPayment_OrderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierCurrencyPayment_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"isPaid"}}]}}]}}]} as unknown as DocumentNode<CarrierCurrencyPayment_OrderFragmentFragment, unknown>;
export const PackageDetail_OrderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PackageDetail_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"requiredShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"tariffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticketUrl"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"sent"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tariffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PackageDetail_OrderFragmentFragment, unknown>;
export const ReturnAllModal_OrderItemFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReturnAllModal_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productDepots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ReturnAllModal_OrderItemFragmentFragment, unknown>;
export const ReturnAllModal_OrderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReturnAllModal_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReturnAllModal_OrderItemFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReturnAllModal_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productDepots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ReturnAllModal_OrderFragmentFragment, unknown>;
export const EditReturnItemModal_OrderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditReturnItemModal_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<EditReturnItemModal_OrderFragmentFragment, unknown>;
export const OrderItemsInPackages_OrderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderItemsInPackages_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tariffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderItemsTable_OrderItemFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"sent"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tariffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tariff"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"dimensionX"}},{"kind":"Field","name":{"kind":"Name","value":"dimensionY"}},{"kind":"Field","name":{"kind":"Name","value":"dimensionZ"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagComponent_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCell_ProductFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isFragile"}},{"kind":"Field","name":{"kind":"Name","value":"isOversize"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditOrderItemModal_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderItemsTable_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantityUnavailable"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"isBundle"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"bundleChildren"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"child"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"picked"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditOrderItemModal_OrderItemFragment"}}]}}]} as unknown as DocumentNode<OrderItemsInPackages_OrderFragmentFragment, unknown>;
export const OrderInfo_CheckoutFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderInfo_CheckoutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<OrderInfo_CheckoutFragmentFragment, unknown>;
export const OrderInfo_OrderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderInfo_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reservationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"billNumber"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"dateExpedition"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderInfo_CheckoutFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderInfo_CheckoutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<OrderInfo_OrderFragmentFragment, unknown>;
export const OrderStateHistory_OrderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderStateHistory_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processStatusRelations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}}]}}]} as unknown as DocumentNode<OrderStateHistory_OrderFragmentFragment, unknown>;
export const OrderDetails_AddressFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderDetails_AddressFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"ic"}},{"kind":"Field","name":{"kind":"Name","value":"dic"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"branchId"}}]}}]} as unknown as DocumentNode<OrderDetails_AddressFragmentFragment, unknown>;
export const OrderDetailsInfo_OrderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderDetailsInfo_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDetails_AddressFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"privateNote"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isPaid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sent"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tariff"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"dimensionX"}},{"kind":"Field","name":{"kind":"Name","value":"dimensionY"}},{"kind":"Field","name":{"kind":"Name","value":"dimensionZ"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderDetails_AddressFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"ic"}},{"kind":"Field","name":{"kind":"Name","value":"dic"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"branchId"}}]}}]} as unknown as DocumentNode<OrderDetailsInfo_OrderFragmentFragment, unknown>;
export const OrderFiles_OrderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderFiles_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"originalFilename"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reservationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceUrl"}},{"kind":"Field","name":{"kind":"Name","value":"movePacks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pdfWOPricesUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"originalFilename"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagComponent_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<OrderFiles_OrderFragmentFragment, unknown>;
export const OrderHeader_OrderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderHeader_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reservationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isPaid"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"privateNote"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isFragile"}},{"kind":"Field","name":{"kind":"Name","value":"isOversize"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagComponent_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<OrderHeader_OrderFragmentFragment, unknown>;
export const UseOrderPicking_OrderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UseOrderPicking_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"picked"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<UseOrderPicking_OrderFragmentFragment, unknown>;
export const OrderListItem_OrderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderListItem_Order"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reservationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"isPaid"}},{"kind":"Field","name":{"kind":"Name","value":"quantityUnavailable"}},{"kind":"Field","name":{"kind":"Name","value":"boxes"}},{"kind":"Field","name":{"kind":"Name","value":"dateExpedition"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"privateNote"}},{"kind":"Field","name":{"kind":"Name","value":"depots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"processStatusUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isFragile"}},{"kind":"Field","name":{"kind":"Name","value":"isOversize"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagComponent_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<OrderListItem_OrderFragment, unknown>;
export const OrderDetail_OrderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderDetail_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditExpeditionBatchPositionModal_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClearanceItemsInTable_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PickingCheckboxCell_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderReturns_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderProducts_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderItemsTable_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Footer_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PackingCheckboxCell_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierCurrencyPayment_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PackageDetail_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReturnAllModal_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditReturnItemModal_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderItemsInPackages_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderInfo_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderStateHistory_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDetailsInfo_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderFiles_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderHeader_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UseOrderPicking_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderListItem_Order"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditExpeditionBatchPositionModal_ClearanceItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClearanceItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"productDepots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"quantityAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"quantityStock"}},{"kind":"Field","name":{"kind":"Name","value":"quantityReservation"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"position1"}},{"kind":"Field","name":{"kind":"Name","value":"position2"}},{"kind":"Field","name":{"kind":"Name","value":"position3"}},{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"productDepots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"position1"}},{"kind":"Field","name":{"kind":"Name","value":"position2"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagComponent_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCell_ProductFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isFragile"}},{"kind":"Field","name":{"kind":"Name","value":"isOversize"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditReturnItemModal_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isBundle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"moves"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"productDepotFrom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"position1"}},{"kind":"Field","name":{"kind":"Name","value":"position2"}},{"kind":"Field","name":{"kind":"Name","value":"position3"}},{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderReturnsTable_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"Field","name":{"kind":"Name","value":"bundleChildren"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"child"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditReturnItemModal_OrderItemFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditOrderItemModal_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderItemsTable_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantityUnavailable"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"isBundle"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"bundleChildren"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"child"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"picked"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditOrderItemModal_OrderItemFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReturnAllModal_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productDepots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderInfo_CheckoutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderDetails_AddressFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"ic"}},{"kind":"Field","name":{"kind":"Name","value":"dic"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"branchId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditExpeditionBatchPositionModal_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditExpeditionBatchPositionModal_ClearanceItemFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClearanceItemsInTable_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"picked"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditExpeditionBatchPositionModal_ClearanceItemFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PickingCheckboxCell_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"picked"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderReturns_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reservationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"returnsDepot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"depots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"requiredSerialNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"position1"}},{"kind":"Field","name":{"kind":"Name","value":"position2"}},{"kind":"Field","name":{"kind":"Name","value":"position3"}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"Field","name":{"kind":"Name","value":"requiredSerialNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productDepots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderReturnsTable_OrderItemFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderProducts_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"boxes"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderItemsTable_OrderItemFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderItemsTable_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Footer_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processStatusRelations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"requiredShippingAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"picked"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sent"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticketUrl"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"tariffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"movePacks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pdfWOPricesUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reservationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceUrl"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PackingCheckboxCell_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierCurrencyPayment_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"isPaid"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PackageDetail_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"requiredShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"tariffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticketUrl"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"sent"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tariffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReturnAllModal_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReturnAllModal_OrderItemFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditReturnItemModal_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderItemsInPackages_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tariffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderItemsTable_OrderItemFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"sent"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tariffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tariff"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"dimensionX"}},{"kind":"Field","name":{"kind":"Name","value":"dimensionY"}},{"kind":"Field","name":{"kind":"Name","value":"dimensionZ"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderInfo_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reservationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"billNumber"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"dateExpedition"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderInfo_CheckoutFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderStateHistory_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processStatusRelations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderDetailsInfo_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDetails_AddressFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"privateNote"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isPaid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sent"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tariff"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"dimensionX"}},{"kind":"Field","name":{"kind":"Name","value":"dimensionY"}},{"kind":"Field","name":{"kind":"Name","value":"dimensionZ"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderFiles_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"originalFilename"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reservationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceUrl"}},{"kind":"Field","name":{"kind":"Name","value":"movePacks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pdfWOPricesUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"originalFilename"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderHeader_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reservationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isPaid"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"privateNote"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isFragile"}},{"kind":"Field","name":{"kind":"Name","value":"isOversize"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UseOrderPicking_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"picked"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderListItem_Order"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reservationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"isPaid"}},{"kind":"Field","name":{"kind":"Name","value":"quantityUnavailable"}},{"kind":"Field","name":{"kind":"Name","value":"boxes"}},{"kind":"Field","name":{"kind":"Name","value":"dateExpedition"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"privateNote"}},{"kind":"Field","name":{"kind":"Name","value":"depots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"processStatusUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isFragile"}},{"kind":"Field","name":{"kind":"Name","value":"isOversize"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<OrderDetail_OrderFragmentFragment, unknown>;
export const ActiveReturnsTable_DepotFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActiveReturnsTable_DepotFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Depot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<ActiveReturnsTable_DepotFragmentFragment, unknown>;
export const CompletedReturnsTable_ProductMoveFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompletedReturnsTable_ProductMoveFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMove"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"productDepotTo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CompletedReturnsTable_ProductMoveFragmentFragment, unknown>;
export const CompletedReturnsTable_ProductMovePackFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompletedReturnsTable_ProductMovePackFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMovePack"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"moves"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompletedReturnsTable_ProductMoveFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompletedReturnsTable_ProductMoveFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMove"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"productDepotTo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CompletedReturnsTable_ProductMovePackFragmentFragment, unknown>;
export const GroupClearanceItems_OrderGroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupClearanceItems_OrderGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagComponent_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCell_ProductFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isFragile"}},{"kind":"Field","name":{"kind":"Name","value":"isOversize"}}]}}]} as unknown as DocumentNode<GroupClearanceItems_OrderGroupFragment, unknown>;
export const GroupOrdersTables_OrderGroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupOrdersTables_OrderGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reservationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GroupOrdersTables_OrderGroupFragment, unknown>;
export const GroupOrders_OrderGroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupOrders_OrderGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reservationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderListItem_Order"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagComponent_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderListItem_Order"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reservationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"isPaid"}},{"kind":"Field","name":{"kind":"Name","value":"quantityUnavailable"}},{"kind":"Field","name":{"kind":"Name","value":"boxes"}},{"kind":"Field","name":{"kind":"Name","value":"dateExpedition"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"privateNote"}},{"kind":"Field","name":{"kind":"Name","value":"depots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"processStatusUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isFragile"}},{"kind":"Field","name":{"kind":"Name","value":"isOversize"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GroupOrders_OrderGroupFragment, unknown>;
export const Header_OrderGroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Header_OrderGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagComponent_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<Header_OrderGroupFragment, unknown>;
export const SubmitAllOrders_OrderGroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubmitAllOrders_OrderGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<SubmitAllOrders_OrderGroupFragment, unknown>;
export const CreateFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"base64Data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"originalFilename"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mimeType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"base64Data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"base64Data"}}},{"kind":"Argument","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}},{"kind":"Argument","name":{"kind":"Name","value":"originalFilename"},"value":{"kind":"Variable","name":{"kind":"Name","value":"originalFilename"}}},{"kind":"Argument","name":{"kind":"Name","value":"mimeType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mimeType"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"originalFilename"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<CreateFileMutation, CreateFileMutationVariables>;
export const DeleteFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<DeleteFileMutation, DeleteFileMutationVariables>;
export const OrdersListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrdersList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"orderFilters"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"direction"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"direction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"direction"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderListItem_Order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paginator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"endPage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagComponent_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderListItem_Order"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reservationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"isPaid"}},{"kind":"Field","name":{"kind":"Name","value":"quantityUnavailable"}},{"kind":"Field","name":{"kind":"Name","value":"boxes"}},{"kind":"Field","name":{"kind":"Name","value":"dateExpedition"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"privateNote"}},{"kind":"Field","name":{"kind":"Name","value":"depots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"processStatusUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isFragile"}},{"kind":"Field","name":{"kind":"Name","value":"isOversize"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<OrdersListQuery, OrdersListQueryVariables>;
export const OrderHistoryItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderHistoryItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderListItem_Order"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagComponent_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderListItem_Order"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reservationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"isPaid"}},{"kind":"Field","name":{"kind":"Name","value":"quantityUnavailable"}},{"kind":"Field","name":{"kind":"Name","value":"boxes"}},{"kind":"Field","name":{"kind":"Name","value":"dateExpedition"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"privateNote"}},{"kind":"Field","name":{"kind":"Name","value":"depots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"processStatusUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isFragile"}},{"kind":"Field","name":{"kind":"Name","value":"isOversize"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<OrderHistoryItemQuery, OrderHistoryItemQueryVariables>;
export const BasicEntitiesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BasicEntitiesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicEntities_TagFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"depots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicEntities_DepotFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"carriers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicEntities_CarrierFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkouts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicEntities_CheckoutFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicEntities_CurrencyFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicEntities_PaymentFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagComponent_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicEntities_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicEntities_DepotFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Depot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicEntities_CarrierFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Carrier"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicEntities_CheckoutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicEntities_CurrencyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Currency"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicEntities_PaymentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Payment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<BasicEntitiesQueryQuery, BasicEntitiesQueryQueryVariables>;
export const CreateDisposalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDisposal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"company"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"carrier"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"packages"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDisposal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"company"},"value":{"kind":"Variable","name":{"kind":"Name","value":"company"}}},{"kind":"Argument","name":{"kind":"Name","value":"carrier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"carrier"}}},{"kind":"Argument","name":{"kind":"Name","value":"packages"},"value":{"kind":"Variable","name":{"kind":"Name","value":"packages"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<CreateDisposalMutation, CreateDisposalMutationVariables>;
export const SendDisposalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendDisposal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendDisposal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<SendDisposalMutation, SendDisposalMutationVariables>;
export const PackagesForDisposalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PackagesForDisposal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"packageFilters"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"direction"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"direction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"direction"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisposalCreateTable_PackageFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paginator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"endPage"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisposalCreateTable_PackageFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Package"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]} as unknown as DocumentNode<PackagesForDisposalQuery, PackagesForDisposalQueryVariables>;
export const DisposalsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DisposalsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"disposalFilters"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"direction"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disposals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"direction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"direction"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DisposalTable_DisposalFragment"}},{"kind":"Field","name":{"kind":"Name","value":"sent"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paginator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"endPage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DisposalTable_DisposalFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PackageDisposal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ticketUrl"}},{"kind":"Field","name":{"kind":"Name","value":"sent"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DisposalsListQuery, DisposalsListQueryVariables>;
export const GroupsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GroupsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"orderGroupFilters"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"direction"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"direction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"direction"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupListItem_OrderGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paginator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"endPage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagComponent_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupListItem_OrderGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"ordersCount"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}}]}}]} as unknown as DocumentNode<GroupsListQuery, GroupsListQueryVariables>;
export const OrderDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDetail_OrderFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditExpeditionBatchPositionModal_ClearanceItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClearanceItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"productDepots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"quantityAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"quantityStock"}},{"kind":"Field","name":{"kind":"Name","value":"quantityReservation"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"position1"}},{"kind":"Field","name":{"kind":"Name","value":"position2"}},{"kind":"Field","name":{"kind":"Name","value":"position3"}},{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"productDepots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"position1"}},{"kind":"Field","name":{"kind":"Name","value":"position2"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditExpeditionBatchPositionModal_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditExpeditionBatchPositionModal_ClearanceItemFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagComponent_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCell_ProductFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isFragile"}},{"kind":"Field","name":{"kind":"Name","value":"isOversize"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClearanceItemsInTable_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"picked"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditExpeditionBatchPositionModal_ClearanceItemFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PickingCheckboxCell_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"picked"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditReturnItemModal_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isBundle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"moves"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"productDepotFrom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"position1"}},{"kind":"Field","name":{"kind":"Name","value":"position2"}},{"kind":"Field","name":{"kind":"Name","value":"position3"}},{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderReturnsTable_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"Field","name":{"kind":"Name","value":"bundleChildren"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"child"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditReturnItemModal_OrderItemFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderReturns_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reservationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"returnsDepot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"depots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"requiredSerialNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"position1"}},{"kind":"Field","name":{"kind":"Name","value":"position2"}},{"kind":"Field","name":{"kind":"Name","value":"position3"}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"Field","name":{"kind":"Name","value":"requiredSerialNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productDepots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderReturnsTable_OrderItemFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditOrderItemModal_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderItemsTable_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantityUnavailable"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"isBundle"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"bundleChildren"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"child"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"picked"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditOrderItemModal_OrderItemFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderProducts_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"boxes"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderItemsTable_OrderItemFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderItemsTable_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Footer_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processStatusRelations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"requiredShippingAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"picked"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sent"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticketUrl"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"tariffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"movePacks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pdfWOPricesUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reservationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceUrl"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PackingCheckboxCell_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierCurrencyPayment_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"isPaid"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PackageDetail_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"requiredShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"tariffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticketUrl"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"sent"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tariffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReturnAllModal_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productDepots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReturnAllModal_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReturnAllModal_OrderItemFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditReturnItemModal_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderItemsInPackages_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tariffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderItemsTable_OrderItemFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"sent"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tariffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tariff"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"dimensionX"}},{"kind":"Field","name":{"kind":"Name","value":"dimensionY"}},{"kind":"Field","name":{"kind":"Name","value":"dimensionZ"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderInfo_CheckoutFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderInfo_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reservationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"billNumber"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"dateExpedition"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderInfo_CheckoutFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderStateHistory_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processStatusRelations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderDetails_AddressFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"ic"}},{"kind":"Field","name":{"kind":"Name","value":"dic"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"branchId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderDetailsInfo_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDetails_AddressFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"privateNote"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isPaid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sent"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tariff"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"dimensionX"}},{"kind":"Field","name":{"kind":"Name","value":"dimensionY"}},{"kind":"Field","name":{"kind":"Name","value":"dimensionZ"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderFiles_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"originalFilename"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reservationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceUrl"}},{"kind":"Field","name":{"kind":"Name","value":"movePacks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pdfWOPricesUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"originalFilename"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderHeader_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reservationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isPaid"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"privateNote"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isFragile"}},{"kind":"Field","name":{"kind":"Name","value":"isOversize"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UseOrderPicking_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"picked"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderListItem_Order"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reservationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"isPaid"}},{"kind":"Field","name":{"kind":"Name","value":"quantityUnavailable"}},{"kind":"Field","name":{"kind":"Name","value":"boxes"}},{"kind":"Field","name":{"kind":"Name","value":"dateExpedition"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"privateNote"}},{"kind":"Field","name":{"kind":"Name","value":"depots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"processStatusUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isFragile"}},{"kind":"Field","name":{"kind":"Name","value":"isOversize"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderDetail_OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditExpeditionBatchPositionModal_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClearanceItemsInTable_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PickingCheckboxCell_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderReturns_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderProducts_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderItemsTable_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Footer_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PackingCheckboxCell_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierCurrencyPayment_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PackageDetail_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReturnAllModal_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditReturnItemModal_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderItemsInPackages_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderInfo_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderStateHistory_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDetailsInfo_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderFiles_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderHeader_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UseOrderPicking_OrderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderListItem_Order"}}]}}]} as unknown as DocumentNode<OrderDetailQuery, OrderDetailQueryVariables>;
export const ResetPackageFromOrderInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetPackageFromOrderInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetPackage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<ResetPackageFromOrderInfoMutation, ResetPackageFromOrderInfoMutationVariables>;
export const UpdateOrderMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrderMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"carrier"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shippingAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentItems"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"updatePaymentItem_"}}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"privateNote"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tags"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"carrier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"carrier"}}},{"kind":"Argument","name":{"kind":"Name","value":"shippingAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shippingAddress"}}},{"kind":"Argument","name":{"kind":"Name","value":"paymentItems"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentItems"}}},{"kind":"Argument","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}},{"kind":"Argument","name":{"kind":"Name","value":"privateNote"},"value":{"kind":"Variable","name":{"kind":"Name","value":"privateNote"}}},{"kind":"Argument","name":{"kind":"Name","value":"tags"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tags"}}},{"kind":"Argument","name":{"kind":"Name","value":"currency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPaid"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPaid"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDetails_AddressFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"requiredShippingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"tariffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"privateNote"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderDetails_AddressFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"ic"}},{"kind":"Field","name":{"kind":"Name","value":"dic"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"branchId"}}]}}]} as unknown as DocumentNode<UpdateOrderMutationMutation, UpdateOrderMutationMutationVariables>;
export const UpdateAddressMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAddressMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"street"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ic"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dic"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"branchId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}},{"kind":"Argument","name":{"kind":"Name","value":"street"},"value":{"kind":"Variable","name":{"kind":"Name","value":"street"}}},{"kind":"Argument","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"Argument","name":{"kind":"Name","value":"zip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zip"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"ic"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ic"}}},{"kind":"Argument","name":{"kind":"Name","value":"dic"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dic"}}},{"kind":"Argument","name":{"kind":"Name","value":"branchId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"branchId"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDetails_AddressFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderDetails_AddressFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"ic"}},{"kind":"Field","name":{"kind":"Name","value":"dic"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"branchId"}}]}}]} as unknown as DocumentNode<UpdateAddressMutationMutation, UpdateAddressMutationMutationVariables>;
export const CreateAddressMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAddressMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"street"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ic"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dic"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"branchId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"NullValue"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}},{"kind":"Argument","name":{"kind":"Name","value":"street"},"value":{"kind":"Variable","name":{"kind":"Name","value":"street"}}},{"kind":"Argument","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"Argument","name":{"kind":"Name","value":"zip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zip"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"ic"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ic"}}},{"kind":"Argument","name":{"kind":"Name","value":"dic"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dic"}}},{"kind":"Argument","name":{"kind":"Name","value":"branchId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"branchId"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDetails_AddressFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderDetails_AddressFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"ic"}},{"kind":"Field","name":{"kind":"Name","value":"dic"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"branchId"}}]}}]} as unknown as DocumentNode<CreateAddressMutationMutation, CreateAddressMutationMutationVariables>;
export const UpdateClearanceItemBulkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateClearanceItemBulk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"picked"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"packed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateClearanceItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"picked"},"value":{"kind":"Variable","name":{"kind":"Name","value":"picked"}}},{"kind":"Argument","name":{"kind":"Name","value":"packed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"packed"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"picked"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateClearanceItemBulkMutation, UpdateClearanceItemBulkMutationVariables>;
export const UpdateOrder_OrderProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrder_OrderProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boxes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"boxes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boxes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"boxes"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOrder_OrderProductsMutation, UpdateOrder_OrderProductsMutationVariables>;
export const CreateOrderFileFromCameraInProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrderFileFromCameraInProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"base64Data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"originalFilename"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mimeType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"base64Data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"base64Data"}}},{"kind":"Argument","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}},{"kind":"Argument","name":{"kind":"Name","value":"originalFilename"},"value":{"kind":"Variable","name":{"kind":"Name","value":"originalFilename"}}},{"kind":"Argument","name":{"kind":"Name","value":"mimeType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mimeType"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<CreateOrderFileFromCameraInProductsMutation, CreateOrderFileFromCameraInProductsMutationVariables>;
export const GetProductMovePacksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductMovePacks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productMovePacks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"in","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"moves"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serialNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"orderItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompletedReturnsTable_ProductMovePackFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompletedReturnsTable_ProductMoveFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMove"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"productDepotTo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"depot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompletedReturnsTable_ProductMovePackFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductMovePack"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"moves"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompletedReturnsTable_ProductMoveFragment"}}]}}]}}]} as unknown as DocumentNode<GetProductMovePacksQuery, GetProductMovePacksQueryVariables>;
export const DeletePaymentItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePaymentItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePaymentItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<DeletePaymentItemMutation, DeletePaymentItemMutationVariables>;
export const UpdateClearanceItemLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateClearanceItemLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"updateClearanceItemLocations"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateClearanceItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"locations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locations"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateClearanceItemLocationsMutation, UpdateClearanceItemLocationsMutationVariables>;
export const UpdateOrderItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrderItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrderItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}},{"kind":"Argument","name":{"kind":"Name","value":"quantity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditOrderItemModal_OrderItemFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderItemsTable_OrderItemFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagComponent_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCell_ProductFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isFragile"}},{"kind":"Field","name":{"kind":"Name","value":"isOversize"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditOrderItemModal_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderItemsTable_OrderItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"quantityUnavailable"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"isBundle"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"bundleChildren"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"child"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"ean2"}},{"kind":"Field","name":{"kind":"Name","value":"ean3"}},{"kind":"Field","name":{"kind":"Name","value":"ean4"}},{"kind":"Field","name":{"kind":"Name","value":"ean5"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"picked"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditOrderItemModal_OrderItemFragment"}}]}}]} as unknown as DocumentNode<UpdateOrderItemMutation, UpdateOrderItemMutationVariables>;
export const DeleteOrderItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOrderItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOrderItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<DeleteOrderItemMutation, DeleteOrderItemMutationVariables>;
export const CreateNewPackageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateNewPackage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"items"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tariff"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"weight"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"carrier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dimensionX"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dimensionY"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dimensionZ"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPackage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"items"},"value":{"kind":"Variable","name":{"kind":"Name","value":"items"}}},{"kind":"Argument","name":{"kind":"Name","value":"tariff"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tariff"}}},{"kind":"Argument","name":{"kind":"Name","value":"weight"},"value":{"kind":"Variable","name":{"kind":"Name","value":"weight"}}},{"kind":"Argument","name":{"kind":"Name","value":"carrier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"carrier"}}},{"kind":"Argument","name":{"kind":"Name","value":"dimensionX"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dimensionX"}}},{"kind":"Argument","name":{"kind":"Name","value":"dimensionY"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dimensionY"}}},{"kind":"Argument","name":{"kind":"Name","value":"dimensionZ"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dimensionZ"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"sent"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tariffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tariff"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"dimensionX"}},{"kind":"Field","name":{"kind":"Name","value":"dimensionY"}},{"kind":"Field","name":{"kind":"Name","value":"dimensionZ"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateNewPackageMutation, CreateNewPackageMutationVariables>;
export const DeletePackageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePackage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePackage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<DeletePackageMutation, DeletePackageMutationVariables>;
export const UpdatePackageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePackage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"items"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tariff"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"weight"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dimensionX"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dimensionY"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}},"defaultValue":{"kind":"NullValue"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dimensionZ"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}},"defaultValue":{"kind":"NullValue"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePackage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"items"},"value":{"kind":"Variable","name":{"kind":"Name","value":"items"}}},{"kind":"Argument","name":{"kind":"Name","value":"tariff"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tariff"}}},{"kind":"Argument","name":{"kind":"Name","value":"weight"},"value":{"kind":"Variable","name":{"kind":"Name","value":"weight"}}},{"kind":"Argument","name":{"kind":"Name","value":"dimensionX"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dimensionX"}}},{"kind":"Argument","name":{"kind":"Name","value":"dimensionY"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dimensionY"}}},{"kind":"Argument","name":{"kind":"Name","value":"dimensionZ"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dimensionZ"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"sent"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tariffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tariff"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"dimensionX"}},{"kind":"Field","name":{"kind":"Name","value":"dimensionY"}},{"kind":"Field","name":{"kind":"Name","value":"dimensionZ"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePackageMutation, UpdatePackageMutationVariables>;
export const ResetPackageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetPackage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetPackage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<ResetPackageMutation, ResetPackageMutationVariables>;
export const SendPackageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendPackage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendPackage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<SendPackageMutation, SendPackageMutationVariables>;
export const UpdateOrderItemPackingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrderItemPacking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"packed"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrderItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"packed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"packed"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateOrderItemPackingMutation, UpdateOrderItemPackingMutationVariables>;
export const UpdateClearanceItemPackingResetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateClearanceItemPackingReset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"packed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateClearanceItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"packed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"packed"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateClearanceItemPackingResetMutation, UpdateClearanceItemPackingResetMutationVariables>;
export const UpdateClearanceItemPickingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateClearanceItemPicking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"picked"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"packed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateClearanceItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"picked"},"value":{"kind":"Variable","name":{"kind":"Name","value":"picked"}}},{"kind":"Argument","name":{"kind":"Name","value":"packed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"packed"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"picked"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateClearanceItemPickingMutation, UpdateClearanceItemPickingMutationVariables>;
export const UpdateClearanceItemPickingHookDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateClearanceItemPickingHook"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"picked"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"packed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateClearanceItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"picked"},"value":{"kind":"Variable","name":{"kind":"Name","value":"picked"}}},{"kind":"Argument","name":{"kind":"Name","value":"packed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"packed"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"picked"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateClearanceItemPickingHookMutation, UpdateClearanceItemPickingHookMutationVariables>;
export const UpdateOrderItemsPickingHookDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrderItemsPickingHook"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"picked"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"packed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrderItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"picked"},"value":{"kind":"Variable","name":{"kind":"Name","value":"picked"}}},{"kind":"Argument","name":{"kind":"Name","value":"packed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"packed"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"picked"}},{"kind":"Field","name":{"kind":"Name","value":"packed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateOrderItemsPickingHookMutation, UpdateOrderItemsPickingHookMutationVariables>;
export const UpdateOrderProcessStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrderProcessStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"processStatusRelation"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateOrderProcessStatusMutation, UpdateOrderProcessStatusMutationVariables>;
export const SendPackageMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendPackageMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendPackage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticketUrl"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SendPackageMutationMutation, SendPackageMutationMutationVariables>;
export const CreateProductMovePackReturnDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProductMovePackReturn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"moves"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"createProductMove"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProductMovePack"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"moves"},"value":{"kind":"Variable","name":{"kind":"Name","value":"moves"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<CreateProductMovePackReturnMutation, CreateProductMovePackReturnMutationVariables>;
export const UpdateOrderProcessStatusForReturnsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrderProcessStatusForReturns"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"processStatusRelation"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateOrderProcessStatusForReturnsMutation, UpdateOrderProcessStatusForReturnsMutationVariables>;
export const OrderGroupDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderGroupDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Header_OrderGroup"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupOrders_OrderGroup"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupClearanceItems_OrderGroup"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubmitAllOrders_OrderGroup"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TagComponent_TagFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderListItem_Order"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reservationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"isPaid"}},{"kind":"Field","name":{"kind":"Name","value":"quantityUnavailable"}},{"kind":"Field","name":{"kind":"Name","value":"boxes"}},{"kind":"Field","name":{"kind":"Name","value":"dateExpedition"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"privateNote"}},{"kind":"Field","name":{"kind":"Name","value":"depots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"processStatusUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isFragile"}},{"kind":"Field","name":{"kind":"Name","value":"isOversize"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductCell_ProductFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isFragile"}},{"kind":"Field","name":{"kind":"Name","value":"isOversize"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Header_OrderGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TagComponent_TagFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupOrders_OrderGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reservationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderListItem_Order"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupClearanceItems_OrderGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"batch"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCell_ProductFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubmitAllOrders_OrderGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clearanceItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<OrderGroupDetailQuery, OrderGroupDetailQueryVariables>;
export const SubmitOrderMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitOrderMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"processStatusRelation"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<SubmitOrderMutationMutation, SubmitOrderMutationMutationVariables>;
export const CreatePackageForGroupOrderMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePackageForGroupOrderMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"items"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"carrier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPackage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"items"},"value":{"kind":"Variable","name":{"kind":"Name","value":"items"}}},{"kind":"Argument","name":{"kind":"Name","value":"carrier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"carrier"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreatePackageForGroupOrderMutationMutation, CreatePackageForGroupOrderMutationMutationVariables>;
export const SendPackageForGroupOrderMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendPackageForGroupOrderMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendPackage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticketUrl"}},{"kind":"Field","name":{"kind":"Name","value":"carrier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SendPackageForGroupOrderMutationMutation, SendPackageForGroupOrderMutationMutationVariables>;